<template>
	<transition name="el-fade-in-linear">
    <div v-show="transitionshow">      

   		<!------------------------Order search start (提成搜索开始)---------------------->
		<el-form :inline="true" class="backborder1 demo-form-inline" size="small" filterable clearable>			
			<el-form-item style="width:8%">
				<el-select v-model="query.type" @change="ischange=true">
					<el-option v-for="(item,index) in searchlists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="width:20%">
				<el-date-picker	v-model="query.date" type="daterange" style="width:100%"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd" :unlink-panels="false" @change="ischange=true">
				</el-date-picker>
			</el-form-item>
			<el-form-item style="width:8%">
				<el-select v-model="query.ispay" placeholder="是否支付" clearable @change="ischange=true">
					<el-option v-for="(item,index) in ispaylists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="width:8%">
				<el-select v-model="query.paytype" placeholder="支付方式" clearable @change="ischange=true">
					<el-option v-for="(item,index) in paytype" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="width:11%">
				<el-select v-model="query.status" placeholder="订单状态" filterable clearable @change="ischange=true">
						<el-option v-for="(item,index) in orderstatus" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="width:10%" v-if="datacenter=='cz'">
				<el-select v-model="query.clerkid" placeholder="请选择销售员" clearable filterable>
					<el-option v-for="(item,index) in sellerLists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="width:15%" v-if="datacenter=='cz'">
				<el-select v-model="query.ordersourse" clearable placeholder="请选择订单渠道来源" filterable>
					<el-option v-for="(item,index) in ordersourselists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item style="width:12%">
				<el-select v-model="query.mark_status" clearable placeholder="请选择标签" filterable>
					<el-option label="补货中" value="1"></el-option>
					<el-option label="可发货" value="2"></el-option>
				</el-select>
			</el-form-item>
			

			<el-form-item style="width:15%"  v-if="$cookies.get('agentid')==1 || $cookies.get('agentid')==47 || $cookies.get('agentid')==36">
				<el-select v-model="query.searchtype" placeholder="请选择关键字搜索类型" filterable>
					<el-option v-for="(item,index) in searchtype" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item ref="query.key" :model="query">
				<el-input placeholder="请输入订单号 / 客户名称 / 收货人姓名 / 收货人电话" v-model="query.key" clearable @change="ischange=true" style="width:100%" @keyup.enter.native="searchorder"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="searchorder">搜索</el-button>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="warning" icon="el-icon-phone-outline" @click="pushsetting">通知设置</el-button>
			</el-form-item>
			<!-- 导出订单信息 -->
			<el-form-item>
				<el-dropdown @command="sumTypeCkeck">
					<el-button icon="el-icon-download" size="small" type="success">导出</el-button>
					<el-dropdown-menu slot="dropdown">							
						<el-dropdown-item  command="1" key="1" >导出订单列表</el-dropdown-item>
						<el-dropdown-item  command="2" key="2" >导出订单明细</el-dropdown-item>
						<el-dropdown-item  command="3" key="3" >导出订单明细（财务）</el-dropdown-item>
						<el-dropdown-item  command="4" key="4" v-if="iskingdee==1" >导出金蝶销售单模板数据</el-dropdown-item>
						<el-dropdown-item  command="5" key="5" >导入订单快递信息</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-form-item>
			<el-form-item>
				<el-badge :value="delgoodslists.length > 0 ? delgoodslists.length : ''" class="item">
				<el-dropdown @command="handleordermore">
					<el-button size="small" type="warning">批处理订单</el-button>
					<el-dropdown-menu slot="dropdown">							
						<el-dropdown-item  command="1" key="1" >批量删除订单</el-dropdown-item>
						<el-dropdown-item  command="2" key="2" >批量发货</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				</el-badge>
			</el-form-item>
			<el-form-item>
				<el-badge :value="delgoodslists.length > 0 ? delgoodslists.length : ''" class="item">
				<el-button type="" size="small" round @click="clearorderselect">清空已选中订单</el-button>
				</el-badge>
			</el-form-item>
			<el-form-item>
				<el-badge :value="specialordernums > 0 ? specialordernums : ''" class="item">
				<el-button type="warning" size="small" round @click="verifyspecialorder">审核特批单</el-button>
				</el-badge>
			</el-form-item>
		</el-form>
		<!------------------------Order search end (提成搜索结束)------------------------>

		<!-- 订单发货提示 -->
		<div class="cz-mall-order-verifys-infos" v-if="isshowsysorder1"><i></i><span>温馨提示：每日0点，系统将超过 7 天订单状态为：已发货，待签收的订单自动设置为：已签收，待完成（即超时系统自动确认收货）</span></div>
		<div class="cz-mall-order-verifys-infos" v-if="isshowsysorder2"><i></i><span>温馨提示：每日1点，系统将超过 1 天订单状态为：已签收，待完成的订单自动设置为：已完成（即超时系统自动完成）</span></div>

		<!--- 京东预存款 -->
		<div style="margin-top:10px;border-radius:5px;padding:.7rem 1% .7rem 1%;background:rgb(211,211,211,.6)" v-if="jdmoneys.money > 0 && jdmoneys.money!=''">
			<span v-if="jdmoneys.status==0"><em style="padding:.2rem .3rem;color:#fff;background:red;font-style:normal;color:#fff;font-size:.7rem;font-weight:bold;border-radius:50%">JD</em><i style="font-style:normal;color:#E6A23C;margin-left:1%;font-size:1rem;font-weight:bold">￥{{jdmoneys.money}}</i><i style="font-style:normal;margin-left:3px;normal;font-size:.7rem;color:rgb(144, 147, 153)">（京东预存款）</i></span>
			<span v-if="jdmoneys.status==1"><em style="padding:.2rem .3rem;color:#fff;background:red;font-style:normal;color:#fff;font-size:.7rem;font-weight:bold;border-radius:50%">JD</em><i style="font-style:normal;color:red;margin-left:1%;font-size:1rem;font-weight:bold">￥{{jdmoneys.money}}</i><i style="font-style:normal;margin-left:3px;normal;font-size:.7rem;color:red">（京东预存款预警：预存款不足，请及时充值）</i></span>
			<span style="margin-left:2%;font-size:.7rem;color:red;">温馨提示：商城已发货的订单，如若买家没有点击签收，那么在<em style="font-size:1rem;font-style:normal;font-weight:bold"> {{showdays}} </em>个工作日后系统将会自动将其编辑为客户已签收</span>
		</div>

		<!-- 订单发货时默认生成销售出库单的状态 -->
		<div style="margin-top:10px;display:inline-block;width:100%" v-if="datacenter=='cz'">
			<div style="display:inline-block">
				<span style="font-size:13px;font-weight:500;color:#333333">生成销售出库单状态</span>
				<el-select v-model="sendsellstatus" size="small" style="width:40%" @change="changedefaultsellstatus">
					<el-option v-for="(item,index) in sellstatuslists" :label="item.name" :value="item.id" :key="index"></el-option>
				</el-select>
				<el-tooltip class="item" effect="dark" content="此操作用于决定订单发货时生成的销售出库单的状态是未审核还是已审核" placement="top">
				<span style="font-size:12px;line-height:12px;border-radius:50%;font-weight:500;color:#333333;padding:2px 6px;background:#ebb563">?</span>
				</el-tooltip>
			</div>
		</div>

		<!------------------------Order lists start (提成列表结束)------------------------>
		<div class="backborder2" style="margin-top:20px">
			<el-table :data="orderlists" style="width:100%" v-loading="orderLoading" ref="goodsmultipleTable" @select="goodsselectchange" @select-all="goodsallselectchange">
				<el-table-column type="expand">
				<template slot-scope="props">
				    <div class="cz-mall-order-addressinfo">	
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==1">支付方式：支付宝</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==7">支付方式：微信</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==8">支付方式：银联</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==5">支付方式：透支</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==9">支付方式：线下支付</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==11">支付方式：小也白条</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==20">支付方式：汇付天下-支付宝</span>
						<span class="cz-mall-order-paytype" v-if="props.row.paytype==21">支付方式：汇付天下-微信</span>
						<span v-if="props.row.note">订单备注：{{props.row.note}}</span><span v-if="props.row.order_number" style="margin-left:15px;">订单号：{{props.row.order_number}}</span>  <br/>
						<span style="margin-right:2%">收货人信息：{{props.row.truename}}，{{props.row.phone}}，{{props.row.province}}-{{props.row.city}}-{{props.row.town}}-{{props.row.country}}，{{props.row.address}}</span>

						<!-- 支付记录 
			            <el-button type="warning" v-if="props.row.ispay==1" size="mini" @click="checkpaylogs(props.row)" round>查看支付记录</el-button>
						-->

						<!-- 宠赞数据中心查看包裹 -->
						<el-button type="primary" size="mini" @click="getpacks(props.row.id)" round v-if="datacenter=='cz'">查看出库单</el-button>
						<!-- 非宠赞数据中心查看包裹 -->
						<el-button type="primary" size="mini" @click="getpackshippings(props.row.id)" round >查看物流信息</el-button>

						<!-- 销售订单同步至金蝶 -->
						<el-tooltip class="item" effect="dark" content="将订单数据提交至管易云的销售订单" placement="top" v-if="iskingdee==1">
						<el-button :type="props.row.kingdeesubmit==1 ? 'success' : 'primary'" size="mini" :icon="props.row.kingdeesubmit==1 ? 'el-icon-check' : 'el-icon-setting'" @click="synkingdee(props.row.id)" round>{{props.row.kingdeesubmit==1 ? '订单已同步' : '同步订单' }}</el-button>
						</el-tooltip>

						<!-- 含有京东商品的订单同步采购单至金蝶 -->
						<el-tooltip class="item" effect="dark" content="将订单中的京东商品信息提交到金蝶生成采购单" placement="top" v-if="iskingdee==1">
						<el-button :type="props.row.jdkingdeesubmit==1 ? 'success' : 'primary'" size="mini" :icon="props.row.jdkingdeesubmit==1 ? 'el-icon-check' : 'el-icon-setting'" @click="jdsynkingdee(props.row.id)" round v-if="props.row.child_orderid > 0">{{props.row.jdkingdeesubmit==1 ? '采购单已同步' : '同步采购单' }}</el-button>
						</el-tooltip>

						<el-button type="warning" size="mini" @click="getlogs(props.row.id)" round v-if="props.row.updatelogs > 0">历史改单记录</el-button>
						<el-button type="warning" size="mini" icon="el-icon-document" @click="orderrefunds(props.row.id)" round>订单退款记录</el-button>						
			        </div>
	                <el-table :data="props.row.goods">
						<el-table-column label="Id / 编号" min-width="100" align="center">
							<template slot-scope="goods">
								<div style="float:left;width:100%">{{goods.row.id}}</div>
								<div style="float:left;width:100%;font-size:12px;color:#909399">（{{goods.row.sku}}）</div>
							</template>
						</el-table-column>
		                <el-table-column label="商品名称" min-width="350">
		                	<template slot-scope="goods">
								<div style="float:left;width:100%">
								<div style="float:left;width:60px;height:60px;position:relative;">
									<div class="cz-mall-order-goods-infos">
									<img :src="goods.row.thumb=='' ? require('../../assets/default_img_mini.png') : goods.row.thumb"  class="mall-order-info-goods-thumb"/>
									</div>
									<i class="cz-mall-order-goods-jd-icon" v-if="goods.row.type==2">JD</i>
									<i class="cz-mall-order-goods-song" v-if="goods.row.isgift==1">送</i>
								</div>
								<div style="float:left;width:calc(100% - 60px - 10px);margin-left:10px">
									<span class="cz-mall-order-goods-name">{{goods.row.productname}}</span>
									<span class="cz-mall-order-goods-active-detail" v-if="goods.row.active &&  goods.row.active!=''">{{goods.row.active}}</span>
									<span class="cz-mall-order-goods-active-news" v-if="goods.row.offersnew && goods.row.offersnew!=''">{{goods.row.offersnew}}</span>
									<span class="cz-mall-order-goods-active-change" v-if="goods.row.offerschange && goods.row.offerschange!=''">{{goods.row.offerschange}}</span>
								</div>
								</div>
							</template>
		                </el-table-column>
		                <el-table-column prop="numbers" label="数量" min-width="120" align="center">
							<template slot-scope="props">
								<div style="float:left;width:100%;font-size:14px;line-height:23px">{{props.row.numbers}}</div>
								<div style="float:left;width:100%;font-size:13px;line-height:23px;color:red" v-if="props.row.refundnumbers > 0">（已退：{{props.row.refundnumbers}}）</div>
							</template>
						</el-table-column>
						<el-table-column prop="price" label="单价" min-width="120" align="center"></el-table-column>
		                <el-table-column prop="basetotal" label="小计" min-width="120" align="center"></el-table-column>
						<el-table-column prop="derate" label="优惠" min-width="120" align="center"></el-table-column>
						<el-table-column prop="total" label="实际小计" min-width="120" align="center"></el-table-column>
						<!--
						<el-table-column prop="refundnumbers" label="退货数量" min-width="120" align="center"></el-table-column>
						-->
	                </el-table>
	            </template>
				</el-table-column>

				<el-table-column type="selection" width="50" align="center"></el-table-column>
				<el-table-column label="id" align="center" width="100">
					<template slot-scope="props">
						<div style="display:inline-block;width:100%;text-align:center;font-size:13px">{{props.row.id}}</div>
					</template>
				</el-table-column>
				<el-table-column label="订单信息" min-width="270">
					<template slot-scope="props">
					    <span class="cz-mall-order-number" style="display:flex;justify-content:left;align-items:center;">{{props.row.ordernumber}}

							<el-tooltip class="item" effect="dark" :content="query.type==1 ? '当前店铺第 '+props.row.nbs+' 次下单（按下单时间统计）' : '当前店铺第 '+props.row.nbs+' 次下单（按支付时间统计）' " placement="top">
							<i class="cz-mall-order-sort" style="margin-left:7px">{{props.row.nbs}}</i>
							</el-tooltip>
							<a class="cz-mall-order-yh" style="margin-left:7px" @click="showactives(props.row.active)" v-if="props.row.active!=''">惠</a>

							<!-- 支付宝支付，未支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：支付宝，未支付" placement="top" v-if="props.row.ispay==0 && props.row.paytype==1">
							<div v-if="props.row.ispay==0 && props.row.paytype==1" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/alipay_nopay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 微信支付，未支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：微信，未支付" placement="top" v-if="props.row.ispay==0 && props.row.paytype==7">
							<div v-if="props.row.ispay==0 && props.row.paytype==7" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/wechat_nopay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 汇付天下-支付宝支付，未支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：汇付天下-支付宝，未支付" placement="top" v-if="props.row.ispay==0 && props.row.paytype==20">
							<div v-if="props.row.ispay==0 && props.row.paytype==20" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/alipay_nopay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 汇付天下-微信支付，未支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：汇付天下-微信，未支付" placement="top" v-if="props.row.ispay==0 && props.row.paytype==21">
							<div v-if="props.row.ispay==0 && props.row.paytype==21" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/wechat_nopay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>


							<!-- 支付宝支付，已支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：支付宝，已支付" placement="top" v-if="props.row.ispay==1 && props.row.paytype==1">
							<div v-if="props.row.ispay==1 && props.row.paytype==1" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/alipay_pay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 微信支付，已支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：微信，已支付" placement="top" v-if="props.row.ispay==1 && props.row.paytype==7">
							<div v-if="props.row.ispay==1 && props.row.paytype==7" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/wechat_pay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 汇付天下-支付宝支付，已支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：汇付天下-支付宝，已支付" placement="top" v-if="props.row.ispay==1 && props.row.paytype==20">
							<div v-if="props.row.ispay==1 && props.row.paytype==20" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/alipay_huifu_pay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 汇付天下-微信支付，已支付 -->
							<el-tooltip class="item" effect="dark" content="支付方式：汇付天下-微信，已支付" placement="top" v-if="props.row.ispay==1 && props.row.paytype==21">
							<div v-if="props.row.ispay==1 && props.row.paytype==21" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/wechat_huifu_pay.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 订单来源-跑店小程序 -->
							<el-tooltip class="item" effect="dark" content="下单渠道：跑店小程序" placement="top" v-if="props.row.ordersourse==1">
							<div v-if="props.row.ordersourse==1" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/run.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>

							<!-- 订单来源-PC采购渠道下单的订单 -->
							<!-- v-if="props.row.order_from==2" -->
							<el-tooltip v-if="props.row.order_from==2" class="item" effect="dark" content="下单渠道：PC采购" placement="top">
							<div class="pcqd">PC</div>
							</el-tooltip>

							<!-- 订单来源-一件代发 -->
							<el-tooltip class="item" effect="dark" content="下单渠道：宠老板一件代发" placement="top" v-if="props.row.order_type==6 && props.row.ordersourse==2">
							<div v-if="props.row.order_type==6 && props.row.ordersourse==2" style="width:18px;height:18px;margin-left:7px;"><img src="@/assets/Goods/paytype_icon/replace.png" style="width:18px;height:18px;" /></div>
							</el-tooltip>
							<div v-if="props.row.mark_status == 1 && (props.row.status == 4 || props.row.status == 0)" class="buhuo">补货中</div>
							<div v-if="props.row.mark_status == 2 && (props.row.status == 4 || props.row.status == 0)" class="buhuo buhuo-greey">可发货</div>
						</span>

						<!-- 拼团活动 -->
						<el-tooltip class="item" effect="dark" :content="props.row.orderactives.msg" placement="top" v-if="props.row.orderactives.msg!=''">
							<span class="cz-mall-order-pt">{{props.row.orderactives.name}}</span>
						</el-tooltip>				
						<span class="cz-mall-order-shop"><a @click="getshopinfos(props.row.shopid)">店铺名称：{{props.row.shopname}}</a></span>
						<span class="cz-mall-order-seller" v-if="datacenter=='cz'">销售员：{{props.row.clerkname}}</span>
					</template>
				</el-table-column>	
				<el-table-column label="订单金额" prop="total" min-width="100" align="center"/>
				<el-table-column label="优惠减免" prop="derate" min-width="100" align="center"/>
				<el-table-column label="额外优惠" prop="derateprice" min-width="100" align="center"/>
				<el-table-column label="额外运费" prop="express" min-width="100" align="center"/>
				<el-table-column label="实付金额" prop="allprice" min-width="140" align="center">
					<template slot-scope="props">
						<div style="float:left;width:100%;font-size:14px;line-height:23px">{{props.row.allprice}}</div>
						<div style="float:left;width:100%;font-size:13px;line-height:23px;color:red" v-if="props.row.allrefunds > 0">（已退款：{{props.row.allrefunds}}）</div>
					</template>
				</el-table-column>
				<!--
				<el-table-column label="退款金额" prop="allrefunds" width="100" align="center">
				-->
				<el-table-column label="下单时间" min-width="150" align="center" v-if="query.type==1">
					<template slot-scope="scope">
						<span class="cz-mall-order-inputtime">{{scope.row.inputtime}}</span>
					</template>
				</el-table-column>
				<el-table-column label="支付时间" min-width="150" align="center" v-if="query.type==2">
					<template slot-scope="scope">
						<span class="cz-mall-order-inputtime">{{scope.row.pay_time}}</span>
					</template>
				</el-table-column>		
				<el-table-column prop="status" label="状态" min-width="130" align="center">
					<template slot-scope="scope">
						<span class="cz-mall-order-status-send" style="color:red"  v-if="scope.row.isedit>0">改单中...</span>
						<span class="cz-mall-order-status-send" style="color:red"  v-if="scope.row.isrefund==1">售后中...</span>
						<span class="cz-mall-order-status-send" style="color:red"  v-if="scope.row.isrefund==2">全部退款完成</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.paytype < 9 && scope.row.ispay==1 && scope.row.status==0">待确认</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.paytype==9 && scope.row.status==0">待确认</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.paytype==11 && scope.row.status==0">待确认</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==4">已确认，待发货</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && (scope.row.status==1 || scope.row.status==2 || scope.row.status==3)">已发货，待签收</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==5">客户已签收</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==11">订单完成</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==9">买家取消订单</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==10">商家取消订单</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==6">客户申请退货</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==7">已退货</span>
						<span class="cz-mall-order-status-send"  v-if="scope.row.isedit==0 && scope.row.isrefund==0 && scope.row.status==8">商家拒绝退货</span>
					
						<!-- 是否已有物流信息 -->
						<div class="cz-mall-order-haveshippings" v-if="scope.row.haveshippings > 0" @click="getpackshippings(scope.row.id)"><img src="../../assets/refund_goods.png" /></div>

						<!-- 提现记录 -->
						<el-tooltip 
							class="item" 
							effect="dark" 
							:content="scope.row.tx_status==1 ? '提现完成，提现流水号：'+scope.row.tx_sn : '正在提现，提现流水号：'+scope.row.tx_sn " 
							placement="top" 
							v-if="scope.row.tx_auth==1 && scope.row.tx_status > 0"
						>
						<div class="cz-mall-order-haveshippings" v-if="scope.row.tx_auth==1 && scope.row.tx_status > 0">
							<img :src="scope.row.tx_status==1 ? require('@/assets/sellicon/tixian_finish.png') : require('@/assets/sellicon/tixian_loading.png') " />
						</div>
						</el-tooltip>


					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="90" align="center">
					<template slot-scope="props">		
						<el-dropdown>
							<el-button type="warning" size="mini" icon="el-icon-arrow-down" circle></el-button>
							<el-dropdown-menu slot="dropdown">
								<!-- 校验库存按钮 -->
								<el-dropdown-item v-if="(props.row.mark_status == 1 || props.row.mark_status == 2) && props.row.status == 4" @click.native="checkInventory(props.row)">校验库存</el-dropdown-item>

								<!-- 使用宠赞为数据中心的操作按钮 - 确认订单（news） -->
								<el-dropdown-item v-if="datacenter=='cz' && props.row.paytype != 9 && props.row.ispay==1 && props.row.status==0 && actionauth.mall_order_send=='true'" @click.native="sureGoods(props.row)">确认订单</el-dropdown-item>
								<!-- 使用宠赞为数据中心的操作按钮 - 订单发货（news） -->
								
								<el-dropdown-item v-if="datacenter=='cz' && props.row.paytype != 9 && props.row.ispay==1 && props.row.status==4 && actionauth.mall_order_send=='true' && props.row.mark_status != 1" @click.native="selectSend(props.row)">订单发货</el-dropdown-item>
								<!-- 使用宠赞为数据中心的操作按钮 - 取消订单 （news）-->
								<el-dropdown-item v-if="datacenter=='cz' && props.row.paytype != 9 && (props.row.status==0 || props.row.status==4) && actionauth.mall_order_send=='true'" @click.native="cannelGoods(props.row)">取消订单</el-dropdown-item>
								<!-- 使用宠赞为数据中心的操作按钮 - 完成订单 （news）-->
								<el-dropdown-item v-if="datacenter=='cz' && props.row.paytype != 9 && props.row.ispay==1 && props.row.status==5 && actionauth.mall_order_send=='true'" @click.native="finishGoods(props.row)">完成订单</el-dropdown-item>
								
								<!-- 使用宠赞为数据中心的操作按钮 - 改单，已支付的单子一律不允许改单，否则金额无法流向财务无法统计 （news）-->
								<!-- 不使用宠赞数据中心的操作按钮 - 改单，已支付的单子一律不允许改单，否则金额无法流向财务无法统计 （news）-->
								<el-dropdown-item v-if="(props.row.ispay==0 && props.row.mark_status != 1 && !wangdian_sid) || (props.row.ispay==1 && props.row.mark_status != 1 && ispayeditauth==true && !wangdian_sid) || (datacenter!='cz' && props.row.ispay==0 && !wangdian_sid)" @click.native="editorders(props.row)">去改单</el-dropdown-item>
								<!-- <el-dropdown-item v-if="props.row.ispay==1 && props.row.mark_status != 1 && ispayeditauth==true && !wangdian_sid" @click.native="editorders(props.row)">去改单</el-dropdown-item>
								<el-dropdown-item v-if="datacenter!='cz' && props.row.ispay==0 && !wangdian_sid" @click.native="editorders(props.row)">去改单</el-dropdown-item> -->
								
								<!-- 使用宠赞为数据中心的操作按钮 - 编辑销售员 （news）-->
								<el-dropdown-item @click.native="settingclerk(props.row)" v-if="datacenter=='cz'">编辑销售员</el-dropdown-item>

								<!-- 不使用宠赞数据中心的操作按钮 - 确认订单 （news）-->
								<el-dropdown-item v-if="datacenter!='cz' && props.row.paytype != 9 && props.row.ispay==1 && props.row.status==0 && actionauth.mall_order_send=='true'" @click.native="sureGoods(props.row)">确认订单</el-dropdown-item>
								<!-- 不使用宠赞数据中心的操作按钮 - 订单发货 （news）-->
								<el-dropdown-item v-if="datacenter!='cz' && props.row.paytype != 9 && props.row.ispay==1 && props.row.status==4 && actionauth.mall_order_send=='true' && !wangdian_sid" @click.native="noczSendgoods(props.row)">订单发货</el-dropdown-item>
								<!-- 不使用宠赞数据中心的操作按钮 - 取消订单 （news）-->
								<el-dropdown-item v-if="datacenter!='cz' && props.row.paytype != 9 && props.row.ispay==1 && (props.row.status==0 || props.row.status==4) && actionauth.mall_order_send=='true'" @click.native="cannelGoods(props.row)">取消订单</el-dropdown-item>
								<!-- 不使用宠赞数据中心的操作按钮 - 完成订单 （news）-->
								<el-dropdown-item v-if="datacenter!='cz' && props.row.paytype != 9 && props.row.ispay==1 && props.row.status==5 && actionauth.mall_order_send=='true'" @click.native="finishGoods(props.row)">完成订单</el-dropdown-item>
								
								<!-- 填写快递单号 -->
								<el-dropdown-item v-if="props.row.paytype != 9 && props.row.ispay==1 && (props.row.status==1 || props.row.status==2 || props.row.status==3 || props.row.status==5 || props.row.status==11) && actionauth.mall_order_send=='true' && !wangdian_sid" @click.native="noczwritelogistics(props.row)">填写快递单</el-dropdown-item>


								<!-- 使用宠赞数据中心的代理商-待确认订单状态（old） -->
								<!--
								<el-dropdown-item v-if="props.row.paytype != 9 && props.row.ispay==1 && props.row.status==0 && actionauth.mall_order_send=='true'" @click.native="sureGoods(props.row)">确认订单</el-dropdown-item>
								<el-dropdown-item v-if="props.row.paytype == 11 && props.row.ispay==1 && props.row.status==0 && actionauth.mall_order_send=='true'" @click.native="sureGoods(props.row)">确认订单</el-dropdown-item>
								-->
								<!-- 使用宠赞数据中心的代理商-订单发货 -->
								<!--
								<el-dropdown-item v-if="props.row.paytype != 9 && props.row.ispay==1 && (props.row.status==1 || props.row.status==2 || props.row.status==3 || props.row.status==4 || props.row.status==5 || props.row.status==6 || props.row.status==7 || props.row.status==8 || props.row.status==11) && actionauth.mall_order_send=='true'" @click.native="selectSend(props.row)">订单发货</el-dropdown-item>
								<el-dropdown-item v-if="props.row.paytype ==11 && props.row.ispay==1 && (props.row.status==1 || props.row.status==2 || props.row.status==3 || props.row.status==4 || props.row.status==5 || props.row.status==6 || props.row.status==7 || props.row.status==8 || props.row.status==11) && actionauth.mall_order_send=='true'" @click.native="selectSend(props.row)">订单发货</el-dropdown-item>
								-->
								<!---- 使用宠赞数据中心的代理商-取消订单 ------>
								<!--
								<el-dropdown-item v-if="props.row.paytype != 9 && props.row.ispay==1 && (props.row.status==0 || props.row.status==4) && actionauth.mall_order_send=='true'" @click.native="cannelGoods(props.row)">取消订单</el-dropdown-item>
								<el-dropdown-item v-if="props.row.paytype == 11 && props.row.ispay==1 && (props.row.status==0 || props.row.status==4) && actionauth.mall_order_send=='true'" @click.native="cannelGoods(props.row)">取消订单</el-dropdown-item>
								-->
								<!---- 使用宠赞数据中心的代理商-完成订单 ------>
								<!--
								<el-dropdown-item v-if="props.row.paytype != 9 && props.row.ispay==1 && props.row.status==5 && actionauth.mall_order_send=='true'" @click.native="finishGoods(props.row)">完成订单</el-dropdown-item>
								<el-dropdown-item v-if="props.row.paytype == 11 && props.row.ispay==1 && props.row.status==5 && actionauth.mall_order_send=='true'" @click.native="finishGoods(props.row)">完成订单</el-dropdown-item>
								-->
								<!---- 改单、退货，订单支付金额后一律不允许改单，涉及财务相关的金额结算 ---->
								<!--
								<el-dropdown-item v-if="props.row.ispay==0" @click.native="editorders(props.row)">去改单</el-dropdown-item>
								<el-dropdown-item @click.native="settingclerk(props.row)" v-if="datacenter=='cz'">编辑销售员</el-dropdown-item>
								<el-dropdown-item @click.native="refundordergoods(props.row)">去退货</el-dropdown-item>
								-->
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
		        <el-pagination 
		            @size-change="orderpageSizeChange" 
		          	@current-change="orderpageCurrentChange"
		          	:current-page="query.p"
		          	:page-sizes="[10, 20, 50]"
		          	:page-size="query.rollpage"
		          	layout="total, sizes, prev, pager, next, jumper"
		          	:total="total_rows">
		        </el-pagination>
	   		</div>
		</div>
		
		<!-------------------------------------- 取消订单 -------------------------------------------->
        <el-dialog title="取消订单" :visible.sync="cannelDialog" width="20%" top="15vh">
			<el-form>
        		<el-col :span="24">
        		    <el-input size="small" type="textarea" :autosize="{minRows:6, maxRows:10}" placeholder="请填写取消订单原因" v-model="reason"></el-input>
        		</el-col>
        	</el-form>
        	<el-col :span="24" style="margin-top:20px"></el-col>
        	<div slot="footer" class="dialog-footer">
            	<el-button size="small" @click="cannelDialog = false">取 消</el-button>
            	<el-button size="small" type="primary" :loading="cannelLoading" @click="cannelSave">确 认</el-button>
            </div>
        </el-dialog>
        
        <!------------------------ 确认并选择销售员 ------------------------->
        <el-dialog title="选择销售员" :visible.sync="selectclerkDialog" width="30%">
        	<el-form size="small" label-width="100px">
        		<el-col :span="23">
        		    <el-form-item label="交货日期">
			            <el-date-picker type="date" placeholder="请选择交货日期" v-model="create.deliverdate" style="width:99%;" value-format="yyyy-MM-dd"></el-date-picker>
			        </el-form-item>
	                <el-form-item label="销售员">
	                    <el-select v-model="create.seller" placeholder="请选择销售员">
	                    	<el-option v-for="item in clerks" :key="item.id" :label="item.name" :value="item.id"></el-option>
	                    </el-select>
	                </el-form-item>
	                <el-form-item label="操作人">
						<el-select v-model="create.sysmanager" placeholder="请选择经手人">
					    	<el-option v-for="(item,index) in sysmanagers" :key="index" :label="item.truename" :value="item.id"></el-option>
					    </el-select> 
				    </el-form-item>  
                </el-col>
        	</el-form>
              		
        	<div slot="footer" class="dialog-footer">
		    	<el-button size="small" @click="selectclerkDialog = false">取 消</el-button>
		        <el-button size="small" type="primary" @click="saveclerk">确认</el-button>
		    </div>
        </el-dialog>
        
        <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
            <div id="printContent" style="margin-top:20px">
      		    <DIV style="LINE-HEIGHT:30px;font-size:18px;padding-bottom:2px;" align="center" v-if="printsmodel.title==1"><STRONG>{{printsmodel.titlevalue}}</STRONG></DIV>
      		    <ul class="titlelists">
			  	    <li v-if="printsmodel.customer_name==1">客户名称：{{customerName}}</li>
				    <li v-if="printsmodel.deliverdate==1">交货日期：{{create.deliverdate}}</li>
				    <li v-if="printsmodel.documents==1">单据编号：{{create.documents}}</li>
				    <li v-if="localorder.paytype==1 && printsmodel.accountname==1">收款帐号：支付宝</li>
          			<li v-else-if="localorder.paytype==7 && printsmodel.accountname==1">收款帐号：微信</li>
          			<li v-else-if="localorder.paytype==8 && printsmodel.accountname==1">收款帐号：银联</li>
          			<li v-else-if="localorder.paytype==5 && printsmodel.accountname==1">收款帐号：透支</li>
          			<li v-else-if="localorder.paytype==9 && localorder.ispay==0 && printsmodel.accountname==1">收款帐号：未付款</li>
					<li v-else-if="localorder.paytype==9 && localorder.ispay==1 && printsmodel.accountname==1">收款帐号：{{localorder.accountname}}</li>
          			<li v-if="printsmodel.clerkname==1">销售员：{{clerkName}}</li> 
          			<li v-if="printsmodel.note==1">出库备注：{{localorder.note}}</li>
          			<li v-if="printsmodel.contactname==1">收货人姓名：{{create.contactname}}</li>
					<li v-if="printsmodel.contactphone==1">收货电话：{{create.contactphone}}</li> 
					<li v-if="printsmodel.address==1">收货地址：{{create.address}}</li>
			    </ul>
      		    <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px" bordercolor="#333333">
          			<thead>
            			<TR class="contactcontent">
              				<!--<TD v-if="printsmodel.number==1"><DIV align=center><b>编号</b></DIV></TD>-->
              				<TD v-if="printsmodel.product_name==1"><DIV align=center><b>品名</b></DIV></TD>
              				<TD v-if="printsmodel.unit==1"><DIV align=center><b>单位</b></DIV></TD>
              				<TD v-if="printsmodel.num==1"><DIV align=center><b>数量</b></DIV></TD>
              				<TD v-if="printsmodel.sell==1"><DIV align=center><b>售价</b></DIV></TD>
              				<TD v-if="printsmodel.account==1"><DIV align=center><b>小计</b></DIV></TD>
              				<TD v-if="printsmodel.warehourse==1"><DIV align=center><b>仓库</b></DIV></TD>
              				<TD v-if="printsmodel.desc==1"><DIV align=center><b>类型</b></DIV></TD>
              			</TR>
          			</thead> 
          			<TBODY>      
            			<tr v-for="item in create.goods.data" class="contactcontent">
              				<!--<TD v-text="item.id" align=center v-if="printsmodel.number==1"></TD>-->
				            <TD v-text="item.name" style="padding-left:1%" v-if="printsmodel.product_name==1"></TD>
				            <TD v-text="item.unit" align=center v-if="printsmodel.unit==1"></TD>
				            <TD v-text="item.numbers" align=center v-if="printsmodel.num==1"></TD>
				            <TD v-text="item.price" align=center v-if="printsmodel.sell==1"></TD>
				            <TD v-text="item.base_total" align=center v-if="printsmodel.account==1"></TD>
				            <TD v-text="item.warehouse" align=center v-if="printsmodel.warehourse==1"></TD>
				            <TD v-text="item.ordertype" align=center v-if="printsmodel.desc==1"></TD>
            			</tr>
				        <tr>
				            <!--<TD align=center v-if="printsmodel.number==1 || printsmodel.product_name==1"><b>合计</b></TD>-->
				            <TD v-if="printsmodel.product_name==1">&nbsp;&nbsp;<b>合计</b></TD>
				            <TD v-if="printsmodel.unit==1">&nbsp;</TD>
				            <TD v-if="printsmodel.num==1" align="center">{{this.create.goods.allnumber}}</TD>
				            <TD v-if="printsmodel.sell==1">&nbsp;</TD>
				            <TD align=center v-if="printsmodel.account==1">{{this.create.goods.cost}}</TD>
				            <TD v-if="printsmodel.warehourse==1">&nbsp;</TD>
				            <TD v-if="printsmodel.desc==1">&nbsp;</TD>
				        </tr>
          			</TBODY>
      			</TABLE>
      			<TABLE border=0 cellSpacing=0 cellPadding=0 width="100%" style="font-size:15px">
        			<TBODY>
        				<TR class="top1">
          					<TD v-if="printsmodel.inputdate==1">录单日期：{{this.create.goods.createtime}}</TD>
          					<TD v-if="printsmodel.derate==1">优惠金额：{{this.create.goods.cheap}} 元</TD>
          					<TD v-if="printsmodel.total==1">应付金额：{{this.create.goods.total}} 元</TD>
          					<TD v-if="printsmodel.sysmanagername==1">操作人：{{this.create.sysmanagername}}</TD>
          				</tr>
          				<TR class="top1" v-if="printsmodel.print==1">
				            <TD :colspan="4">{{printsmodel.printvalue}}</TD>
				        </tr>
				        <TR class="top2">
				          <TD v-if="printsmodel.p_man==1">配货人</TD>
				          <TD v-if="printsmodel.s_man==1">送货人</TD>
				          <TD v-if="printsmodel.ss_man==1">收货人</TD>
				          <TD>&nbsp;</TD>
				          <TD>&nbsp;</TD>
				        </tr>
          			</TBODY>
          		</TABLE> 
			</div>
			<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="printerDialog = false">取 消</el-button>
		        <el-button size="medium" type="primary" @click="onlyprint" v-if="localorder.status==1">打印</el-button>
		        <el-button size="medium" type="primary" @click="createSave" :loading="createsaveLoading" v-if="localorder.status!=1">只出库不打印</el-button>
		        <el-button size="medium" type="danger" @click="printContent" v-if="localorder.status!=1">出库并打印</el-button>
		    </div>
  	    </el-dialog>
        
        
		
		<!--------------- 消息提示 ----------->
		<el-dialog title="线上商城告示" :visible.sync="noticeDialog"  width="25%" top="15vh">
			<div>
			    <span>1、线上商城已接入京东商品数据，授权的代理商产品可见，所下的订单商品列表里有可能是混合商品（即既有宠赞商品又有京东的商品）；</span><br/>
			    <span>2、订单中商品来源信息里，标有宠字的为宠赞的商品、标有京字的为京东的商品；</span><br/>
			    <span>3、京东的商品不参与线上商城的活动、不能使用线上商城的代金券、优惠券。</span>
			</div>
		</el-dialog>
		
		<!----- 包裹信息 -->
		<el-dialog title="出库单信息" :visible.sync="packdialog"  width="65%" top="10vh">
			<div v-loading="packdialogloading" v-if="packlists.length==0" style="width:100%;height:200px;background:rgb(211,211,211,0.3);border-radius:6px;font-size:14px;font-weight:500;display:flex;justify-content:center;align-items:center">
				<img src="../../assets/packet.png" style="width:40px;height:40px"/>
				<span style="float:left;margin-left:1%">暂无出库单信息</span>
			</div>
			<div v-loading="packdialogloading" v-for="(item,index) in packlists" :key="index" style="float:left;width:96%;padding:2%;background:rgb(211,211,211,0.3);border-radius:6px;margin-bottom:20px">
				
				<!-- 数据中心为宠赞的用户显示发货对应的销售出库单，非宠赞为数据中心的用户只显示快递信息 -->
				<el-col :span="24" v-if="datacenter=='cz'">
				<el-col :span="24"  style="font-weight:bold;">
					<div style="float:left">供应商：</div>
					<div style="float:left">（{{item.sendagentname!='' ? item.sendagentname : '京东'}}）</div>
				</el-col>
				<el-col :span="24">
					<el-col :span="24">{{item.documents}}</el-col>
					<el-col :span="24">收货人：{{item.truename}}</el-col>
					<el-col :span="6">手机号码：{{item.phone}}</el-col>
					<el-col :span="24">收货地址：{{item.mainaddress}}，{{item.address}}</el-col>
				</el-col>
				<el-table :data="item.goods" style="float:left;width:100%;margin-top:10px">
					<el-table-column label="商品名称" prop="name"></el-table-column>
					<el-table-column label="数量" prop="numbers" align="center" width="100"></el-table-column>
					<el-table-column label="价格" prop="price" align="center" width="100"></el-table-column>
					<el-table-column label="小计" prop="total" align="center" width="100"></el-table-column>
				</el-table>
				</el-col>

				<div class="packstyle" v-if="item.shipping.length>0">
				<div style="float:left;width:100%">
					<a v-for="(tt,ii) in item.shipping" :style="tt.isactive==1 ? 'float:left;padding:5px 20px;border-bottom:2px solid #e6a23c;font-size:13px;cursor:pointer' : 'float:left;padding:5px 20px;border-bottom:2px solid #fff;font-size:13px;cursor:pointer' " @click="checkpacklogistics(index,ii)">{{tt.name}}（单号：{{tt.code}}）</a>
				</div>
				<ul style="padding:0 2%;margin-top:30px;float:left;width:96%" v-for="(tt,ii) in item.shipping" v-if="tt.isactive==1">
					<li v-for="(ttt,iii) in tt.data" style="border-left:2px solid #e4e7ed;" v-if="ttt.isend=='no'">
						<div class="icon" v-if="iii == 0"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
						<div class="time" v-if="iii == 0" style="color:red;">{{ttt.content}}</div>
						<span class="content" v-if="iii == 0" style="color:red">{{ttt.msgTime}}</span>
						<span class="content" v-if="iii == 0 && tt.operator!=''" style="color:red">操作人：{{ttt.operator}}</span>

						<div class="icon" v-if="iii > 0"><img src="../../assets/time.png" /></div>
						<div class="time" v-if="iii > 0">{{ttt.content}}</div>
						<span class="content" v-if="iii > 0">{{ttt.msgTime}}</span>
						<span class="content" v-if="iii > 0 && ttt.operator!=''">操作人：{{tt.operator}}</span>
					</li>
					<li v-for="(ttt,iii) in tt.data" v-if="ttt.isend=='yes'">
						<div class="icon" v-if="iii == 0" style="color:red"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
						<div class="time" v-if="iii == 0" style="color:red">{{ttt.content}}</div>
						<span class="content" v-if="iii == 0" style="color:red">{{ttt.msgTime}}</span>
						<span class="content" v-if="iii == 0 && tt.operator!=''" style="color:red">操作人：{{ttt.operator}}</span>

						<div class="icon" v-if="iii > 0"><img src="../../assets/time.png" /></div>
						<div class="time" v-if="iii > 0">{{ttt.content}}</div>
						<span class="content" v-if="iii > 0">{{ttt.msgTime}}</span>
						<span class="content" v-if="iii > 0 && ttt.operator!=''">操作人：{{ttt.operator}}</span>
					</li>
				</ul>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="margin-top:20px">
		        <el-button size="medium" @click="packdialog = false">取 消</el-button>
		    </div>
		</el-dialog>
		
		<!---- 发货方式 ------->
		<el-dialog title="请选择发货方式" :visible.sync="sendDialog"  width="15%" top="20vh">
			<div style="float:left;width:100%" v-loading="sendloading">
				<el-col :span="24" v-for="(item,index) in sendtypelists" :key="index">
					<el-button @click="sendordergoods(0,0)" v-if="item.name=='全部商品发货' && item.issend" type="primary" size="mini" style="width:100%;margin:0 0 10px 0">全部商品发货</el-button>
					<el-button @click="sendordergoods(0,0)" v-if="item.name=='全部商品发货' && item.issend==false" type="info" size="mini" style="width:100%;margin:0 0 10px 0">全部商品发货</el-button>
					<el-button @click="sendordergoods(2,0)" v-if="item.name=='京东商品发货' && item.issend" type="danger"  size="mini" style="width:100%;margin:0 0 10px 0">京东商品发货</el-button>
					<el-button @click="sendordergoods(2,0)" v-if="item.name=='京东商品发货' && item.issend==false" type="info" icon="el-icon-check" size="mini" style="width:100%;margin:0 0 10px 0">京东商品发货</el-button>

					<el-button @click="sendordergoods(1,item.agentid)" v-if="item.agentid > 0 && item.issend" type="warning" size="mini" style="width:100%;margin:0 0 10px 0">{{item.name}}商品发货</el-button>
					<el-button @click="sendordergoods(1,item.agentid)" v-if="item.agentid > 0 && item.issend==false" type="info" icon="el-icon-check" size="mini" style="width:100%;margin:0 0 10px 0">{{item.name}}商品发货</el-button>
				</el-col>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="sendDialog = false" style="margin-top:20px">取 消</el-button>
			</div>
		</el-dialog>

		<!--- 推送通知 --->
		<el-dialog title="推送设置" :visible.sync="pushDialog"  width="45%" top="15vh">
			<el-tag type="danger" style="margin-bottom:20px">温馨提示：以下设置主要用于商城下单后通过以下方式通知平台管理人员</el-tag>
			<div v-loading="pushloading" style="float:left;width:100%">
				<el-col v-for="(item,index) in pushlists" :key="index" :span="24" style="margin-bottom:20px;background:rgb(220,223,230,.4);padding:.5rem .3rem .3rem .5rem;border-radius:6px">
					<div style="border-bottom:1px solid #fff;padding:0 0 .5rem 0">
						<span style="font-weight:bold">{{item.name}}</span>
						<el-button type="warning" size="mini" circle icon="el-icon-plus"  @click="addpush(item.id)"  style="float:right;margin-right:1%"></el-button>
					</div>
					<table class="pushnotice" style="float:left;width:100%">
						<tr v-for="(tt,ii) in item.manager" :key="ii" style="padding:5px 0 5px 0;float:left;width:100%">
							<td width="20%">{{tt.truename}}</td>
							<td width="30%"><el-input v-model="tt.contact" @blur="changecontact(tt.type,tt.id,tt.contact)"></el-input></td>
							<td width="20%">
								<td width="20%"><el-button size="mini" type="danger" circle icon="el-icon-delete" @click="delpush(tt.id)" style="float:right"></el-button></td>
							</td>
						</tr>
					</table>
				</el-col>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="pushDialog = false" style="margin-top:20px">取 消</el-button>
			</div>
		</el-dialog>

		<!--- 新增用户信息 --->
		<el-dialog title="新增推送设置" :visible.sync="addpushDialog"  width="20%" top="15vh">
			<el-form :inline="true" size="small">
				<el-form-item style="width:100%">
					<el-input v-model="pushquery.truename" placeholder="联系人"></el-input>
				</el-form-item>
				<el-form-item style="width:100%">
					<el-input v-model="pushquery.contact" placeholder="手机号 / 微信"></el-input>
				</el-form-item>  
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="medium" @click="addpushs">确定</el-button>
				<el-button size="medium" @click="addpushDialog = false">取 消</el-button>
			</div>
		</el-dialog>

		<!--- 线下客户支付状态信息 --->
		<el-dialog title="线下支付信息详情" :visible.sync="changepayDialog"  width="25%" top="15vh">
			<el-form :inline="true" size="small">
				<el-form-item label="收款帐号">
					<el-select v-model="changepayquery.account" placeholder="未付款" filterable style="width:100%">
						<el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="支付金额" style="width:100%">
					<el-input v-model="changepayquery.amount" placeholder="支付金额" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="销售人员">
					<el-select v-model="changepayquery.seller" filterable placeholder="请选择销售员">
						<el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="信息备注">
					<el-input size="small" type="textarea" :autosize="{minRows:3, maxRows:10}" placeholder="备注" v-model="changepayquery.desc"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="medium" @click="savepay">确定</el-button>
				<el-button size="medium" @click="changepayDialog = false">取 消</el-button>
			</div>
		</el-dialog>

		<!-- 活动信息列表 -->
		<el-dialog title="活动信息列表" :visible.sync="activeDialog"  width="25%" top="15vh">
			<div style="float:left;width:100%;padding-bottom:20px">
				<div style="float:left;width:100%" v-for="(item,key) in showactivelists">{{item}}</div>
			</div>
			<div slot="footer" class="dialog-footer" style="margin-top:20px">
				<el-button size="medium" @click="activeDialog=false">取消</el-button>
			</div>
		</el-dialog>

		
		<!------------- 订单列表导出信息 ----------------->	
	    <el-dialog title="导出订单信息确认" :visible.sync="outlistsputDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outexportlists" border v-loading="outlistsLoading">
		      	  	<el-table-column prop="ordernumber" label="订单编号"></el-table-column>
					<el-table-column prop="shopname" label="店铺名称"></el-table-column>
					<el-table-column prop="truename" label="收货人姓名"></el-table-column>
					<el-table-column prop="phone" label="收货电话"></el-table-column>
					<el-table-column prop="address" label="收货地址"></el-table-column>
					<el-table-column prop="ispay" label="是否支付"></el-table-column>
					<el-table-column prop="paytype" label="支付类型"></el-table-column>
					<el-table-column prop="oriprices" label="订单金额"></el-table-column>
					<el-table-column prop="prices" label="支付金额"></el-table-column>
					<el-table-column prop="inputtime" label="下单时间"></el-table-column>
					<el-table-column prop="pay_time" label="支付时间"></el-table-column>
					<el-table-column prop="status" label="订单状态"></el-table-column>
					<el-table-column prop="paybank" label="支付渠道"></el-table-column>
					<el-table-column prop="pay_trade_no" label="对账订单号"></el-table-column>
					<el-table-column prop="senddesc" label="出库订单号"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outlistsputDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

		<!------------- 订单商品详情列表导出信息 ----------------->	
	    <el-dialog title="导出订单信息确认" :visible.sync="outdetailsputDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="suredetailoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="outexportdetails" border v-loading="outdetailsLoading">
		      	  	<el-table-column prop="ordernumber" label="订单编号"></el-table-column>
					<el-table-column prop="sku" label="sku"></el-table-column>
					<el-table-column prop="productname" label="商品名称"></el-table-column>
					<el-table-column prop="propertyname" label="规格"></el-table-column>
					<el-table-column prop="spec" label="规格属性"></el-table-column>
					<el-table-column prop="price" label="价格"></el-table-column>
					<el-table-column prop="numbers" label="数量"></el-table-column>
					<el-table-column prop="cost" label="采购成本"></el-table-column>
					<el-table-column prop="total" label="小计"></el-table-column>
					<el-table-column prop="orderreal" label="所属订单实付金额"></el-table-column>
					<el-table-column prop="goodsreal" label="商品实付金额"></el-table-column>
					<el-table-column prop="market" label="零售价"></el-table-column>
					<el-table-column prop="type" label="商品类型"></el-table-column>
					<el-table-column prop="inputtime" label="下单时间"></el-table-column>
					<el-table-column prop="pay_time" label="支付时间"></el-table-column>
					<el-table-column prop="status" label="订单状态"></el-table-column>
					<el-table-column prop="documents" label="供应商订单编号"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="outdetailsputDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="suredetailoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

		<el-dialog title="订单选择销售员" :visible.sync="settingclerkDialog" width="20%" top="20vh">
			<el-select v-model="settingclerkid" placeholder="请选择销售员" clearable filterable>
				<el-option v-for="(item,index) in sellerLists" :label="item.name" :value="item.id" :key="index"></el-option>
			</el-select>
			<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="settingclerkDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="suresettingclerks">确认</el-button>
		    </div>	   
		</el-dialog>

		<el-dialog title="店铺信息" :visible.sync="shopinfoDialog" width="40%" top="15vh">
			<div style="float:left;width:100%;margin-bottom:20px">
				<div style="float:left;width:100px;height:100px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;display:flex;justify-content:center;align-items:center">
					<img :src="shopinfos.logo" style="border-radius:6px;max-width:80%;max-height:80%;" v-if="shopinfos.logo!=''" />
					<img src="../../assets/shop.png" style="border-radius:6px;max-width:80%;max-height:80%;" v-if="shopinfos.logo==''"/>
				</div>
				<div style="float:left;width:75%;margin-left:3%">
					<span style="float:left;width:100%;line-height:25px;;font-size:13px;font-weight:500">店铺名称：{{shopinfos.shopname}}</span>
					<span style="float:left;width:100%;line-height:25px;font-size:13px;font-weight:500">联系电话：{{shopinfos.showphone}}</span>
					<span style="float:left;width:100%;line-height:25px;font-size:13px;font-weight:500">店铺地址（非收货地址）：{{shopinfos.cityname}}</span>
					<span style="float:left;width:100%;line-height:25px;font-size:13px;font-weight:500">店铺详细地址（非收货地址）：{{shopinfos.address}}</span>
				</div>
				<!--
				<template>
				<div style="float:left;width:98%;margin-top:30px;border:1px solid #ddd;padding:1%">
					<baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true" v-loading="mapLoading">
						<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="false" :autoLocation="true" :locationIcon="{size: {width: 18, height: 10}}" @locationSuccess="getLoctionSuccess" @locationError="getLocationError"></bm-geolocation>
						<bm-marker :position="autoLocationPoint"  :dragging="true" :auto-viewport='true' animation="BMAP_ANIMATION_BOUNCE"  v-if="initLocation"></bm-marker>
					</baidu-map>	
				</div>
				</template>	
				-->
			</div>

			<div slot="footer" class="dialog-footer">
		        <el-button size="small" @click="shopinfoDialog=false">取 消</el-button>
		    </div>	   
		</el-dialog>

		<!-- 设置自动签收时长 -->
		<el-dialog title="设置自动签收时长" :visible.sync="daysDialog" width="20%" top="15vh">
			<el-col :span="18" style="margin-bottom:30px">
				<el-input placeholder="请输入自动签收时长" v-model="days"><template slot="append">日</template></el-input>
			</el-col>
			<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="daysDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="savedays">确认</el-button>
		    </div>	 
		</el-dialog>

		<!-- 修改订单信息相关 -->
		<el-dialog title="修改订单信息" :visible.sync="editorderDialog" width="80%" top="5vh">
			<!-- 基础信息 -->
			<div v-loading="editgoodsloading">
			<div style="float:left;padding-bottom:.5rem;margin-bottom:2rem;" >
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">订单编号：{{ordertemp.ordernumber}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">下单店铺：{{ordertemp.shopname}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">订单状态：{{ordertemp.status}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">下单时间：{{ordertemp.inputtime}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">支付方式：{{ordertemp.paytype}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">支付时间：{{ordertemp.pay_time}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">收货人：{{ordertemp.shopname}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">联系电话：{{ordertemp.phone}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">买家备注：{{ordertemp.note}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">地址信息：{{ordertemp.defaultcity}}</el-col>
				<el-col :span="16" style="font-size:.8rem;margin-bottom:.5rem">详细地址：{{ordertemp.address}}</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem;">
					<span>商品排列：</span>
					<el-select v-model="ordertempquery.type" filterable @change="changegoodssort" style="width:60%" size="mini">
						<el-option v-for="(item,index) in goodssort" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
				</el-col>
				<el-col :span="8" style="font-size:.8rem;margin-bottom:.5rem">
					<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addtempgoodslists"></el-button>
					<el-button type="danger" icon="el-icon-setting" size="mini" circle @click="resettempgoodslists" v-if="ordertemp.editstatus==0"></el-button>
				</el-col>
			</div>

			<!-- 活动信息 -->
			<div style="float:left;width:98%;padding:0  1% .5rem 1%;border:1px solid rgb(221,221,221,.2);border-radius:5px;background:rgb(221,221,221,.2)" v-if="ordertemp.activenums>0">
				<el-tag type="danger"  v-for="(item,index) in ordertemp.active" :key="index" style="float:left;height:25px;line-height:25px;margin:.5rem 2% 0 0;" closable @close="delactive(item.id)">{{item.active}}</el-tag>
			</div>
			
			<!-- 商品信息 -->
			<div v-for="(item,index) in ordertemp.goods" class="ordertempgoods" style="float:left;width:98%;">
				<div style="float:left;width:100%;padding:.3rem 1% .3rem 1%;border-bottom:1px dashed #ddd;margin-top:1.5rem;margin-bottom:.3rem">
					<div style="float:left;font-size:13px;font-weight:550">{{item.name}}<i v-if="item.documents!='' && item.documents!=null " style="font-style:normal">（订单号：{{item.documents}}，{{item.statusname}}）</i></div>
					<el-tag type="danger" v-if="item.activeid > 0" style="float:left;height:25px;line-height:25px;margin:.1rem 0 0 2%;" closable>{{item.active}}</el-tag>
				</div>
				<table border="0" style="width:100%;">
					<tr style="float:left;width:96%;padding:.1rem 2% .1rem 2%">
						<td style="float:left;width:40%;font-size:13px;font-weight:500;color:#666666">商品信息</td>
						<td style="float:left;width:10%;font-size:13px;font-weight:500;color:#666666" align="center">数量</td>
						<td style="float:left;width:10%;font-size:13px;font-weight:500;color:#666666" align="center">单价</td>
						<td style="float:left;width:10%;font-size:13px;font-weight:500;color:#666666" align="center">折扣（100%）</td>
						<td style="float:left;width:10%;font-size:13px;font-weight:500;color:#666666" align="center">折后单价</td>
						<td style="float:left;width:10%;font-size:13px;font-weight:500;color:#666666" align="center">小计</td>
						<td style="float:left;width:8%;font-size:13px;font-weight:500;color:#666666" align="center">操作</td>
					</tr>
					<tr v-for="(tt,ii) in item.data" style="float:left;width:96%;padding:.5rem 2% .5rem 2%;display:flex;align-items:center" :class="item.status==0 ? 'showtr' : 'noshowtr' ">
						<td style="float:left;width:40%" align="left">
							<div style="float:left;width:100%">
								<div style="float:left;display:flex;justify-content:center;align-items:center;width:60px;height:60px;background:rgba(221,221,221,.5);border-radius:6px">
									<img :src="tt.showthumb" style="border-radius:6px;max-width:85%;max-height:85%"/>
								</div>
								<div style="float:left;width:81%;margin-left:2%">
									<span style="float:left;width:100%;font-size:.8rem;line-height:1.3rem;color:#666666">{{tt.productname}}<i style="font-style:normal" v-if="tt.sku > 0">（sku：{{tt.sku}}）</i></span>
									<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.7rem;line-height:1.2rem;margin-top:.2rem">规格：{{tt.propertyname}}</span><br/>
									<div style="float:left;width:100%;margin-top:.2rem;"><span style="float:left;line-height:.9rem;padding:.2rem .5rem;color:#fff;font-size:.7rem;background:#67C23A;border-radius:15px" v-if="tt.agentname!='' && tt.agentname!=null">{{tt.agentname}}</span></div>
									<div style="float:left;width:100%;margin-top:.4rem;"><el-tag type="danger" style="float:left;height:20px;line-height:20px;border-color:rgba(245,108,108,.5)" v-if="tt.activeid > 0" closable  @close="delactive(tt.activeid)">{{tt.active}}</el-tag></div>
								</div>
							</div>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-input v-model="tt.numbers" class="temelinputinner" @blur="changeparam(index,tt.id,tt.productid,tt.propertyid,tt.numbers,'edit','nums')"></el-input>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-input v-model="tt.price" class="temelinputinner" v-if="item.name!='赠品'" @blur="changeparam(index,tt.id,tt.productid,tt.propertyid,tt.price,'edit','price')"></el-input>
							<span v-if="item.name=='赠品'">{{tt.price}}</span>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-input v-model="tt.discount" class="temelinputinner" v-if="item.name!='赠品'" @blur="changeparam(index,tt.id,tt.productid,tt.propertyid,tt.discount,'edit','discount')"></el-input>
							<span v-if="item.name=='赠品'">{{tt.discount}}</span>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-input v-model="tt.dis_sell" class="temelinputinner" v-if="item.name!='赠品'" @blur="changeparam(index,tt.id,tt.productid,tt.propertyid,tt.dis_sell,'edit','dis_sell')"></el-input>
							<span v-if="item.name=='赠品'">{{tt.dis_sell}}</span>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-input v-model="tt.total" class="temelinputinner" v-if="item.name!='赠品'" @blur="changeparam(index,tt.id,tt.productid,tt.propertyid,tt.total,'edit','total')"></el-input>
							<span v-if="item.name=='赠品'">{{tt.total}}</span>
						</td>
						<td style="float:left;width:8%" align="center">
							<el-button type="danger" size="mini" circle icon="el-icon-minus" style="padding:3px" @click="changeparam(index,tt.id,tt.productid,tt.propertyid,tt.total,'del','total')"></el-button>
						</td>
					</tr>
				</table>
			</div>

			<el-input type="textarea" v-model="ordertemp.sysdesc" :rows="4" placeholder="请输入管理员备注" style="margin-top:5rem" @blur="changesysdesc(ordertemp.id,ordertemp.sysdesc)"></el-input>
			
			<!-- 结尾付款 -->
			<div style="float:left;width:98%;padding:.5rem 1%;margin-top:2rem;border-radius:5px;background:rgb(221,221,221,.2)">
				<table border="0" style="float:right;width:100%;font-size:.9rem">
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500">订单合计：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%;font-size:14px;font-weight:550" align="right">{{ordertemp.totals}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">活动减免：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%;font-size:14px;font-weight:550" align="right">{{ordertemp.activeprice}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:70%;" align="right">
							<!--<el-button type="primary" icon="el-icon-plus" circle style="padding:4px;margin-right:1.5rem"></el-button>-->
							<el-tag type="danger" size="mini" closable style="float:right;margin-top:.2rem;margin-right:.3rem" v-for="(item,index) in ordertemp.coupon" :key="index">{{item.msg}}</el-tag>
						</td>
						<td style="float:left;width:18%" align="right">代金券：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%" align="right">{{ordertemp.couponprice}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">优惠金额：</td>
						<td style="float:left;width:2%"></td>
						<td style="float:left;width:11.3%;font-size:14px;font-weight:550" align="right">
							<el-input v-model="ordertemp.derateprice" @blur="changecoupons(ordertemp.id,ordertemp.derateprice,'youhui')"  class="showsetprice"></el-input>
						</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">总计：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%;font-size:14px;font-weight:550" align="right">{{ordertemp.amount}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">运费：</td>
						<td style="float:left;width:2%"></td>
						<td style="float:left;width:11.3%;font-size:14px;font-weight:550" align="right">
							<el-input v-model="ordertemp.express" @blur="changecoupons(ordertemp.id,ordertemp.express,'yunfei')" class="showsetprice"></el-input>
						</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">应付金额：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%;font-size:14px;font-weight:550" align="right">{{ordertemp.prices}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">已付金额：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%;font-size:14px;font-weight:550" align="right">{{ordertemp.base_price}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%;font-size:13px;font-weight:500" align="right">需补/退金额：</td>
						<td style="float:left;width:2%"></td>
						<td style="float:left;width:10%;color:red;font-weight:bold" align="right" v-if="ordertemp.difprice < 0">{{ordertemp.difprice}}</td>
						<td class="tr" style="float:left;width:10%;color:#67C23A;font-size:14px;font-weight:bold" align="right" v-if="ordertemp.difprice >= 0">{{ordertemp.difprice}}</td>
					</tr>
				</table>
			</div>
			<div slot="footer" class="dialog-footer" style="clear:both;text-align:right">
		        <el-button size="small" @click="editorderDialog = false" style="margin-top:30px">取 消</el-button>
				<el-button size="small" type="warning" @click="cannelverify(ordertemp.id)" style="margin-top:30px" v-if="ordertemp.editstatus==1">返回重新修改</el-button>
		        <el-button size="small" type="warning" @click="editverify(ordertemp.id)" style="margin-top:30px" v-if="ordertemp.editstatus==0">提交审核</el-button>
				<el-button size="small" type="success" @click="finishedit(ordertemp.id)" style="margin-top:30px" v-if="ordertemp.editstatus==1">确认审核</el-button>
		    </div>
			</div>

			<!-- 获取新增商品信息列表 -->
			<div :class="addtempgoodDialog ? 'showaddgoods' : 'closeshowaddgoods' ">
				<h class="cover" @click="closeaddtempgoods"></h>
				<div class="addtempgoodsinside" :style="sacgoodsadd">
					<!-- 选择商品 -->
					<div class="selectgoods">
						<p class="title">商品列表</p>
						<el-button type="primary" round size="small" style="float:right;margin-right:2%" :loading="sureaddgoodsloading" @click="ensureselectgoods">确定</el-button>
						<el-button round size="small" style="float:right;margin-right:2%" @click="closeaddtempgoods">取消</el-button>
						<div class="temgoodslists">
							<el-form :inline="true" class="demo-form-inline" size="mini">
								<el-form-item>
									<el-select v-model="selectgoodsquery.brandid" filterable clearable placeholder="按品牌" @change="changeselectgoods">	          
										<el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
											<span style="float: left">{{item.name}}</span>
											<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item ref="productquery">
									<el-input placeholder="sku / 商品名称" v-model="selectgoodsquery.key" clearable @keyup.enter.native="getselectgoods" @blur="getselectgoods" @change="isselectgoodsquerychange=true"></el-input>
								</el-form-item>
							</el-form>

							<el-table :data="selectgoodslists" v-loading="selectgoodsloading">
								<el-table-column label="商品">
									<template slot-scope="scope">
										<div style="float:left;width:60px;height:60px;border:1px solid #dddddd;border-radius:6px;background:#dddddd;display:flex;justify-content:center;align-items:center">
											<img :src="scope.row.thumb" style="width:100%;max-width:85%;max-height:85%;border-radius:6px"/>
										</div>
										<div style="float:left;width:73%;margin-left:2%">
										<span style="float:left;width:87%;margin-left:2%;font-size:.7rem;line-height:1.2rem">{{scope.row.name}}</span><br/>
										<span style="float:left;margin-left:2%;color:#909399;font-size:.7rem;" v-if="scope.row.sku!='' && scope.row.sku!=null">sku：{{scope.row.sku}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="规格" width="110" align="center">
									<template slot-scope="scope">
										<a href="javascript:;" class="showspec specon" @click="getspeclists(scope.row,scope.$index)">{{scope.row.spec}}</a>
									</template>
								</el-table-column>
								<el-table-column label="批发价" prop="sellprice" width="110" align="center"></el-table-column>
								<el-table-column label="零售价" prop="marketprice" width="110" align="center"></el-table-column>
								<el-table-column label="操作" width="100" align="center">
									<template slot-scope="scope">
										<el-button type="success" icon="el-icon-plus" circle size="mini" @click="goodsadd(scope.row)"></el-button>
										<el-button type="danger" icon="el-icon-plus" circle size="mini" @click="giftadd(scope.row)"></el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="block">
							<!--分页begin-->
							<el-pagination
								@size-change="selectgoodspageSizeChange"
								@current-change="selectgoodspageCurrentChange"
								:current-page="selectgoodsquery.p"
								:page-sizes="[10, 20, 50]"
								:page-size="selectgoodsquery.rollpage"
								layout="total, sizes, prev, pager, next, jumper"
								:total="selectgoodsrows">
							</el-pagination>
							<!--分页end-->
							</div>
						</div>
					</div>
					<!-- 选中商品 -->
					<div class="salegoods">
						<p class="title">已选商品（{{selectgoodsadd.length}}个）</p>
						<div class="temgoodslists">
							<el-table :data="selectgoodsadd">
								<el-table-column label="商品">
									<template slot-scope="scope">
										<div style="float:left;width:60px;height:60px;border-radius:6px;background:#dddddd;display:flex;justify-content:center;align-items:center;">
											<img :src="scope.row.thumb" style="border-radius:6px;max-width:85%;max-height:85%"/>
										</div>
										<div style="float:left;width:73%;margin-left:2%">
										<span style="float:left;width:87%;margin-left:2%;font-size:.7rem;line-height:1.2rem">{{scope.row.name}}</span><br/>
										<span style="float:left;margin-left:2%;color:#909399;font-size:.7rem;" v-if="scope.row.spec!=''">规格：{{scope.row.spec}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="数量" width="100" align="center">
									<template slot-scope="scope">
										<el-input-number v-model="scope.row.nums" size="small" :min="1" :max="100000"></el-input-number>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="80" align="center">
									<template slot-scope="scope">
										<el-button type="danger" icon="el-icon-minus" circle size="mini" style="padding:3px" @click="selectgoodsadd.splice(scope.$index,1)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<!-- 赠品 -->
					<div class="giftgoods">
						<p class="title">已选赠品（{{selectgiftadd.length}}个）</p>
						<div class="temgoodslists">
							<el-table :data="selectgiftadd">
								<el-table-column label="商品">
									<template slot-scope="scope">
										<div style="float:left;width:60px;height:60px;border-radius:6px;background:#dddddd;display:flex;justify-content:center;align-items:center;">
											<img :src="scope.row.thumb" style="border-radius:6px;max-width:85%;max-height:85%"/>
										</div>
										<div style="float:left;width:73%;margin-left:2%">
										<span style="float:left;width:87%;margin-left:2%;font-size:.7rem;line-height:1.2rem">{{scope.row.name}}</span><br/>
										<span style="float:left;margin-left:2%;color:#909399;font-size:.7rem;" v-if="scope.row.spec!=''">规格：{{scope.row.spec}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="数量" prop="nums" width="100" align="center">
									<template slot-scope="scope">
										<el-input-number v-model="scope.row.nums" size="small" :min="1" :max="100000"></el-input-number>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="80" align="center">
									<template slot-scope="scope">
										<el-button type="danger" icon="el-icon-minus" circle size="mini" style="padding:3px" @click="selectgiftadd.splice(scope.$index,1)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>

		</el-dialog>

		<!-- 商品规格列表 -->
		<el-dialog title="商品规格信息" :visible.sync="goodsspecDialog" width="40%" top="15vh">
			<el-table :data="goodsspeclists" v-loading="goodsspecloading">
				<el-table-column label="商品">
					<template slot-scope="scope">
						<div style="float:left;width:60px;height:60px;background:#dddddd;border-radius:6px;display:flex;justify-content:center;align-items:center">
							<img :src="scope.row.thumb" style="border-radius:6px;max-width:85%;max-height:85%"/>
						</div>
						<div style="float:left;width:73%;margin-left:2%">
							<span style="float:left;width:87%;margin-left:2%;font-size:.7rem;line-height:1.2rem">{{scope.row.property_name}}</span><br/>
							<span style="float:left;margin-left:2%;color:#909399;font-size:.7rem;" v-if="scope.row.sku!='' && scope.row.sku!=null">sku：{{scope.row.sku}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="批发价" prop="property_price" width="120" align="center"></el-table-column>
				<el-table-column lable="操作" align="center" width="80">
					<template slot-scope="scope">
						<el-button type="success" icon="el-icon-check" circle size="mini" @click="ensurespec(scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<!-- 修改订单信息相关 -->

		<!------------- 订单修改历史记录信息 ----------------->	
	    <el-dialog title="订单修改历史记录" :visible.sync="updatelogdialog" width="95%" top="5vh">
			<div class="logs" v-for="(item,index) in loglists" :key="index" v-loading="editloading">
				<div class="baseinfo">
					<span class="edittype" v-if="item.type==0">改单</span>
					<span class="refundtype" v-if="item.type==1">退货</span>
					<span class="editman">修改人：{{item.editname}}（{{item.editupdate}}）</span>
					<span class="verifyman">审核人：{{item.editverifymanagerid}}（{{item.editverifyupdate}}）</span>
					<span class="logtime">{{item.logtime}}</span>
				</div>
				<div class="old">
					<el-col :span="24">
						<el-col :span="3" v-if="item.type==0" style="font-weight:bold">改单前</el-col>
						<el-col :span="4" v-if="item.type==1" style="font-weight:bold">退货前</el-col>
						<el-col :span="3" v-if="item.type==0">支付方式：{{item.old.base.paytype}}</el-col>
						<el-col :span="3" v-if="item.type==0">订单状态：{{item.old.base.status}}</el-col>
						<el-col :span="3" v-if="item.type==0">是否支付：{{item.old.base.ispay}}</el-col>
						<el-col :span="12" v-if="item.type==0">优惠活动：{{item.old.youhui}}</el-col>
						<el-col :span="3" v-if="item.type==0">订单金额：{{item.old.base.total}}</el-col>
						<el-col :span="3" v-if="item.type==0">优惠减免：{{item.old.base.youhui}}</el-col>
						<el-col :span="3" v-if="item.type==0">额外优惠：{{item.old.base.derate}}</el-col>
						<el-col :span="3" v-if="item.type==0">额外运费：{{item.old.base.express}}</el-col>
						<el-col :span="3" v-if="item.type==0">实付金额：{{item.old.base.prices}}</el-col>

						<el-col :span="4" v-if="item.type==1">支付方式：{{item.old.base.paytype}}</el-col>
						<el-col :span="4" v-if="item.type==1">订单状态：{{item.old.base.status}}</el-col>
						<el-col :span="12" v-if="item.type==1">是否支付：{{item.old.base.ispay}}</el-col>
						<el-col :span="4" v-if="item.type==1">订单金额：{{item.old.base.total}}</el-col>
						<el-col :span="4" v-if="item.type==1">实付金额：{{item.old.base.allprice}}</el-col>
						<el-col :span="4" v-if="item.type==1">已退金额：{{item.old.base.allrefunds}}</el-col>
						<el-col :span="4" v-if="item.type==1">可退金额：{{item.old.base.prices}}</el-col>
					</el-col>

					<table border="0" style="float:left;width:100%;margin-top:1rem;border-bottom:1px dashed #909399">
						<tr style="float:left;width:100%;padding:.1rem 0" v-if="item.type==0">
							<td style="float:left;width:34%">商品信息</td>
							<td style="float:left;width:9%" align="center">数量</td>
							<td style="float:left;width:9%" align="center">单价</td>
							<td style="float:left;width:9%" align="center">折扣（100%）</td>
							<td style="float:left;width:9%" align="center">折后单价</td>
							<td style="float:left;width:9%" align="center">小计</td>
							<td style="float:left;width:9%" align="center">优惠金额</td>
							<td style="float:left;width:9%" align="center">实付小计</td>
						</tr>
						<tr style="float:left;width:100%;padding:.1rem 0" v-if="item.type==1">
							<td style="float:left;width:34%">商品信息</td>
							<td style="float:left;width:9%" align="center">可退数量</td>
							<td style="float:left;width:9%" align="center">价格</td>
							<td style="float:left;width:9%" align="center">小计</td>
						</tr>

						<tr v-for="(tt,ii) in item.old.goods" style="float:left;width:100%;padding:.5rem 0" v-if="item.type==0">
							<td style="float:left;width:34%;display:table-cell;vertical-align:middle" align="left">
								<div style="float:left;width:100%">
									<span style="padding:.1rem .3rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem;" v-if="tt.type==1">CZ</span>
									<span style="padding:.1rem .3rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem" v-if="tt.type==2">JD</span>
									<img :src="tt.thumb" style="float:left;width:10%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
									<div style="float:left;width:81%;margin-left:2%">
										<span style="float:left;width:100%;font-size:.8rem;line-height:1.3rem">{{tt.name}}<i style="font-style:normal" v-if="tt.sku > 0">（sku：{{tt.sku}}）</i><i style="font-style:normal;color:#fff;background:#F56C6C;padding:.1rem .3rem;border-radius:5px;font-size:.7rem;margin-left:2%" v-if="tt.isgift > 0">送</i></span>
										<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.7rem;line-height:1.2rem;margin-top:.2rem">规格：{{tt.spec}}</span><br/>
										<div style="float:left;width:100%;margin-top:.4rem;"><el-tag type="danger" style="float:left;height:20px;line-height:20px;border-color:rgba(245,108,108,.5)" v-if="tt.active!=''">{{tt.active}}</el-tag></div>
									</div>
								</div>
							</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.numbers}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.price}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.discount}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.dis_sell}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.total}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.derate}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.realtotal}}</td>
						</tr>

						<tr v-for="(tt,ii) in item.old.goods" style="float:left;width:100%;padding:.5rem 0" v-if="item.type==1">
							<td style="float:left;width:34%;display:table-cell;vertical-align:middle" align="left">
								<div style="float:left;width:100%">
									<span style="padding:.1rem .3rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem;" v-if="tt.type==1">CZ</span>
									<span style="padding:.1rem .3rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem" v-if="tt.type==2">JD</span>
									<img :src="tt.thumb" style="float:left;width:10%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
									<div style="float:left;width:81%;margin-left:2%">
										<span style="float:left;width:100%;font-size:.8rem;line-height:1.3rem">{{tt.name}}<i style="font-style:normal" v-if="tt.sku > 0">（sku：{{tt.sku}}）</i><i style="font-style:normal;color:#fff;background:#F56C6C;padding:.1rem .3rem;border-radius:5px;font-size:.7rem;margin-left:2%" v-if="tt.isgift > 0">送</i></span>
										<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.7rem;line-height:1.2rem;margin-top:.2rem">规格：{{tt.spec}}</span><br/>
										<div style="float:left;width:100%;margin-top:.4rem;"><el-tag type="danger" style="float:left;height:20px;line-height:20px;border-color:rgba(245,108,108,.5)" v-if="tt.active!=''">{{tt.active}}</el-tag></div>
									</div>
								</div>
							</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.lastnumbers}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.dis_sell}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.total}}</td>
						</tr>
					</table>

				</div>
				<div class="new">
					<el-col :span="24">
						<el-col :span="3" v-if="item.type==0" style="font-weight:bold">改单后</el-col>
						<el-col :span="4" v-if="item.type==1" style="font-weight:bold">退货商品</el-col>
						<el-col :span="3" v-if="item.type==0">支付方式：{{item.news.base.paytype}}</el-col>
						<el-col :span="3" v-if="item.type==0">订单状态：{{item.news.base.status}}</el-col>
						<el-col :span="3" v-if="item.type==0">是否支付：{{item.news.base.ispay}}</el-col>
						<el-col :span="12" v-if="item.type==0">优惠活动：{{item.news.youhui}}</el-col>
						<el-col :span="3" v-if="item.type==0">订单金额：{{item.news.base.total}}</el-col>
						<el-col :span="3" v-if="item.type==0">优惠减免：{{item.news.base.youhui}}</el-col>
						<el-col :span="3" v-if="item.type==0">额外优惠：{{item.news.base.derate}}</el-col>
						<el-col :span="3" v-if="item.type==0">额外运费：{{item.news.base.express}}</el-col>
						<el-col :span="3" v-if="item.type==0">实付金额：{{item.news.base.prices}}</el-col>
						<el-col :span="3" v-if="item.news.base.difprice==0 && item.type==0">需退/补金额：{{item.news.base.difprice}}</el-col>
						<el-col :span="3" v-if="item.news.base.difprice < 0 && item.type==0">需退/补金额：<span style="color:#F56C6C">{{item.news.base.difprice}}</span></el-col>
						<el-col :span="3" v-if="item.news.base.difprice > 0 && item.type==0">需退/补金额：<span style="color:#67C23A">{{item.news.base.difprice}}</span></el-col>
						<el-col :span="3" v-if="item.type==0 && item.pay"><el-button type="warning" size="mini" @click="checkeditpays(item.pay)" round >退款记录</el-button></el-col>
						<el-col :span="4" v-if="item.type==1">支付方式：{{item.news.base.paytype}}</el-col>
						<el-col :span="4" v-if="item.type==1">订单状态：{{item.news.base.status}}</el-col>
						<el-col :span="12" v-if="item.type==1">是否支付：{{item.news.base.ispay}}</el-col>
						<el-col :span="4" v-if="item.type==1">退货商品金额：{{item.news.base.allrefund}}</el-col>
						<el-col :span="4" v-if="item.type==1">协商运费金额：{{item.news.base.express}}</el-col>
						<el-col :span="4" v-if="item.type==1">实退金额：{{item.news.base.prices}}</el-col>
						<el-col :span="4" v-if="item.type==1 && item.news.base.difprice > 0">需退/补金额：<span style="color:#F56C6C">-{{item.news.base.difprice}}</span></el-col>
						<el-col :span="4" v-if="item.type==1 && item.news.base.difprice==0">需退/补金额：<span style="color:#67C23A">{{item.news.base.difprice}}</span></el-col>
						<el-col :span="2" v-if="item.type==1 && item.pay"><el-button type="warning" size="mini" @click="checkeditpays(item.pay)" round >退款记录</el-button></el-col>
					</el-col>

					<table border="0" style="float:left;width:100%;margin-top:1rem;">
						<tr style="float:left;width:100%;padding:.1rem 0" v-if="item.type==0">
							<td style="float:left;width:34%">商品信息</td>
							<td style="float:left;width:9%" align="center">数量</td>
							<td style="float:left;width:9%" align="center">单价</td>
							<td style="float:left;width:9%" align="center">折扣（100%）</td>
							<td style="float:left;width:9%" align="center">折后单价</td>
							<td style="float:left;width:9%" align="center">小计</td>
							<td style="float:left;width:9%" align="center">优惠金额</td>
							<td style="float:left;width:9%" align="center">实付小计</td>
						</tr>
						<tr style="float:left;width:100%;padding:.1rem 0" v-if="item.type==1">
							<td style="float:left;width:34%">商品信息</td>
							<td style="float:left;width:9%" align="center">退货数量</td>
							<td style="float:left;width:9%" align="center">价格</td>
							<td style="float:left;width:9%" align="center">小计</td>
							<td style="float:left;width:9%" align="center">实退金额</td>
						</tr>

						<tr v-for="(tt,ii) in item.news.goods" style="float:left;width:100%;padding:.5rem 0" v-if="item.type==0">
							<td style="float:left;width:34%;display:table-cell;vertical-align:middle" align="left">
								<div style="float:left;width:100%">
									<span style="padding:.1rem .3rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem;" v-if="tt.type==1">CZ</span>
									<span style="padding:.1rem .3rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem" v-if="tt.type==2">JD</span>
									<img :src="tt.thumb" style="float:left;width:10%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
									<div style="float:left;width:81%;margin-left:2%">
										<span style="float:left;width:100%;font-size:.8rem;line-height:1.3rem">{{tt.name}}<i style="font-style:normal" v-if="tt.sku > 0">（sku：{{tt.sku}}）</i><i style="font-style:normal;color:#fff;background:#F56C6C;padding:.1rem .3rem;border-radius:5px;font-size:.7rem;margin-left:2%" v-if="tt.isgift > 0">送</i></span>
										<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.7rem;line-height:1.2rem;margin-top:.2rem">规格：{{tt.spec}}</span><br/>
										<div style="float:left;width:100%;margin-top:.4rem;"><el-tag type="danger" style="float:left;height:20px;line-height:20px;border-color:rgba(245,108,108,.5)" v-if="tt.active!=''">{{tt.active}}</el-tag></div>
									</div>
								</div>
							</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.numbers}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.price}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.discount}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.dis_sell}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.total}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.derate}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.realtotal}}</td>
						</tr>

						<tr v-for="(tt,ii) in item.news.goods" style="float:left;width:100%;padding:.5rem 0" v-if="item.type==1">
							<td style="float:left;width:34%;display:table-cell;vertical-align:middle" align="left">
								<div style="float:left;width:100%">
									<span style="padding:.1rem .3rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem;" v-if="tt.type==1">CZ</span>
									<span style="padding:.1rem .3rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;line-height:1.2rem;font-style:normal;margin:-.6rem" v-if="tt.type==2">JD</span>
									<img :src="tt.thumb" style="float:left;width:10%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
									<div style="float:left;width:81%;margin-left:2%">
										<span style="float:left;width:100%;font-size:.8rem;line-height:1.3rem">{{tt.name}}<i style="font-style:normal" v-if="tt.sku > 0">（sku：{{tt.sku}}）</i><i style="font-style:normal;color:#fff;background:#F56C6C;padding:.1rem .3rem;border-radius:5px;font-size:.7rem;margin-left:2%" v-if="tt.isgift > 0">送</i></span>
										<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.7rem;line-height:1.2rem;margin-top:.2rem">规格：{{tt.spec}}</span><br/>
										<div style="float:left;width:100%;margin-top:.4rem;"><el-tag type="danger" style="float:left;height:20px;line-height:20px;border-color:rgba(245,108,108,.5)" v-if="tt.active!=''">{{tt.active}}</el-tag></div>
									</div>
								</div>
							</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.numbers}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.dis_sell}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.total}}</td>
							<td style="float:left;width:9%;display:table-cell;vertical-align:middle" align="center">{{tt.realrefundprices}}</td>
						</tr>	


					</table>					

				</div>
			</div>

			<div slot="footer" class="dialog-footer" style="clear:both;">
		        <el-button size="small" @click="updatelogdialog = false" style="margin-top:30px">取 消</el-button>
		    </div>
		</el-dialog>

		<!-- 退货 -->
		<el-dialog title="商品退货" :visible.sync="refundgoodsDialog" width="75%" top="5vh">
			<el-col :span="24" style="font-size:.8rem;margin-bottom:.5rem;text-align:right;margin-bottom:1rem;padding-bottom:.5rem;float:left;border-bottom:1px dashed rgb(221,221,221,.7)">
				<el-button type="danger" icon="el-icon-setting" size="mini" round @click="resettemprefundlists" v-if="refundgoodslists.editstatus==0">重新加载商品信息</el-button>
			</el-col>
			<div class="ordertempgoods" style="float:left;width:98%;border-bottom:1px dashed rgb(221,221,221,.7);padding:.5rem 0" v-loading="refundgoodsloading">
				<table border="0" style="width:100%;">
					<tr style="float:left;width:96%;padding:.1rem 2% .1rem 2%">
						<td style="float:left;width:48%">商品信息</td>
						<td style="float:left;width:10%" align="center">数量</td>
						<td style="float:left;width:10%" align="center">单价</td>
						<td style="float:left;width:10%" align="center">小计</td>
						<td style="float:left;width:10%" align="center">实退小计</td>
						<td style="float:left;width:10%" align="center">操作</td>
					</tr>
					<tr v-for="(tt,ii) in refundgoodslists.goods" style="float:left;width:96%;padding:.5rem 2% .5rem 2%">
						<td style="float:left;width:48%" align="left">
							<div style="float:left;width:100%">
								<i style="padding:.1rem .4rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;font-style:normal;margin:-.6rem;" v-if="tt.type==1">CZ</i>
								<i style="padding:.1rem .4rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.7rem;font-style:normal;margin:-.6rem" v-if="tt.type==2">JD</i>
								<img :src="tt.thumb" style="float:left;width:12%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
								<div style="float:left;width:81%;margin-left:2%">
									<span style="float:left;width:100%;font-size:.8rem;line-height:1.3rem">{{tt.productname}}<i style="font-style:normal" v-if="tt.sku > 0">（sku：{{tt.sku}}）</i></span>
									<span style="float:left;width:100%;color:rgb(144, 147, 153);font-size:.7rem;line-height:1.2rem;margin-top:.2rem">规格：{{tt.spec}}</span>
								</div>
							</div>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-input v-model="tt.numbers" class="temelinputinner" @blur="changerefundparam(refundgoodslists.id,tt.id,tt.productid,tt.propertyid,tt.numbers,'edit')"></el-input>
						</td>
						<td style="float:left;width:10%" align="center">
							<span>{{tt.price}}</span>
						</td>
						<td style="float:left;width:10%" align="center">
							<span>{{tt.total}}</span>
						</td>
						<td style="float:left;width:10%" align="center">
							<span>{{tt.refundprice}}</span>
						</td>
						<td style="float:left;width:10%" align="center">
							<el-button type="danger" size="mini" circle icon="el-icon-minus" style="padding:3px" @click="changerefundparam(refundgoodslists.id,tt.id,tt.productid,tt.propertyid,0,'del')"></el-button>
						</td>
					</tr>
				</table>
			</div>
			<div style="float:left;width:98%;padding:.5rem 1%;margin-top:2rem;border-radius:5px;background:rgb(221,221,221,.2)">
				<table border="0" style="float:right;width:100%;font-size:.9rem">
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%">可退金额合计：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%" align="right">{{refundgoodslists.allprice}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%" align="right">商品应退金额合计：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%" align="right">{{refundgoodslists.allrefund}}</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%" align="right">协商扣减运费：</td>
						<td style="float:left;width:2%"></td>
						<td style="float:left;width:11.3%" align="right">
							<el-input v-model="refundgoodslists.express" @blur="changerefundexpress(refundgoodslists.id,refundgoodslists.express)" class="showsetprice"></el-input>
						</td>
					</tr>
					<tr style="float:left;width:100%;text-align:right">
						<td style="float:left;width:60%"></td>
						<td style="float:left;width:28%" align="right">实际应退金额合计：</td>
						<td style="float:left;width:2%"></td>
						<td class="tr" style="float:left;width:10%" align="right">{{refundgoodslists.prices}}</td>
					</tr>
				</table>
			</div>

			<div slot="footer" class="dialog-footer" style="clear:both;">
		        <el-button size="small" @click="updatelogdialog = false" style="margin-top:30px">取 消</el-button>
				<el-button size="small" type="warning" @click="cannelrefundverify(refundgoodslists.id)" style="margin-top:30px" v-if="refundgoodslists.editstatus==1">返回重新修改</el-button>
		        <el-button size="small" type="warning" @click="editrefundverify(refundgoodslists.id)" style="margin-top:30px" v-if="refundgoodslists.editstatus==0">提交审核</el-button>
				<el-button size="small" type="success" @click="finishrefundedit(refundgoodslists.id)" style="margin-top:30px" v-if="refundgoodslists.editstatus==1">确认审核</el-button>
		    </div>
		</el-dialog>

		<!-- 改单退货说明 -->
		<el-dialog title="改单/退货说明" :visible.sync="showordernoticeDialog" width="35%" top="10vh">
			<div style="float:left;width:100%">
				<span style="float:left;font-size:.8rem;width:100%;margin-bottom:.5rem">未支付未发货的订单信息可以随意修改</span>
				<span style="float:left;font-size:.8rem;width:100%;margin-bottom:.5rem">已支付未发货的订单信息商品可以随意修改，但修改后的应付金额不能大于已付金额（支付宝不支持同一个订单付款2次）</span>
				<span style="float:left;font-size:.8rem;width:100%;margin-bottom:.5rem">已支付已发货的京东商品信息，不能修改，只能退货</span>
				<span style="float:left;font-size:.8rem;width:100%;margin-bottom:.5rem">已支付已发货的宠赞商品信息修改后，会将原来的出库单信息进行覆盖</span>
				<span style="float:left;font-size:.8rem;width:100%;margin-bottom:.5rem">已支付已发货的宠赞商品信息修改后，会将原来的出库单信息进行覆盖</span>
				<span style="float:left;font-size:.8rem;width:100%;margin-bottom:.5rem">订单若出现有商品退货则不允许再对订单进行改单</span>
				<span style="float:left;font-size:.8rem;width:100%">客户未签收的订单不允许对订单进行商品退货</span>
			</div>
			<div slot="footer" class="dialog-footer" style="clear:both;">
		        <el-button size="small" @click="showordernoticeDialog = false" style="margin-top:30px">取 消</el-button>
		    </div>
		</el-dialog>

		<!-- 支付信息记录 -->
		<el-dialog title="支付信息记录" :visible.sync="paylogsDialog" width="35%" top="10vh">
			<div style="float:left;width:100%;padding:.3rem">支付金额：{{payinfos.total_fee}}</div>
			<div style="float:left;width:100%;padding:.3rem">是否支付：{{payinfos.status}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付状态：{{payinfos.isused}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付用途：{{payinfos.subject}}</div>
			<div style="float:left;width:100%;padding:.3rem">商城提交支付单号：{{payinfos.out_trade_no}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付方订单号：{{payinfos.payment_trade_no}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付成功通知时间：{{payinfos.payment_notify_time}}</div>
			<div slot="footer" class="dialog-footer" style="clear:both;">
		        <el-button size="small" @click="paylogsDialog = false" style="margin-top:30px">取 消</el-button>
		    </div>
		</el-dialog>

		<!-- 支付信息记录 -->
		<el-dialog title="退款信息记录" :visible.sync="editorderpayDialog" width="35%" top="10vh">
			<div style="float:left;width:100%;padding:.3rem">支付金额：{{editpays.total_fee}}</div>
			<div style="float:left;width:100%;padding:.3rem">是否支付：{{editpays.status}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付状态：{{editpays.isused}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付用途：{{editpays.subject}}</div>
			<div style="float:left;width:100%;padding:.3rem">商城提交支付单号：{{editpays.out_trade_no}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付方订单号：{{editpays.payment_trade_no}}</div>
			<div style="float:left;width:100%;padding:.3rem">支付成功通知时间：{{editpays.payment_notify_time}}</div>
			<div slot="footer" class="dialog-footer" style="clear:both;">
		        <el-button size="small" @click="paylogsDialog = false" style="margin-top:30px">取 消</el-button>
		    </div>
		</el-dialog>


		<!-- 设置物流信息 -->
		<el-dialog title="设置物流信息" :visible.sync="settingshippingDialog" width="65%" top="10vh">
			<div class="sendandreciever" v-loading="settingshippingloading">
				<div class="shippingcodeinfos">
				   <span class="shippingde">快递名称：{{shippingquery.shippingname}}（{{shippingquery.shippingcode}}）</span>
				   <span :class="shippingquery.status==0 ? 'red shippingde' : 'green shippingde' ">状态：{{shippingquery.status==0 ? '未生成电子面单' : '已生成电子面单' }}</span>
				   <span class="shippingde">快递单号：{{shippingquery.logisticscode}}</span>
				   <el-button type="primary" size="mini" circle icon="el-icon-search" style="float:right" :disabled="shippingquery.status==0 ? false : true" @click="getallshippinglists"></el-button>
				</div>
				<div class="sendandrecieverdetails">
					<div class="senderinfos">
						<div class="sendtitle">
							寄件
							<el-button type="primary" size="mini" circle icon="el-icon-search" style="float:right" :disabled="shippingquery.status==0 ? false : true" @click="getsenderlists"></el-button>
						</div>
						<span class="sendcontent">寄件人：{{shippingquery.sendname}}</span>
						<span class="sendcontent">联系电话：{{shippingquery.sendphone}}</span>
						<span class="sendcontent">联系地址：{{shippingquery.sendProvincename}}-{{shippingquery.sendCityname}}-{{shippingquery.sendArea}}</span>
						<span class="sendcontent">详细地址：{{shippingquery.sendAddress}}</span>
					</div>
					<div class="recieverinfos">
						<div class="recivertitle">
							收件
							<el-button type="primary" size="mini" circle icon="el-icon-search" style="float:right" :disabled="shippingquery.status==0 ? false : true" @click="getrecieverlists"></el-button>
						</div>
						<span class="recivercontent">收件人：{{shippingquery.recievename}}</span>
						<span class="recivercontent">联系电话：{{shippingquery.recievephone}}</span>
						<span class="recivercontent">联系地址：{{shippingquery.recieveProvincename}}-{{shippingquery.recieveCityname}}-{{shippingquery.recieveArea}}</span>
						<span class="recivercontent">详细地址：{{shippingquery.recieveAddress}}</span>
					</div>
				</div>
				<div class="sendgoods">
					<div class="sendgoodstitle">发货商品</div>
					<div class="sendgoodslists" v-for="(item,index) in shippingquery.goods" :key="index">
						<div class="sendgis">
							<img :src="GLOBAL.staticUrl+item.thumb" />
							<span class="sendgoodsname">{{item.productname}}<i v-if="item.isgift==1">赠送</i></span>
							<span class="sendgoodsnum">{{item.numbers}}</span>
							<span class="sendgoodspec">规格：{{item.propertyname}}</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="settingshippingDialog = false" :disabled="shippingquery.status==0 ? false : true">取 消</el-button>
              <el-button size="small" type="primary" @click="saveshippinginfos" :disabled="shippingquery.status==0 ? false : true">保 存</el-button>
			  <el-button size="small" type="primary" @click="pringshipping" :disabled="shippingquery.status==0 ? true : false">打 印</el-button>
          	</div>
		</el-dialog>

		<!-- 查看快递信息 -->
		<el-dialog title="查看快递信息" :visible.sync="shipDialog" width="50%" top="10vh">
		    <el-table :data="shippinglists" v-loading="shiploading">
		      	<el-table-column prop="shippingname" label="快递名称"></el-table-column>
				<el-table-column prop="shippingcode" label="快递编号" align="center"></el-table-column>
				<el-table-column prop="numbers" label="单号总余量 / 剩余余量" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
                  		<el-button type="success" size="mini" icon="el-icon-check" circle @click="selectships(scope.row)"></el-button>
                  	</template>
				</el-table-column>
		    </el-table>
		</el-dialog>

		<!-- 查看寄件人 -->
		<el-dialog title="查看寄件人信息" :visible.sync="senderDialog" width="55%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" size="mini">
				<el-form-item>
					<el-input placeholder="请输入关键字" v-model="senderquery.key" @keyup.enter.native.prevent="getsenderlistsdata" clearable @change="senderquery.ischange=true"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" circle @click="getsenderlistsdata"></el-button>
					<el-button type="danger" icon="el-icon-plus" circle @click="addsender"></el-button>
				</el-form-item>
			</el-form>
		    <el-table :data="senderlists" v-loading="senderquery.loading">
		      	<el-table-column prop="name" label="发货人名称"></el-table-column>
				<el-table-column prop="phone" label="手机号" align="left" width="150"></el-table-column>
				<el-table-column label="地址" align="left" width="280">
					<template slot-scope="scope">
                  		<span style="float:left;width:100%">{{scope.row.province}}-{{scope.row.city}}-{{scope.row.area}}</span>
						<span style="float:left;width:100%">{{scope.row.address}}</span>
                  	</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="140">
					<template slot-scope="scope">
						<el-button type="success" size="mini" icon="el-icon-check" circle @click="getsender(scope.row)"></el-button>
						<el-button type="warning" size="mini" icon="el-icon-edit" circle @click="editsender(scope.row)"></el-button>
						<el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delsender(scope.row)"></el-button>
					</template>
				</el-table-column>
		    </el-table>
			<div class="block">
		      <!--分页begin-->
		      <el-pagination 
			  	  @size-change="senderpageSizeChange" 
				  @current-change="senderpageCurrentChange"
		      	  :current-page="senderquery.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="senderquery.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="senderrows">
		      </el-pagination>
		      <!--分页end-->
	      	</div>
		</el-dialog>

		<!-- 新增 / 编辑寄件人 -->
		<el-dialog title="新增/编辑寄件人信息" :visible.sync="addsenderDialog" width="30%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" size="mini">
				<el-form-item label="寄件人" label-width="120">
					<el-input placeholder="请输入关键字" v-model="addsenderquery.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="手机号" label-width="120">
					<el-input placeholder="请输入关键字" v-model="addsenderquery.phone" clearable></el-input>
				</el-form-item>
				<el-form-item label="所在省份：" label-width="120">
					<el-select v-model="addsenderquery.provinceid" clearable remote  filterable placeholder="请选择省份" @change="changeprovince">	            
					<el-option v-for="(item,index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
					</el-select>          
				</el-form-item>
				<el-form-item label="所在城市：" label-width="120" v-if="citylists.length > 0">
					<el-select v-model="addsenderquery.cityid" clearable remote  filterable placeholder="请选择城市" @change="changecity">	            
					<el-option v-for="(item,index) in citylists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
					</el-select>          
				</el-form-item>
				<el-form-item label="所在区域/县：" label-width="120" v-if="arealists.length > 0">
					<el-select v-model="addsenderquery.areaid" clearable remote  filterable placeholder="请选择区域/县" @change="changearea">	            
					<el-option v-for="(item,index) in arealists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
					</el-select>          
				</el-form-item>
				<el-form-item label="详细地址" label-width="120">
					<el-input placeholder="请输入详细地址" v-model="addsenderquery.address" clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addsenderDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="saveaddsender">保 存</el-button>
          	</div>
		</el-dialog>


		<!-- 查看收件人 -->
		<el-dialog title="查看寄件人信息" :visible.sync="recieverDialog" width="55%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" size="mini">
				<el-form-item>
					<el-input placeholder="请输入关键字" v-model="recieverquery.key" @keyup.enter.native.prevent="getrecieverlistsdata" clearable @change="recieverquery.ischange=true"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" circle @click="getrecieverlistsdata"></el-button>
					<el-button type="danger" icon="el-icon-plus" circle @click="addreciever"></el-button>
				</el-form-item>
			</el-form>
		    <el-table :data="recieverlists" v-loading="recieverquery.loading">
		      	<el-table-column prop="name" label="发货人名称"></el-table-column>
				<el-table-column prop="phone" label="手机号" align="left" width="150"></el-table-column>
				<el-table-column label="地址" align="left" width="280">
					<template slot-scope="scope">
                  		<span style="float:left;width:100%">{{scope.row.province}}-{{scope.row.city}}-{{scope.row.area}}</span>
						<span style="float:left;width:100%">{{scope.row.address}}</span>
                  	</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="140">
					<template slot-scope="scope">
						<el-button type="success" size="mini" icon="el-icon-check" circle @click="getreciever(scope.row)"></el-button>
						<el-button type="warning" size="mini" icon="el-icon-edit" circle @click="editreciever(scope.row)"></el-button>
						<el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delreciever(scope.row)"></el-button>
					</template>
				</el-table-column>
		    </el-table>
			<div class="block">
		      <!--分页begin-->
		      <el-pagination
			  	  @size-change="recieverpageSizeChange" 
			  	  @current-change="recieverpageCurrentChange"
		      	  :current-page="recieverquery.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="recieverquery.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="recieverrows">
		      </el-pagination>
		      <!--分页end-->
	      	</div>
		</el-dialog>

		<!-- 新增 / 编辑寄件人 -->
		<el-dialog title="新增/编辑收件人信息" :visible.sync="addrecieverDialog" width="30%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" size="mini">
				<el-form-item label="收件人" label-width="120">
					<el-input placeholder="请输入关键字" v-model="addrecieverquery.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="手机号" label-width="120">
					<el-input placeholder="请输入关键字" v-model="addrecieverquery.phone" clearable></el-input>
				</el-form-item>
				<el-form-item label="所在省份：" label-width="120">
					<el-select v-model="addrecieverquery.provinceid" clearable remote  filterable placeholder="请选择省份" @change="changeprovince">	            
					<el-option v-for="(item,index) in provincelists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
					</el-select>          
				</el-form-item>
				<el-form-item label="所在城市：" label-width="120" v-if="citylists.length > 0">
					<el-select v-model="addrecieverquery.cityid" clearable remote  filterable placeholder="请选择城市" @change="changecity">	            
					<el-option v-for="(item,index) in citylists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
					</el-select>          
				</el-form-item>
				<el-form-item label="所在区域/县：" label-width="120" v-if="arealists.length > 0">
					<el-select v-model="addrecieverquery.areaid" clearable remote  filterable placeholder="请选择区域/县" @change="changearea">	            
					<el-option v-for="(item,index) in arealists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						<span style="float: left">{{item.name}}</span>
					</el-option>              
					</el-select>          
				</el-form-item>
				<el-form-item label="详细地址" label-width="120">
					<el-input placeholder="请输入详细地址" v-model="addrecieverquery.address" clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addrecieverDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="saveaddreciever">保 存</el-button>
          	</div>
		</el-dialog>


		<!-- 快递电子面单打印 -->
		<el-dialog title="电子面单打印模板" :visible.sync="shippingprintDialog" top="10vh">
			<div id="shippingprinttemp" class="shippingprinttemp">
				<div style="width:100%;height:50px"><img src="../../assets/bskd.jpg" style="float:left;width:39%"/></div>
				<div class="printtime">{{shippingquery.localtime}}</div>
				<div class="codeout"><img id="shippingbarcode" style="float:left;width:60%;margin-left:20%;padding:5px 0"/></div>
				<div class="sourse">
					<span class="sourse-left">{{shippingquery.OriginCode}}</span>
					<span class="sourse-right">{{shippingquery.SortingCode}}</span>
				</div>
				<div class="sourse">
					<span class="sourse-left">集</span>
					<span class="sourse-right">{{shippingquery.PackageCode}}</span>
				</div>
				<div class="shippingsender">
					<div class="senderlogo">收</div>
					<div class="senderright">
						<span class="sendername">{{shippingquery.recievename}}</span>
						<span class="senderphone">{{shippingquery.recievephone}}</span>
						<span class="senderaddress">{{shippingquery.recieveProvincename}} {{shippingquery.recieveCityname}} {{shippingquery.recieveArea}} {{shippingquery.recieveAddress}}</span>
					</div>
				</div>
				<div class="shippingreciever">
					<div class="recieverleft">
						<div class="recieverlogo">寄</div>
						<span class="recievername">***</span>
						<span class="recieverphone">{{shippingquery.sendphone}}</span>
					</div>
					<div class="recievercenter">
						<div class="ercode" ref="ercodeinfos" ></div>
					</div>
					<div class="recieverright">
						<div class="recieverrighttop">
							<span>已验视</span>
							<span>已安检</span>
						</div>
						<div class="recieverrightbottom">
							<span>签字栏</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="shippingprintDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="printlocalpage">确 定</el-button>
          	</div>
		</el-dialog>


		<!-- 设置快递信息 -->
		<el-dialog title="设置快递信息" :visible.sync="getlogisticsDialog" top="25vh" width="26%">
			<el-form :inline="true" size="mini">
				<el-form-item label="快递类型" label-width="100">
					<el-select v-model="setlogisticsquery.shippingid" clearable remote  filterable placeholder="请选择快递类型">	            
						<el-option v-for="(item,index) in otherlogistics" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>              
					</el-select>
				</el-form-item>
				<el-form-item label="快递单号" label-width="100">
					<el-input v-model="setlogisticsquery.logistics" clearable placeholder="请填写快递单号"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
              <el-button size="small" @click="getlogisticsDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="submitshippings">确 定</el-button>
          	</div>
		</el-dialog>


		<!-- 第三方非宠赞为数据中心的账号发货时强行弹出填写物流信息框 -->
		<el-dialog title="设置快递信息" :visible.sync="noczsendquery.dialog" top="25vh" width="26%">
			<div style="display:inline-block;width:100%" v-loading="noczsendquery.loading">
			<el-form :inline="true" size="mini">
				<el-form-item label="快递类型" label-width="100">
					<el-select v-model="noczsendquery.noczlogisticsid" clearable remote  filterable placeholder="请选择快递类型">	            
						<el-option v-for="(item,index) in otherlogistics" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>              
					</el-select>
				</el-form-item>
				<el-form-item label="快递单号" label-width="100">
					<el-input v-model="noczsendquery.noczlogistciscode" clearable placeholder="请填写快递单号"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px">
              <el-button size="small" @click="noczsendquery.dialog = false">取 消</el-button>
              <el-button size="small" type="primary">确 定</el-button>
          	</div>
			</div>
		</el-dialog>


		<!-- 仅退款 / 退货退款记录 -->
		<el-dialog title="仅退款 / 退后退款记录" :visible.sync="orderrefundDialog" top="5vh" width="60%">
			<div class="mall-order-refund-log-out" style="display:inline-block;width:100%" v-loading="orderrefundloading">
				<div class="main-order-refund-log-infos" v-for="(item,index) in orderrefundlists" :key="index" v-if="orderrefundlists.length > 0" style="display:inline-block;width:calc(100% - 20px);padding:10px;border-radius:6px;background:#F2F6FC">
					<div class="main-order-refund-log-infos-msg" style="float:left;width:100%;">
						<div class="main-order-refund-log-infos-msg-content" style="float:left;font-size:13px;line-height:25px;margin-right:5%">售后类型：{{item.refundtype==1 ? '仅退款' : '退款退货'}}</div>
						<div class="main-order-refund-log-infos-msg-content" style="float:left;font-size:13px;line-height:25px;margin-right:5%">售后单号：{{item.order_sn}}</div>
						<div class="main-order-refund-log-infos-msg-content" style="float:left;font-size:13px;line-height:25px;margin-right:5%">
							发起时机：
							<span v-if="item.order_status==0">待确认</span>
							<span v-if="item.order_status==1">已发货，待签收</span>
							<span v-if="item.order_status==2">已发货，待确认</span>
							<span v-if="item.order_status==3">已发货，待确认</span>
							<span v-if="item.order_status==4">已确认，待发货</span>
							<span v-if="item.order_status==5">已签收，待完成</span>
							<span v-if="item.order_status==11">已完成</span>		
						</div>
						<div class="main-order-refund-log-infos-msg-content" style="float:left;font-size:13px;line-height:25px;margin-right:5%">发起时间：{{item.inputtime}}</div>
						<div class="main-order-refund-log-infos-msg-content" style="float:left;font-size:13px;line-height:25px;margin-right:5%">退款金额：<i style="font-style:normal;color:red;font-weight:bold">￥{{item.refundprices}}</i></div>
						<div class="main-order-refund-log-infos-msg-content" style="float:left;font-size:13px;line-height:25px;margin-right:5%">退款时间：{{item.refundtime}}</div>
					</div>
					<div class="main-order-refund-log-details" style="float:left;width:100%;padding:10px 0;">
						<div class="main-order-refund-log-details-names" style="float:left;width:50%;height:60px">
							<div class="main-order-refund-log-details-names-img" style="float:left;width:60px;height:60px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;display:flex;justify-content:center;align-items:center">
								<img :src="item.thumb" style="max-width:85%;max-height:85%;border-radius:6px" />
							</div>
							<div class="main-order-refund-log-details-names-name" style="float:left;width:calc(100% - 62px - 2%);margin-left:2%;font-size:13px;line-height:23px">{{item.productname}}</div>
							<div class="main-order-refund-log-details-names-spec" style="float:left;width:calc(100% - 62px - 2%);margin-left:2%;font-size:12px;line-height:23px;color:#999999">{{item.propertyname}}</div>
						</div>
						<div class="main-order-refund-log-details-prices" style="float:left;width:20%;height:60px;margin-left:2%;display:flex;justify-content:center;align-items:center;font-size:13px">
							￥{{item.price}}
						</div>
						<div class="main-order-refund-log-details-prices" style="float:left;width:20%;height:60px;margin-left:2%;display:flex;justify-content:center;align-items:center;font-size:13px">
							{{item.numbers}}
						</div>
					</div>
				</div>
				<div class="main-order-refund-log-infos-no" v-if="orderrefundlists.length == 0" style="width:100%;height:100px;display:flex;justify-content:center;align-items:center">
					<img src="../../assets/history_gray.png" style="width:30px;height:30px"/>
                	<div class="main-order-refund-log-infos-no-content" style="font-size:14px;margin-left:2%">订单还没有退货记录</div>
				</div>
			</div>
		</el-dialog>



		<!-- 打印模块 -->
		<el-dialog title="设置快递信息" :visible.sync="showshippinginfosDialog" top="4vh" width="100%" height="100%" :beforeClose="closeshipping">
			<Shippings  v-model="shippingorderid" :orderinfos="shippingorders" @finish="closeshippingDialog"/>
		</el-dialog>
		
		<!-- 查看快递信息 -->
		<el-dialog title="查看快递信息" :visible.sync="myshippingDialog" top="10vh" width="70%" height="100%" :beforeClose="closemyshipping">
			<Showshipping  v-model="myorderid" :ordertype="myordertype" @finish="closemyshippingDialog"/>
			<div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px">
                <el-button size="small" @click="myshippingDialog = false">取 消</el-button>
          	</div>
		</el-dialog>

		<!-- 上传快递信息 -->
		<el-dialog title="上传快递信息" :visible.sync="shippinginputDialog" top="4vh" width="40%" :beforeClose="closeinputs">
			<Inputs v-model="shippinginputview" @finish="closeshippinginputDialog"/>
		</el-dialog>

		<!-- 批量发货弹窗 -->
		 <el-dialog title="系统提醒" :visible.sync="batchshippingDialog" top="5vh" width="400px"> 
			<div>
				<span>您勾选的</span>
				<span style="color: red;">{{ selections.length }}</span>
				<span>个订单中含有</span>
				<span style="color: red;"> 非【已确认，待发货】状态 </span>
				<span>的订单</span>
				<span style="color: red;">{{  selections.length - shippingList.length  }}</span>
				<span>个，满足条件订单是否批量发货？</span>
			</div>
			<div slot="footer">
				<el-button size="small" @click="batchshippingDialog = false">取 消</el-button>
				<el-button size="small" type="primary" :loading="shippingListLoading" @click="shippingSubmit">确 认</el-button>
			</div>
		 </el-dialog>
   		
	</div>
	</transition>     
</template>

<script>
import QRCode from 'qrcodejs2'
import Shippings from '@/components/mall/shipping/shippings' //快递模块
import Showshipping from '@/components/mall/shipping/showshipping' //查看快递信息
import Inputs from '@/components/mall/shipping/input' //上传快递单信息
export default {
	components: {QRCode,Shippings,Showshipping,Inputs},
    data () {
        return {
			wangdian_sid: this.$cookies.get('wangdian_sid'),
        	actionauth:'', //功能权限
      	    transitionshow:true,
            url: this.GLOBAL.domain+"Order/index",
            
        	paytype:[{id:1,name:'支付宝'},{id:7,name:'微信'},{id:20,name:'汇付天下-支付宝'},{id:21,name:'汇付天下-微信'}],
        	ispaylists:[{id:1,name:'已支付'},{id:2,name:'未支付'}],
        	tagshow:'true',
        	orderstatus: [
				{id:1,name:'待确认'},	
				{id:2,name:'已确认，待发货'},
				{id:3,name:'已发货，待签收'},	
				{id:4,name:'已签收，待完成'},
				{id:5,name:'已完成'},
				{id:6,name:'商家取消订单'},	
				{id:7,name:'买家取消订单'},
				{id:8,name:'改单中...'},		
				{id:10,name:'售后中'},		
      	    ],
        	
        	orderLoading:false,
        	orderlists:[],
			searchlists:[{id:1,name:'下单时间'},{id:2,name:'支付时间'}],
        	total_rows:0,
			searchtype:[{id:1,name:'按订单号 / 客户名称 / 客户电话'},{id:2,name:'按京东发货单号'},{id:3,name:'按第三方物流单号'}],
            query: {
                act: 'lists',
                paytype:'',
				ispay:'',
                status:'',
				mark_status: '',
                type: 2,
				clerkid:'',
                token: this.$cookies.get('token'),
                date: [],
				searchtype:1,
				ordersourse:'',
				key:'',
                p: 1,
                rollpage: 10
            },
            isjdshow:false,
            noticeDialog:false,
            cannelorderid:'',
            cannelDialog:false,
      	    cannelLoading:false,
      	    reason:'',
      	    localorder:[], //当前订单信息
      	    orderid: '', //订单id
      	    create:{
	            act:'add',
	            token:this.$cookies.get('token'),
	            deliverdate:'',
	            account:'',
	            documents:'',
	            note:'',
	            total:'0.00',
	            derate:'0.00',
	            seller:'',
	            customer:'',
	            sysmanager:'',
	            sysmanagername:'',
	            contactname:'',
	            contactphone:'',
	            address:'',
	            isout:0, //订单发货开关
	            paytype:'', //支付方式
	            orderid:'',
	            goods:[],
				agentid:'',
      	    },
      	    customerName: '', //客户名称
      	    clerkName: '', //销售员
      	    documents:'',
      	    selectclerkDialog:false, //选择职员
      	    clerks:[], //选择销售员列表
      	    sysmanagers:[], //经手人列表
      	    printerDialog:false,
      	    printsmodel:[],
      	    createsaveLoading:false,
      	    printlists: {
      	    	customerName:'',
      	    	deliverdate:'',
      	    	documents:'',
      	    	account:'',
      	    	clerkName:'',
      	    	note:'',
      	    	contactname:'',
      	    	contactphone:'',
      	    	address:'',
      	    	allnumber:'',
      	    	cost:'',
      	    	createtime:'',
      	    	cheap:'',
      	    	total:'',
      	    	sysmanagername:'',
      	    	goods:[]
      	    },
			packdialog:false,
			packdialogloading:false,
			packlists:[],
      	    jdmoneys:[],
			sendorders:[],
			sendDialog:false,
			sendgoodsLoading:false,
			sendtypelists:[],
			sendtype:0,
			pushDialog:false,
			pushLoading:false,
			pushlists:[{id:1,name:"短信推送"},{id:2,name:"微信推送"}],

			pushquery:{
	            act:'addpush',
	            token:this.$cookies.get('token'),
				truename:'',
				contact:'',
				type:'',
      	    },
			addpushDialog:false,
			pushloading:false,
			pushlists:[],
			ischange:false,
			defaultclerk: {
				id:'',
				name:'',
			},
			orderexportdata:[{id:1,name:'导出订单列表'},{id:2,name:'导出订单明细'},{id:3,name:'导出订单明细（财务）'},{id:4,name:'导出金蝶销售单模板数据'}],
			
			changepayDialog:false,
			sellerLists:[],
			accountLists:[],
			changepayquery: {
				act:'saveispay',
				token:this.$cookies.get('token'),
				id:'',
				account:'',
				seller:'',
				amount:'',
				desc:''
			},
			activeDialog:false,
			showactivelists:[],
			outlistsputDialog:false,
			outlistsLoading:false,
			outexportlists:[],
			outdetailsputDialog:false,
			outdetailsLoading:false,
			outexportdetails:[],
			exporthead:[],
			exportfield:[],
			exportlists:[],
			exportname:'',
			settingclerkDialog:false,
			settingclerkorderid:'',
			settingclerkid:'',
			shopinfoDialog:false,
			shopinfos:[],
			center:'',
			zoom:'',
			autoLocationPoint: '',
			initLocation:false,
			mapLoading:false,
			showdays:'',
			days:'',
			daysDialog:false,
			editorderDialog:false,
			ordertempquery: {
				act:'geteditorderinfos',
				token:this.$cookies.get('token'),
				id:'',
				type:1,
				isreset:0,
			},
			ordertemp:[],
			editgoodsloading:false,
			goodssort: [
				{id:1,name:'按供应商'},
				{id:2,name:'按品牌'},
			],
			addtempgoodDialog:false,
			sacgoodsadd: {'margin-left':'-80%'},
			isselectgoodsquerychange:false,
			selectgoodsquery: {
				act:'geteditordergoods',
				token:this.$cookies.get('token'),
				brandid:'',
				key:'',
				p:1,
				rollpage:10,
			},
			selectgoodsloading:false,
			selectgoodsrows:0,
			selectgoodslists:[],
			brandlists:[],
			selectspecindex:'',
			goodsspeclists:[],
			goodsspecloading:false,
			goodsspecDialog:false,
			selectgoodsadd:[],
			selectgiftadd:[],
			sureaddgoodsloading:false,
			nowtime:0,
			timeoutflag:true,
			updatelogdialog:false,
			loglists:[],
			editloading:false,
			refundgoodsDialog:false,
			refundgoodsloading:false,
			refundgoodslists:[],
			refundquery: {
				act:'getrefundorderinfo',
				id:'',
				isreset:0,
				token:this.$cookies.get('token'),
			},
			showordernoticeDialog:false,
			paylogsDialog:false,
			paylogloading:false,
			payinfos:[],
			editorderpayDialog:false,
			editpays:{
				total_fee:'',
				status:'',
				payment_trade_status:'',
				isused:'',
				subject:'',
				out_trade_no:'',
				payment_trade_no:'',
				payment_notify_time:''
			},
			shippinglists:[],
			settingshippingDialog:false,
			settingshippingloading:false,
			shippingquery: {
				act:'saveshipping',
				token:this.$cookies.get('token'),
				orderid:'',
				parentagentid:'',
				shippingid:'',
				shippingname:'',
				shippingcode:'',
				logisticscode:'',
				status:'',
				senderid:'',
				sendname:'',
				sendphone:'',
				sendProvincename:'',
				sendCityname:'',
				sendArea:'',
				sendAddress:'',
				recieverid:'',
				recievename:'',
				recievephone:'',
				recieveProvincename:'',
				recieveCityname:'',
				recieveArea:'',
				recieveAddress:'',
				note:'宠物用品',
				localtime:'',
				OriginCode:'',
				SortingCode:'',
				PackageCode:'',
				goods:[],
			},
			shipDialog:false,
			shiploading:false,
			senderDialog:false,
			senderquery: {
				act:'getsenderlists',
				token:this.$cookies.get('token'),
				loading:false,
				ischange:false,
				key:'',
				p:1,
				rollpage:10,
			},
			senderlists:[],
			senderrows:0,
			addsenderDialog:false,
			addsenderquery: {
				act:'addsender',
				token:this.$cookies.get('token'),
				id:'',
				name:'',
				phone:'',
				provinceid:'',
				cityid:'',
				areaid:''
			},

			recieverDialog:false,
			recieverquery: {
				act:'getrecieverlists',
				token:this.$cookies.get('token'),
				loading:false,
				ischange:false,
				key:'',
				p:1,
				rollpage:10,
			},
			recieverlists:[],
			recieverrows:0,
			addrecieverDialog:false,
			addrecieverquery: {
				act:'addreciever',
				token:this.$cookies.get('token'),
				id:'',
				name:'',
				phone:'',
				provinceid:'',
				cityid:'',
				areaid:''
			},


			provincequery: {
				act:'getjdcityinfos',
				token:this.$cookies.get('token'),
			},
			provincelists:[],
			cityquery: {
				act:'getjdcityinfos',
				token:this.$cookies.get('token'),
				parentid:'',
			},
			citylists:[],
			areaquery: {
				act:'getjdcityinfos',
				token:this.$cookies.get('token'),
				parentid:'',
			},
			arealists:[],
			shippingprintDialog:false,
			codeurl:'',
			localprintshipping:'',
			ordersourselists:[
				{id:1,name:'app商城订单'},
				{id:2,name:'跑店小程序订单'},
				{id:3,name:'PC采购订单'},
				{id:4,name:'一件代发订单'},
			],

			otherlogistics:[],
			getlogisticsDialog:false,
			setlogisticsquery: {
				act:'saveshipping_old',
				token:this.$cookies.get('token'),
				orderid:'',
				parentagentid:'',
				shippingid:'',
				logistics:'',
			},
			sendloading:false,
			datacenter:'',
			iskingdee:'',
			sellstatuslists:[{id:1,name:'未审核'},{id:2,name:'已审核，待完成'}],
			sendsellstatus:1,

			noczsendquery: {
				 act:'noczSendgoods',
				 id:"",
				 token:this.$cookies.get('token'),
				 dialog:false,
				 loading:false,
				 noczlogisticsid:'',
				 noczlogistciscode:'',
			},
			isshowsysorder1:true,
			isshowsysorder2:true,
			ispayeditauth:false,

			showshippinginfosDialog:false,
			shippingorderid:'',
			shippingorders:'',

			myshippingDialog:false,
			myorderid:'',
			shippinginputDialog:false,
			shippinginputview:false,

			orderrefundDialog:false,
			orderrefundlists:[],
			orderrefundloading:false,
			myordertype:'mall',

			delgoodslists:[],
			specialordernums:0,
			batchshippingDialog: false,
			selections: [],
			shippingList: [],
			shippingListLoading: false,
        }  
    },
  
    mounted(){
    	this.getJDshow(); //获取是否接入京东数据权限
		this.getagentcenter(); //获取代理商所使用的数据中心
		this.getiskingdee(); //获取代理商是否具有金蝶同步数据权限
		this.searchorder(); //获取订单信息详情
		this.getactionauth(); //获取功能权限
		this.getClerk(); //获取销售员列表信息
		this.getdefaultclerk(); //获取默认销售员信息
		this.getSysmanager(); //获取操作人信息
		this.getprintsmodel(); //获取打印信息设置
		this.getjdlastmoney();  //获取京东进货备用金额
		this.getSeller();  //获取销售员信息
	  	this.getAccount();  //获取收款账号
		this.setgetgoodsdata(); //获取默认签收时长
		this.getBrand();  //获取商品品牌
		this.getallshippinglogistics(); //获取所有物流快递信息

		this.getdefaultsellstatus(); //获取默认发货生成的销售出库单的状态
		this.getispayeditauth(); //获取是否有已支付的订单的改单权限（普通代理商已支付的订单不可修改）
		this.specialordernumbers(); //获取特批单数量信息 
		
    },
  
    methods:{
		checkInventory(row) {
			// Order/index   act:evrify_inventory  参数：order_id
			// console.log(row, '************)')
			// return
			var resource = this.$resource(this.url);
			resource.save({act:'evrify_inventory', order_id: row.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					let listStr = ''
					result.forEach((item, index) => {
						listStr += '<div>' + item.name + '<span class="q-label">欠 <i class="q-num">' + item.num +  '</i></span></div>'
					})
					if (result.length > 0) {
						const htmlStr = '<div><div class="subtitle">当前订单的商品库存不足：</div>' + 
						listStr + 
						'</div>'
						this.$alert(htmlStr, '系统提示', {
							dangerouslyUseHTMLString: true,
							callback: action => {
								this.searchorder()
							}
						}, )
					} else {
						this.searchorder()
					}
				}
			}).catch((res) => {
					
			});
		},

		//查看审批单信息
		verifyspecialorder() {
			this.$emit('listenchild',{name:'特批单审核',url:'OrderVerify',data:[]});
		},


		//获取特批单数量信息
		specialordernumbers() {
			var resource = this.$resource(this.url);
			resource.save({act:'getverifyordernums',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.specialordernums=result.counts > 0 ? result.counts : 0;
				}
			}).catch((res) => {
					
			});
		},


		////////////////////////////////////
		/** 勾选订单 **/
		goodsselectchange(val,row) {
			// var number=this.delgoodslists.indexOf(row.id);
			// number==-1 ? this.delgoodslists.push(row.id) : this.$delete(this.delgoodslists,number);

			// 查找当前行的索引
			const idIndex = this.delgoodslists.indexOf(row.id);
			
			if (val.includes(row)) { // 选中操作
				// 添加id到delgoodslists（如果不存在）
				if (idIndex === -1) {
					this.delgoodslists.push(row.id);
				}
				// 添加完整行数据到selections（如果不存在）
				const existsInSelections = this.selections.some(item => item.id === row.id);
				if (!existsInSelections) {
					this.selections.push(row);
				}
			} else { // 取消选中操作
				// 从delgoodslists中移除
				if (idIndex > -1) {
					this.delgoodslists.splice(idIndex, 1);
				}
				// 从selections中移除
				const selectionIndex = this.selections.findIndex(item => item.id === row.id);
				if (selectionIndex > -1) {
					this.selections.splice(selectionIndex, 1);
				}
			}

		},

		/** 勾选/取消勾选全部订单 **/
		goodsallselectchange(val) {
			// var _this=this;
			// var number=-1;
			// if(val.length > 0) { //新增商品
			// 	this.selections = val
			// 	val.forEach(function(item,i) {
			// 		number=_this.delgoodslists.indexOf(item.id);
			// 		number==-1 ? _this.delgoodslists.push(item.id) : '';
			// 	});

			// }else { //删除订单
			// 	this.selections = []
			// 	this.orderlists.forEach(function(item,i) {
			// 		number=_this.delgoodslists.indexOf(item.id);
			// 		number > -1 ? _this.$delete(_this.delgoodslists,number) : '';
			// 	});
			// }

			const currentPageIds = this.orderlists.map(item => item.id);
  
			if (val.length > 0) { // 当前页全选
				val.forEach(row => {
				// 添加id到delgoodslists（如果不存在）
				if (!this.delgoodslists.includes(row.id)) {
					this.delgoodslists.push(row.id);
				}
				// 添加完整行数据到selections（如果不存在）
				const exists = this.selections.some(item => item.id === row.id);
				if (!exists) {
					this.selections.push(row);
				}
				});
			} else { // 取消当前页全选
				currentPageIds.forEach(id => {
				// 从delgoodslists中移除当前页ID
				const idIndex = this.delgoodslists.indexOf(id);
				if (idIndex > -1) {
					this.delgoodslists.splice(idIndex, 1);
				}
				// 从selections中移除当前页数据
				const selectionIndex = this.selections.findIndex(item => item.id === id);
				if (selectionIndex > -1) {
					this.selections.splice(selectionIndex, 1);
				}
				});
			}
		},
		shippingSubmit() {
			console.log(this.shippingList, '待发货列表')
			const ids = this.shippingList.map(item => item.id)
			var resource = this.$resource(this.url);
			this.shippingListLoading = true
			const act = this.datacenter != 'cz' ? 'nocz_batch_shipment' : 'batch_shipment'

			resource.save({act, token:this.$cookies.get('token'), orderids: ids.join(',')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					// 发货成功呢？
					this.batchshippingDialog = false
					this.$message.success('订单批量发货成功!');
					this.shippingList = []
					this.clearorderselect()
				}
			})
			.finally(() => {
				this.shippingListLoading = false
			})

		},

		/** 清除已选中的订单信息 **/
		clearorderselect() {
			this.delgoodslists = [];
			this.selections = [];
			this.shippingList = []
			this.searchorder();
		},

		/** 批操作 **/
		handleordermore(type) {
			// if(type==1) this.delordermores(); //批量删除订单
			const number = +type
			switch(number) {
				case 1: //批量删除订单
					this.delordermores(); 
					break;
				case 2: //批量发货
					// 过滤this.selections中，status==4的数据
					const result = this.selections.filter(item => item.status == 4 && item.isedit == 0)
					this.shippingList = result
					
					this.batchshippingDialog = true;
					break;
			}
		},

		//批量删除订单
		delordermores() {
		    if(this.delgoodslists.length==0) {this.$message.error("请选择要删除的订单");return false;}
			this.$confirm('已选中的订单删除之后将不可恢复， 是否继续?', '警告', {type:'warning',confirmButtonText:'删除',cancelButtonText:'再想想'}).then(() => {
                
				var resource = this.$resource(this.GLOBAL.domain+"Order/index");
				resource.save({act:'delorders',ids:this.delgoodslists.join(","),token:this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.delgoodslists=[];
						this.query.p=1;
						this.query.rollpage=10;
						this.searchorder();
					}
				}).catch((res) => {
					
				});
                
            }).catch(() => {
              
            });
		},

		/////////////////////////////////////



		/** 查看退货信息 **/
		orderrefunds(id) {
			this.orderrefundDialog=true;
			this.orderrefundlists=[];
			this.orderrefundloading=true;

			var resource = this.$resource(this.GLOBAL.domain+"Order/index");
			resource.save({act:'getorderrefundlogs',id:id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.orderrefundloading=false;
				}else{
					this.orderrefundlists = JSON.parse(Base64.decode(res.data.Data));
					this.orderrefundloading=false;
				}
			}).catch((res) => {
				this.orderrefundloading=false;
			});

		},


		closeinputs() {
			this.$confirm('你是否要放弃上传订单快递的设置', '提示', { type: 'warning' }).then(() => {
				this.shippinginputDialog=false;
				this.shippinginputview=false;
			}).catch(() => {
              
          	});
		},

		closeshippinginputDialog() {
			this.shippinginputDialog=false;
			this.shippinginputview=false;
		},


		closeshippingDialog(param) {
			this.shippingorderid='';
			this.showshippinginfosDialog=false;
		},
		closeshipping() {
			this.$confirm('你是否要放弃订单快递的设置', '提示', { type: 'warning' }).then(() => {
                this.shippingorderid='';
				this.showshippinginfosDialog=false;
			}).catch(() => {
              
          	});

		},


		/** 查看订单物流信息 **/
		getpackshippings(id) {
			this.myorderid=id;
			this.myshippingDialog=true;
		},
		closemyshippingDialog() {
			this.myorderid='';
			this.myshippingDialog=false;
		},
		closemyshipping() {
			this.myorderid='';
			this.myshippingDialog=false;
		},


		/** 获取代理商是否有已支付但未完成的订单的改单权限 **/
		getispayeditauth() {
			var resource = this.$resource(this.GLOBAL.domain+"Order/index");
			resource.save({act:'iseditispay',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					result.ispayeditauth==0 ? this.ispayeditauth=false : this.ispayeditauth=true;
				}
			}).catch((res) => {
					
			});
		},


		/** 修改默认发货时生成的销售出库单的状态 **/
		changedefaultsellstatus() {
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
			resource.save({act:'changedefaultsellstatus',status:this.sendsellstatus,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					
				}
			}).catch((res) => {
					
			});
		},

		/** 获取发货时默认生成的销售出库单的状态 **/
		getdefaultsellstatus() {
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
			resource.save({act:'getdefaultsellstatus',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.sendsellstatus=result.sendsellstatus;
				}
			}).catch((res) => {
					
			});
		},


		/** 获取代理商是否具有金蝶同步数据权限 **/
		getiskingdee() {
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
			resource.save({act:'getiskingdee',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.iskingdee=result.iskingdee;
				}
			}).catch((res) => {
					
			});
		},

		/** 获取代理商所使用的数据中心 **/
		getagentcenter() {
			var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
			resource.save({act:'getdatacenter',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.datacenter=result.datacenter;
				}
			}).catch((res) => {
					
			});
		},

		//查看支付记录
		checkpaylogs(item) {
			this.payinfos=[];
			var resource = this.$resource(this.url);
			resource.query({act:'getpaylogs',token:this.$cookies.get('token'),id:item.id}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.paylogsDialog=true;
					this.payinfos=JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				
			});
		},


		/********************************** 订单信息修改 *************************************************/
		//提交可退商品信息审核
		cannelrefundverify(id) {
			var resource = this.$resource(this.url);
			resource.query({act:'cannelrefundverify',token:this.$cookies.get('token'),id:id}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.getrefundgoods();
				}else{
					this.getrefundgoods();             
				}
			}).catch((res) => {
				
			});
		},

		//提交可退商品信息审核
		editrefundverify(id) {
			var resource = this.$resource(this.url);
			resource.query({act:'editrefundverify',token:this.$cookies.get('token'),id:id}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.getrefundgoods();
				}else{
					this.getrefundgoods();             
				}
			}).catch((res) => {
				
			});
		},

		//完成可退商品信息审核
		finishrefundedit(id) {
			this.$confirm('温馨提示：您是否已检查过退货商品信息，并退回客户差额？', '提示', { type: 'warning' }).then(() => {
        	    var resource = this.$resource(this.url);
				resource.query({act:'finishrefundedit',token:this.$cookies.get('token'),id:id}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
						this.getrefundgoods();
					}else{
						this.refundgoodsDialog=false;
						this.searchorder();             
					}
				}).catch((res) => {
					
				});

            }).catch(() => {
                
            });
		},

		//修改商品可退数量
		changerefundparam(ordertempid,infoid,productid,propertyid,param,type,goodstype) {
			var resource = this.$resource(this.url);
			resource.query({act:'changerefundparam',token:this.$cookies.get('token'),ordertempid:ordertempid,infoid:infoid,productid:productid,propertyid:propertyid,data:param,type:type}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.getrefundgoods();
				}else{
					this.getrefundgoods();             
				}
			}).catch((res) => {
				
			});
		},

		//修改退货商品快递费
		changerefundexpress(ordertempid,express) {
			var resource = this.$resource(this.url);
			resource.query({act:'changerefundexpress',token:this.$cookies.get('token'),ordertempid:ordertempid,express:express}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.getrefundgoods();
				}else{
					this.getrefundgoods();             
				}
			}).catch((res) => {
				
			});
		},
		
		//获取当前订单信息
		editorders(item) {
			this.$confirm('温馨提示：订单修改过程中不允许对订单进行取消、确定，退货，完成等操作，您确认要对该订单信息进行修改吗？', '提示', { type: 'warning' }).then(() => {
        	    this.ordertemp=[];
				this.editorderDialog=true;	
				this.ordertempquery.id=item.id;
				this.ordertempquery.type=1;
				this.ordertempquery.isreset=0;
				this.gettemporders();
            }).catch(() => {
                
            });
		},

		//获取退货商品信息
		refundordergoods(item) {
			this.$confirm('温馨提示：订单退货过程中不允许对订单进行取消、确定，改单，完成等操作，您确认要对该订单信息进行修改吗？', '提示', { type: 'warning' }).then(() => {
				this.refundquery.id=item.id;
				this.getrefundgoods();
            }).catch(() => {
                
            });
		},

		//获取退货商品数据信息
		getrefundgoods() {
			this.refundgoodsDialog=true;
			this.refundgoodsloading=true;
			var resource = this.$resource(this.url);
			resource.query(this.refundquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.refundgoodsloading=false;
				}else{
					this.refundgoodslists = JSON.parse(Base64.decode(res.data.Data));
					this.refundgoodsloading=false;                  
				}
			}).catch((res) => {
				this.refundgoodsloading=false;
			});

		},

		//重置退货商品信息
		resettemprefundlists() {
			this.$confirm('温馨提示：该操作会将当前所编辑的订单信息放弃，重新加载订单信息，您是否确定要放弃当前编辑的订单信息？', '提示', { type: 'warning' }).then(() => {
        	    this.refundquery.isreset=1;
				this.getrefundgoods();
				this.refundquery.isreset=0;
            }).catch(() => {
                
            });

		},


		//调整当前订单商品信息排序
		changegoodssort() {
			this.gettemporders();
		},

		//获取当前正在修改的订单信息
		gettemporders() {
			this.editgoodsloading=true;
			var resource = this.$resource(this.url);
			resource.query(this.ordertempquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.editgoodsloading=false;
				}else{
					this.ordertemp = JSON.parse(Base64.decode(res.data.Data));
					console.log(this.ordertemp);
					this.editgoodsloading=false;                    
				}
			}).catch((res) => {
				//this.$message.error(this.GLOBAL.errortext);
				this.editgoodsloading=false;
			});
		},

		//关闭窗口
		closeaddtempgoods() {
			var _this=this;
			this.sacgoodsadd['margin-left']='-100%';
			setTimeout(function() {_this.addtempgoodDialog=false;},300);
		},

		//获取商品信息
		addtempgoodslists() {
			var _this=this;
			this.addtempgoodDialog=true;
			setTimeout(function() {_this.sacgoodsadd['margin-left']='0%';},100);

			this.selectgoodsquery.brandid='';
			this.selectgoodsquery.isreset=0;
			this.selectgoodsquery.key='';
			this.selectgoodsquery.p=1;
			this.selectgoodsquery.rollpage=10;
			this.selectgoodsadd=[];
			this.selectgiftadd=[];
			this.getselectgoods();
		},

		//重新加载获取商品信息
		resettempgoodslists() {
			this.$confirm('温馨提示：该操作会将当前所编辑的订单信息放弃，重新加载订单信息，您是否确定要放弃当前编辑的订单信息？', '提示', { type: 'warning' }).then(() => {
        	    this.ordertemp=[];	
				this.ordertempquery.isreset=1;
				this.gettemporders();
				this.ordertempquery.isreset=0;
            }).catch(() => {
                
            });
		},

		//获取品牌
		getBrand(){
			var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
			resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:100000}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.brandlists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
					
			});
		},

		//变更信息
		changeselectgoods() {
			this.isselectgoodsquerychange=true;
			this.getselectgoods();
		},

		//获取所选择的商品信息数据
		getselectgoods() {
			if(this.isselectgoodsquerychange==true) {
				this.selectgoodsquery.p=1;
				this.selectgoodsquery.rollpage=10;
			}

			this.selectgoodsloading=true;
			var resource = this.$resource(this.url);
	        resource.query(this.selectgoodsquery).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.selectgoodsloading=false;
		        }else{
		            this.selectgoodslists = JSON.parse(Base64.decode(res.data.Data));
		            this.selectgoodsrows=parseInt(res.data.count);
		            if(this.isselectgoodsquerychange==true) this.isselectgoodsquerychange=false;	
					this.selectgoodsloading=false;                      
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
				this.selectgoodsloading=false;
	        });
		},

		selectgoodspageSizeChange(val) {
        	this.selectgoodsquery.rollpage = val;
        	this.getselectgoods();
		},
		selectgoodspageCurrentChange(val) {
			this.selectgoodsquery.p = val;
			this.getselectgoods();
		},

		//获取商品规格信息列表
		getspeclists(item,index) {
			this.selectspecindex=index;
			this.goodsspeclists=[];
			this.goodsspecDialog=true;
			this.goodsspecloading=true;

			var resource = this.$resource(this.url);
	        resource.query({act:'getselectgoodsspeclists',token:this.$cookies.get('token'),id:item.id}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.goodsspecloading=false;
		        }else{
		            this.goodsspeclists = JSON.parse(Base64.decode(res.data.Data));
					this.goodsspecloading=false;                     
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
				this.goodsspecloading=false;
	        });
		},

		//选择规格信息
		ensurespec(item) {
			var index=this.selectspecindex;
			this.selectgoodslists[index].sellprice=item.property_price;
			this.selectgoodslists[index].spec=item.property_name;
			this.selectgoodslists[index].propertyid=item.id;
			this.selectgoodslists[index].sku=item.sku;
			this.selectgoodslists[index].thumb=item.thumb;
			this.goodsspecDialog=false;
		},

		//新增在售商品信息
		goodsadd(item) {
			var number=-1;
			var _this=this;
			this.selectgoodsadd.forEach(function(t,i) {
				if(t.id==item.id && t.propertyid==item.propertyid) number=i;
			});

			if(number >= 0) {
				var nums=Number(this.selectgoodsadd[number].nums)+Number(1);
				this.selectgoodsadd[number].nums = nums;
				this.selectgoodsadd[number].total=this.selectgoodsadd[number].sellprice*nums;
			}else {
				this.selectgoodsadd.push({id:item.id,productid:item.productid,name:item.name,spec:item.spec,sellprice:item.sellprice,sku:item.sku,thumb:item.thumb,type:item.type,propertyid:item.propertyid,nums:1,total:item.sellprice});
			}
		},

		//新增赠品信息
		giftadd(item) {
			var number=-1;
			var _this=this;
			this.selectgiftadd.forEach(function(t,i) {
				if(t.id==item.id && t.propertyid==item.propertyid) number=i;
			});

			if(number >= 0) {
				var nums=Number(this.selectgiftadd[number].nums)+Number(1);
				this.selectgiftadd[number].nums = nums;
				this.selectgiftadd[number].total=this.selectgiftadd[number].sellprice*nums;
			}else {
				this.selectgiftadd.push({id:item.id,productid:item.productid,name:item.name,spec:item.spec,sellprice:item.sellprice,sku:item.sku,thumb:item.thumb,type:item.type,propertyid:item.propertyid,nums:1,total:item.sellprice});
			}
		},

		//确认将选中的商品、赠品添加到订单信息里
		ensureselectgoods() {
			this.sureaddgoodsloading=true;
			var resource = this.$resource(this.url);
	        resource.save({act:'saveeditgoodsandgift',token:this.$cookies.get('token'),id:this.ordertempquery.id,goodsdata:this.selectgoodsadd,giftsdata:this.selectgiftadd}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.sureaddgoodsloading=false;
		        }else{
					this.sureaddgoodsloading=false;      
					//关闭窗口
					this.closeaddtempgoods();
					//刷新当前改单页面的数据
					this.gettemporders();               
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
				this.sureaddgoodsloading=false;
	        });
		},


		/** 修改商品信息 **/
		changeparam(index,id,goodsid,propertyid,data,type,checktype) {
			//检测是否满足信息然后返回相应的提示由用户决定是否修改
			var resource = this.$resource(this.url);
	        resource.save({act:'checkeditordergcp',token:this.$cookies.get('token'),checktype:checktype,goodstype:index,tempid:id,goodsid:goodsid,propertyid:propertyid,data:data,type:type}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.gettemporders();
		        }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
		            if(result.msg.length>0) {
						this.$confirm('此操作会影响：'+result.msg+'，您是否需要执行？', { type: 'warning' }).then(() => {
							resource.save({act:'savechangeorderparam',token:this.$cookies.get('token'),checktype:checktype,goodstype:index,tempid:id,goodsid:goodsid,propertyid:propertyid,data:data,type:type}).then((res) => {
								if(res.data.Result>0){
									if(res.data.Result=='70001') this.$router.push('/login')
									this.$message.error(res.data.Message);
									this.gettemporders();
								}else{
									this.gettemporders();
								}
							}).catch((res) => {
								this.gettemporders();
							});							

						}).catch(() => {
							this.gettemporders();
						});   
					}else {
						resource.save({act:'savechangeorderparam',token:this.$cookies.get('token'),checktype:checktype,goodstype:index,tempid:id,goodsid:goodsid,propertyid:propertyid,data:data,type:type}).then((res) => {
							if(res.data.Result>0){
								if(res.data.Result=='70001') this.$router.push('/login')
								this.$message.error(res.data.Message);
								this.gettemporders();
							}else{
								this.gettemporders();
							}
						}).catch((res) => {
							this.gettemporders();
						});			

					}

		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
		},

		//删除活动信息
		delactive(id) {
			var resource = this.$resource(this.url);
			resource.save({act:'delactive',token:this.$cookies.get('token'),activeid:id}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.gettemporders();
				}
			}).catch((res) => {
				
			});	
		},

		//修改备注信息
		changesysdesc(id,sysdesc) {
			var resource = this.$resource(this.url);
	        resource.save({act:'savesysdesc',token:this.$cookies.get('token'),id:id,data:sysdesc}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.gettemporders();              
		        }
	        }).catch((res) => {

	        });
		},

		//返回重新审核
		cannelverify(id) {
			this.editgoodsloading=true;
			var resource = this.$resource(this.url);
	        resource.save({act:'canneleditverify',token:this.$cookies.get('token'),id:id}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.editgoodsloading=false;
		        }else{
		            this.gettemporders();    
					this.editgoodsloading=false;          
		        }
	        }).catch((res) => {
				this.editgoodsloading=false;
	        });
		},

		//订单提交审核
		editverify(id) {
			this.editgoodsloading=true;
			var resource = this.$resource(this.url);
	        resource.save({act:'editverify',token:this.$cookies.get('token'),id:id}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.editgoodsloading=false;
		        }else{
		            this.gettemporders();    
					this.editgoodsloading=false;          
		        }
	        }).catch((res) => {
				this.editgoodsloading=false;
	        });
		},

		//完成审核
		finishedit(id) {
			this.$confirm('温馨提示：您是否已检查过修改后的订单信息并同意将其覆盖到旧的订单上，并返还客户差额？', '提示', { type: 'warning' }).then(() => {
        	    this.editgoodsloading=true;
				var resource = this.$resource(this.url);
				resource.save({act:'finishedit',token:this.$cookies.get('token'),id:id}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
						this.editgoodsloading=false;
					}else{
						this.editorderDialog=false;
						this.searchorder();    
						this.editgoodsloading=false;          
					}
				}).catch((res) => {
					this.editgoodsloading=false;
				});

            }).catch(() => {
                
            });
		},

		//修改优惠金额、运费信息
		changecoupons(id,price,type) {
			var resource = this.$resource(this.url);
	        resource.save({act:'editderateorexpress',token:this.$cookies.get('token'),id:id,price:price,type:type}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
					this.gettemporders();         
		        }else{
		            this.gettemporders();              
		        }
	        }).catch((res) => {
				this.gettemporders();         
	        });
		},

		/********************************** 订单信息修改 *************************************************/

		/** 获取销售员 **/
	    getSeller(){
	        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
		            //默认选择第一个销售员
		            if(this.sellerLists!='') this.changepayquery.seller=this.sellerLists[0]['id'];	                      
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },

		/** 获取银行帐户 **/
	    getAccount(){
	        var resource = this.$resource(this.GLOBAL.domain+"Account/index");
	        resource.query({act:'lists',isdeposit:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.accountLists = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	    },


        /** 关闭消息提示 **/
        closetag() {
	  	    this.tagshow='false';
	    },
	    
	    /** 获取打印信息设置 **/
	    getprintsmodel() {
	  	    var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	        resource.query({ act:'getmodelsetting',id:4,token:this.$cookies.get('token')}).then((res) => {
		  	    if(res.data.Result>0){
		      	    if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
	    },
	    
	    //获取功能权限
		getactionauth() {
			var data =this.$cookies.get('actionauth');
		    data=JSON.parse(data);
		    this.actionauth=data;
		},
		
		//查询是否开启调用京东商品数据权限
		getJDshow() {
			var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	        resource.query({act:'getJDshow',token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
		            this.isjdshow=result.show;
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},
	    
	    /** 搜索订单信息 **/
  	    searchorder() {
		    if(this.ischange==true) {
				this.query.p=1;
				this.query.rollpage=10;
			}

  	        this.orderLoading = true; //开启提成预加载动画
  	        this.query.act='lists';
  	        var resource = this.$resource(this.url);
	        resource.save(this.query).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login');
		            this.orderLoading = false; //关闭加载动画
		            this.$message.error(res.data.Message);
		        }else{
					this.orderlists = JSON.parse(Base64.decode(res.data.Data));
					console.log(this.orderlists, 'ppppppppppppppppppppppppppppppp');
		            this.total_rows=parseInt(res.data.count);
		            this.orderLoading = false; //关闭加载动画
					if(this.ischange==true) this.ischange=false;

					var _this=this;
					setTimeout(function() {
						_this.orderlists.forEach(function(e,index){  
							_this.delgoodslists.indexOf(e.id) >=0 ? _this.$refs.goodsmultipleTable.toggleRowSelection(e) : '';
						});
					},200);  

					//取消跑店小程序的信息提示
					this.$emit('cannelnotice',2);

		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	            this.orderLoading = false; //关闭加载动画
	        });
  	    },
  	    
  	    /** 下一页 **/
  	    orderpageSizeChange(val) {
  	        this.query.rollpage = val;
            this.searchorder();
  	    },
  	    /** 下一页 **/
  	    orderpageCurrentChange(val) {
  	        this.query.p = val;
            this.searchorder();
  	    },
  	    
  	    
  	    /** 发货前的订单确认 **/
        sureGoods(obj) {
		    var truename=obj.truename=='' ? obj.shopname : obj.truename;
      	    this.$confirm('温馨提示：确认订单之前请致电：'+obj.phone+'，与客户：'+truename+' 核对订单信息，您是否已核对过订单信息 ?', '提示', { type: 'warning' }).then(() => {
        	    // 向请求服务端删除
                var resource = this.$resource(this.url);
                resource.save({ act:'sureorder',id: obj.id,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                    this.searchorder();
	                }else{
			            this.searchorder();
	                    this.$message.success('确认订单成功!');
	                }
                }).catch((res) => {
            	    
                });
            }).catch(() => {
                this.$message.info('已取消操作!');
            });
        },

		
		/** 第三方非宠赞系统发货界面 **/
		/**
		noczSendgoods(item) {
			this.noczsendquery.id=item.id;
			this.noczsendquery.dialog=true;
			this.noczsendquery.noczlogisticsid='';
			this.noczsendquery.noczlogistciscode='';
		},
		*/

		/** 第三方发货界面发货操作 **/
		/**
		noczSendgoodsadd() {
			this.$confirm('您是否要对该订单进行发货 ?', '提示', { type: 'warning' }).then(() => {
        	    // 向请求服务端删除
				this.noczsendquery.loading=true;
                var resource = this.$resource(this.url);
                resource.save(this.noczsendquery).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
						this.noczsendquery.loading=false;
	                }else{
						this.noczsendquery.loading=false;
						this.$message.success('订单发货成功!');
						this.noczsendquery.dialog=false;
			            this.searchorder();
	                }
                }).catch((res) => {
            	    this.noczsendquery.loading=false;
                });
            }).catch(() => {
                
            });
		},
		*/


		/** 第三方发货界面发货操作 **/
		noczSendgoods(item) {
			this.noczsendquery.id=item.id;
			this.noczsendquery.noczlogisticsid='';
			this.noczsendquery.noczlogistciscode='';
			this.$confirm('您是否要对该订单进行发货 ?', '提示', { type: 'warning' }).then(() => {
        	    // 向请求服务端删除
                var resource = this.$resource(this.url);
                resource.save(this.noczsendquery).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
						this.$message.success('订单发货成功!');
			            this.searchorder();
	                }
                }).catch((res) => {
            	    
                });
            }).catch(() => {
                
            });
		},


          
        /** 保存订单信息 **/
        saveclerk() {	     		  
      	    this.create.act="checkprint";
            var resource = this.$resource(this.url);
            resource.query(this.create).then((res) => {
	            if(res.data.Result>0){
	            	if(res.data.Result=='70001') this.$router.push('/login')
	            	this.$message.error(res.data.Message);
	            }else{
					this.selectclerkDialog=false;
	      	    	//获取打印的商品信息
	      	    	this.getprinterGoods(this.orderid,this.sendtype);      
	            }
            }).catch((res) => {
                this.$message.error(this.GLOBAL.errortext);
            });
        },
        
        /** 查看当前订单 **/
        getprintorder(obj) {        
        	//选择职员信息
	      	this.localorder=obj;
	      	this.orderid=obj.id;
	      	this.create.orderid=obj.id;
	      	//获取客户名称
	      	this.getCustomerName(this.orderid);
	      	this.create.seller=this.clerks[0]['id'];
	      	//获取销售员名称
	      	this.getClerkName(this.create.seller);
	      	//联系人姓名
	      	this.create.contactname=obj.truename;
	      	//联系电话
	      	this.create.contactphone=obj.phone;
	      	//联系地址
	      	this.create.address=obj.address;
	      	//获取支付方式
	      	this.create.paytype=obj.paytype;
			
	      	//单据编号
	      	this.setDocuments();
	      	this.create.note=this.localorder.note;        	  	  
      	  	this.orderid=obj.id;
	
        	this.getprinterGoods(obj.id);
        },
        
        /** 获取打印的商品信息 **/
        getprinterGoods(id,sendtype) {
            if(id!='' && id!=null){
                var resource = this.$resource(this.GLOBAL.domain+"Order/index");
	            resource.query({act:'getPrintgoods',id:id,sendtype:sendtype,token:this.$cookies.get('token')}).then((res) => {
	                if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	            	    this.$message.error(res.data.Message);
	                }else{
	              	    this.create.goods=JSON.parse(Base64.decode(res.data.Data));
	              	    this.create.account=this.create.goods.cost;
	              	    this.create.total=this.create.goods.total;
	              	    this.create.derate=this.create.goods.cheap;	
	              	    
	              	    this.getClerkName(this.create.seller); //修改销售员名称
	              	    //重置操作人信息
	              	    var _this=this;
	              	    this.sysmanagers.forEach(function(item,i) {
	              	    	if(item.id==_this.create.sysmanager) _this.create.sysmanagername=item.truename;
	              	    });	              	    
	              	      
	              	    this.printerDialog=true;	            	  
	                }
	            }).catch((res) => {
	                this.$message.error(this.GLOBAL.errortext);
	            });
            }
        },
        
        
        /** 只出库不打印 **/
        createSave(orderid,agentid) {
            this.createsaveLoading=true;
			//发货函数分开处理，互不干扰，减小耦合
			if(agentid==0) this.create.act='savewarehouse'; //全部发货
			if(agentid > 0) this.create.act='czorderssend'; //宠赞商品发货
            this.create.orderid=orderid;
			this.create.agentid=agentid;

            var resource = this.$resource(this.url);
            resource.save(this.create).then((res) => {
                if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.createsaveLoading=false;
					this.sendloading=false;
	                this.$message.error(res.data.Message);
                }else{
              	    this.createsaveLoading=false;
              	    this.printerDialog=false;
					this.sendDialog=false;
					this.sendloading=false;
              	    this.searchorder(); //刷新订单列表
              	    this.create.isout=0; //关闭打印页面开关
	                this.$message.success("订单确认发货成功");
                }
            }).catch((res) => {
          	    this.createsaveLoading=false;
				this.sendloading=false;
                this.$message.error(this.GLOBAL.errortext);
            });
        },
        
        /** 出库并打印 **/
        printContent() {
	        this.createSave();
	        //设置打印完成后回调页面
    	    this.$cookies.set('returnurlids','2,12');
    	    //设置打印信息
	        var div_print=document.getElementById('printContent');
	        var newStr=div_print.innerHTML;
	        var oldStr=document.body.innerHTML;
	        document.body.innerHTML=newStr;
	        window.print();
	        document.body.innerHTML=oldStr;
	        location.reload();
        },        
        
        /** 只打印 **/
  	    onlyprint() {
  	    	//设置打印完成后回调页面
    	    this.$cookies.set('returnurlids','2,12');
    	    //设置打印信息
	        var div_print=document.getElementById('printContent');
	        var newStr=div_print.innerHTML;
	        var oldStr=document.body.innerHTML;
	        document.body.innerHTML=newStr;
	        window.print();
	        document.body.innerHTML=oldStr;
	        location.reload();
  	    },
  	    
  	    //取消订单
        cannelGoods(obj) {

			this.$confirm('温馨提示：该操作会将订单取消，并把已支付的金额原路退回给买家，是否继续 ?', '提示', { type: 'warning' }).then(() => {
        	    this.cannelorderid=obj.id;
				this.reason='';
				this.cannelDialog=true;

            }).catch(() => {
                
            });

        },
        
        //确认取消订单
        cannelSave() {
      	    this.cannelLoading=true;
      	    var resource = this.$resource(this.url);
            resource.save({ act:'cannelorder',id: this.cannelorderid,reason:this.reason,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
					this.cannelLoading=false;
                }else{
                	this.$message.success('取消订单成功!');
					this.cannelLoading=false;
		            this.cannelDialog=false;
		            this.searchorder();
                }
            }).catch((res) => {
                
            });
        },


		/** 获取订单发货方式 **/
		selectSend(obj) {
			this.sendorders=obj; //获取订单信息
			//查看订单的发货方式
			this.sendgoodsLoading=true;
      	    var resource = this.$resource(this.url);
            resource.save({ act:'getsends',id:obj.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
					this.sendgoodsLoading=false;
                }else{
                	this.sendtypelists=JSON.parse(Base64.decode(res.data.Data));
		            this.sendgoodsLoading=false;
					this.sendDialog=true;
                }
            }).catch((res) => {
                this.sendgoodsLoading=false;
            });
		},

		/** 发货检测 **/
		sendordergoods(numbers,agentid) {
			this.sendloading=true;
			//检测商品是否已发货
			var resource = this.$resource(this.url);
            resource.save({ act:'checkordersend',id:this.sendorders.id,type:numbers,agentid:agentid,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
					this.sendloading=false;
                }else{
					this.sendtype=numbers;
                	//全部发货
					if(numbers==0) this.createSave(this.sendorders.id,agentid);
					//宠赞商品发货
					if(numbers==1) this.createSave(this.sendorders.id,agentid);
					//京东商品发货
					if(numbers==2) this.sendjdgoods(this.sendorders);
                }
            }).catch((res) => {
                this.sendgoodsLoading=false;
				this.sendloading=false;
            });
		},

		//京东商品发货
		sendjdgoods(item) {
			var resource = this.$resource(this.url);
            resource.save({ act:'jdordersend',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
					this.sendloading=false;
                }else{
                	this.searchorder();
					this.sendDialog=false;
					this.sendloading=false;
                }
            }).catch((res) => {
                this.sendloading=false;
            });
		},

        
        /** 全部订单发货 **/
        sendGoods(obj,agentid) {             	
      	  	//选择职员信息
	      	this.localorder=obj;
	      	this.orderid=obj.id;
	      	this.create.orderid=obj.id;
	      	//获取客户名称
	      	this.getCustomerName(this.orderid);

			//获取销售员信息
	      	this.create.seller=this.defaultclerk.id;
	      	this.clerkName=this.defaultclerk.name;

	      	//联系人姓名
	      	this.create.contactname=obj.truename;
	      	//联系电话
	      	this.create.contactphone=obj.phone;
	      	//联系地址
	      	this.create.address=obj.address;
	      	//获取支付方式
	      	this.create.paytype=obj.paytype;
			
	      	//单据编号
	      	this.setDocuments();
	      	this.create.note=this.localorder.note;
      	  	        	  	  
      	  	this.orderid=obj.id;
      	  	this.selectclerkDialog=true;
        },
        
        /** 确认完成 **/
        finishGoods(obj) {
      	    this.$confirm('温馨提示：您是否确认该订单已完成 ?', '提示', { type: 'warning' }).then(() => {
        	    // 向请求服务端删除
                var resource = this.$resource(this.url);
                resource.save({ act:'finishorder',id:obj.id,token:this.$cookies.get('token')}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
			            this.searchorder();
	                    this.$message.success('确认订单成功!');
	                }
                }).catch((res) => {
            	    //this.$message.error(this.GLOBAL.errortext);
                });
            }).catch(() => {
                this.$message.info('已取消操作!');
            });
        },
        
        
        /** 获取顾客名称 **/
        getCustomerName(id){
            if(id!='' && id!=null){
                var resource = this.$resource(this.url);
	            resource.query({act:'getCustomerName',id:id,token:this.$cookies.get('token')}).then((res) => {
	                if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	            	    this.$message.error(res.data.Message);
	                }else{
	              	    var data=JSON.parse(Base64.decode(res.data.Data));
	              	    this.create.customer=data.id;
	                    this.customerName=data.name;
	                }
	            }).catch((res) => {
	                this.$message.error(this.GLOBAL.errortext);
	            });
            }
        },
        
        //获取销售员列表
        getClerk() {
      	    var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),p:1,rollpage:100000}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
	            }else{
		            this.clerks = JSON.parse(Base64.decode(res.data.Data));
		            //if(this.clerks!='') this.create.seller=this.clerks[0]['id'];
		            //if(this.clerks!='') this.clerkName=this.clerks[0]['name'];
	            }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
        },

		//获取默认销售员信息
		getdefaultclerk() {
			var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	        resource.query({act:'defaultclerks',type:'mallorder',token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
	            }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
					this.defaultclerk.id=result.id;
					this.defaultclerk.name=result.name;
	            }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
		},
        
        /** 获取销售员信息 **/
        getClerkName(id) {
      	    if(id!='' && id!=null){
                var resource = this.$resource(this.url);
	            resource.query({act:'getClerkName',id:id,token:this.$cookies.get('token')}).then((res) => {
	                if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	            	    this.$message.error(res.data.Message);
	                }else{
	              	    var data=JSON.parse(Base64.decode(res.data.Data));
	              	    this.create.seller=data.id;
	                    this.clerkName=data.name;
	                }
	            }).catch((res) => {
	                this.$message.error(this.GLOBAL.errortext);
	            });
            }
        },
        
        /** 获取经手人 **/
        getSysmanager() {
	        var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000000,p:1}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001')this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
		            this.create.sysmanager=this.$cookies.get('managerid');
		            this.create.sysmanagername=this.$cookies.get('truename');
		        }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
        },
        
        /** 出库单号 **/
        setDocuments(){
	        var resource = this.$resource(this.url);
	        resource.query({act:'getxsdocuments',token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
	            }else{
	                this.create.documents = JSON.parse(Base64.decode(res.data.Data));
	                this.documents=this.create.documents;
	            }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
	        });
        },
        
		/** 获取包裹信息展示 **/
	    getpacks(id) {
			this.packdialog=true;
			this.packdialogloading=true;
			this.packlists=[];
			var resource = this.$resource(this.url);
	        resource.query({act:'getpackdetail',token:this.$cookies.get('token'),orderid:id}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
					this.packdialogloading=false;
	            }else{
	                this.packlists = JSON.parse(Base64.decode(res.data.Data));
					this.packdialogloading=false;

	            }
	        }).catch((res) => {
	            this.$message.error(this.GLOBAL.errortext);
				this.packdialogloading=false;
	        });
		},

		/** 获取历史修改记录 **/
		getlogs(id) {
			this.updatelogdialog=true;
			this.editloading=true;
			var resource = this.$resource(this.url);
	        resource.query({act:'getupdatelogdetail',token:this.$cookies.get('token'),orderid:id}).then((res) => {
	            if(res.data.Result>0){
	                if(res.data.Result=='70001') this.$router.push('/login')
	                this.$message.error(res.data.Message);
					this.editloading=false;
	            }else{
	                this.loglists = JSON.parse(Base64.decode(res.data.Data));
					this.editloading=false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
				this.editloading=false;
	        });
		},

		/** 获取京东进货预存金额 **/
		getjdlastmoney() {
			var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
			resource.query({act:'getjdlastmoney',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.jdmoneys = JSON.parse(Base64.decode(res.data.Data));
					
					//预存款滚动效果
					var money=this.jdmoneys.money;
					this.jdmoneys.money=0;
					this.numFun(0,money);

				}
			}).catch((res) => {
				
			});
		},

		/** 获取推送人员信息列表 **/
		pushsetting() {
			this.pushDialog=true;
			this.pushLoading=true;
			this.getpushlists();
		},    

		/** 获取推送人员信息列表 **/
		getpushlists() {
			this.pushloading=true;
			var resource = this.$resource(this.url);		    
			resource.query({act:'getpushlists',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.pushloading=false;
				}else{
					this.pushlists = JSON.parse(Base64.decode(res.data.Data));
					this.pushloading=false;
				}
			}).catch((res) => {
				this.pushloading=false;
			});
		},


		/** 添加推送设置 **/
		addpush(type) {
			this.pushquery.type=type;
			this.pushquery.truename='';
			this.pushquery.contact='';
			this.addpushDialog=true;
		},

		/** 新增推送设置信息 **/
		addpushs() {
			var resource = this.$resource(this.url);		    
			resource.save(this.pushquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.addpushDialog=false;
					this.getpushlists();
				}
			}).catch((res) => {
				
			});
		},

		/** 删除推送设置信息 **/
		delpush(id) {
			var resource = this.$resource(this.url);		    
			resource.query({act:'delpush',id:id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getpushlists();
				}
			}).catch((res) => {
				
			});
		},


		/** 修改联系信息设置 **/
		changecontact(type,id,contact) {
			var resource = this.$resource(this.url);		    
			resource.save({act:'changepush',type:type,id:id,contact:contact,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.getpushlists();
				}else{
					this.getpushlists();
				}
			}).catch((res) => {
				this.getpushlists();
			});
		},


		/** 修改订单 **/
		editorder(item) {
			this.$emit('listenchild',{name:'修改订单信息',url:'Orderedit',data:{id:item.id}});
		},

		/** 修改线下支付订单的支付状态 **/
		checkchangePay(item) {
			var resource = this.$resource(this.url);		    
			resource.save({act:'checkchangepay',token:this.$cookies.get('token'),id:item.id}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.changepayDialog=true;
					var result = JSON.parse(Base64.decode(res.data.Data));

					this.changepayquery.id=result.id;
					this.changepayquery.desc='';
		            if(this.sellerLists!='') this.changepayquery.seller=this.sellerLists[0]['id'];
					this.changepayquery.amount=result.prices;
					this.changepayquery.account='';
				}
			}).catch((res) => {
				
			});
		},

		/** 确认保存订单支付状态 **/
		savepay() {
			var resource = this.$resource(this.url);		    
			resource.save(this.changepayquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.changepayDialog=false;
					this.searchorder();
				}
			}).catch((res) => {
				
			});
		},

		/** 展示活动信息 **/
		showactives(item) {
			this.activeDialog=true;
			this.showactivelists=item;
		},


		//导出订单信息
		sumTypeCkeck(type) {
			if(type==1) this.exportorderlists(); //导出销售订单列表
			if(type==2) this.exportorderdetail(); //导出销售订单详情
			if(type==3) this.exportdetailfromcw(); //导出销售订单详情（财务）
			if(type==4) {this.exportdatafromkingdeemodel();} //导出金蝶销售订单模板数据
			if(type==5) {this.downorderlogistics();} //导入订单快递信息
		},

		//导入订单快递信息
		downorderlogistics() {
			this.shippinginputDialog=true;
			this.shippinginputview=true;
		},




		//导出销售订单明细（财务）
		exportdetailfromcw() {
			if(this.query.date.length==0) {this.$message.error("请选择订单日期");exit;}

			var url=this.GLOBAL.exportUrl+'Order/index/';
			url+="act/exportdetailfromcw/";
			if(this.query.paytype > 0) url+="paytype/"+this.query.paytype+"/";
			if(this.query.ispay > 0) url+="ispay/"+this.query.ispay+'/';
			if(this.query.status!='') url+="status/"+this.query.status+'/';
			if(this.query.type > 0) url+="type/"+this.query.type+'/';
			url+="startdate/"+this.query.date[0]+'/';
			url+="enddate/"+this.query.date[1]+'/';
			if(this.query.key!='') url+='key/'+this.query.key+'/';
			if(this.query.clerkid > 0) url+='clerkid/'+this.query.clerkid+'/';
			url+='token/'+this.$cookies.get('token');
			location.href=url;
		},

		//导出金蝶销售单模板数据
		exportdatafromkingdeemodel() {
			var url=this.GLOBAL.exportUrl+'Order/index/';
			url+="act/exportkingdeeorders/";
			if(this.query.paytype > 0) url+="paytype/"+this.query.paytype+"/";
			if(this.query.ispay > 0) url+="ispay/"+this.query.ispay+'/';
			if(this.query.status!='') url+="status/"+this.query.status+'/';
			if(this.query.type > 0) url+="type/"+this.query.type+'/';
			if(this.query.date[0] && this.query.date[0]!='') url+="startdate/"+this.query.date[0]+'/';
			if(this.query.date[1] && this.query.date[1]!='') url+="enddate/"+this.query.date[1]+'/';
			if(this.query.key!='') url+='key/'+this.query.key+'/';
			if(this.query.clerkid > 0) url+='clerkid/'+this.query.clerkid+'/';
			url+='token/'+this.$cookies.get('token');
			location.href=url;
		},


		//导出销售订单列表
		exportorderlists() {
			this.outlistsputDialog=true;
			this.outlistsLoading=true;
			var resource = this.$resource(this.GLOBAL.exportUrl+'/Order/index');
			resource.query({act: 'exportorderlists',token: this.$cookies.get('token'),paytype:this.query.paytype,ispay:this.query.ispay,status:this.query.status,type:this.query.type,date:this.query.date,key:this.query.key}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.outlistsLoading=false;
				}else{
					this.outexportlists = JSON.parse(Base64.decode(res.data.Data));
					this.outlistsLoading=false;
				}
			}).catch((res) => {
				this.outlistsLoading=false;
			});
		},

		//导出销售订单详情列表信息
		exportorderdetail() {
			this.outdetailsputDialog=true;
			this.outdetailsLoading=true;
			var resource = this.$resource(this.GLOBAL.exportUrl+'/Order/index');
			resource.query({act: 'exportorderdetails',token: this.$cookies.get('token'),paytype:this.query.paytype,ispay:this.query.ispay,status:this.query.status,type:this.query.type,date:this.query.date,key:this.query.key}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.outdetailsLoading=false;
				}else{
					this.outexportdetails = JSON.parse(Base64.decode(res.data.Data));
					this.outdetailsLoading=false;
				}
			}).catch((res) => {
				this.outdetailsLoading=false;
			});
		},

		//导出销售订单列表
		sureoutput() {    
			this.exporthead=['订单编号','店铺名称','收货人姓名','收货电话','收货地址','是否支付','支付类型','订单金额','支付金额','下单时间','支付时间','订单状态','支付渠道','对账订单号','出库订单号'];
			this.exportfield=['ordernumber','shopname','truename','phone','address','ispay','paytype','oriprices','prices','inputtime','pay_time','status','paybank','pay_trade_no','senddesc'];
			this.exportlists=this.outexportlists;
			this.exportname='线上商城订单列表';
			this.exportput();
			this.outlistsputDialog=false;		
		},

		//导出销售订单详情信息
		suredetailoutput() {	
			this.exporthead=['订单编号','店铺名称','收货人姓名','收货人电话','默认地址','详细地址','sku','商品名称','规格','规格属性','价格','数量','采购成本','小计','所属订单实付金额','商品实付小计','零售价','商品类型','下单时间','支付时间','订单状态','订单来源','供应商订单编号'];
			this.exportfield=['ordernumber','shopname','truename','phone','defaultaddress','address','sku','productname','propertyname','spec','price','numbers','cost','total','orderreal','goodsreal','market','type','inputtime','pay_time','status','linetype','documents'];
			this.exportlists=this.outexportdetails;
			this.exportname='线上商城订单明细';
			this.exportput();
			this.outdetailsputDialog=false;	
		},


		/** 确认导出信息 **/
		exportput() {
			require.ensure([], () => {
				var { export_json_to_excel } = require('../../vendor/Export2Excel');
				var data = this.formatJson(this.exportfield, this.exportlists);
				export_json_to_excel(this.exporthead, data, this.exportname);
			})
		},
		
		//导出表格数据
		formatJson(filterVal, jsonData) {
	　　　　return jsonData.map(v => filterVal.map(j => v[j]));
	　　}, 


	    /** 编辑销售员信息 **/
		settingclerk(item) {
			this.settingclerkDialog=true;
			this.settingclerkorderid=item.id;
			this.settingclerkid=item.clerkid;
		},

		/** 保存销售员信息 **/
	    suresettingclerks() {
			this.settingclerkDialog=false;
			var resource = this.$resource(this.url);
			resource.query({act: 'saveorderclerk',token: this.$cookies.get('token'),orderid:this.settingclerkorderid,clerkid:this.settingclerkid}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.searchorder();
					this.settingclerkDialog=false;
				}
			}).catch((res) => {
				this.settingclerkDialog=false;
			});
		},

		/** 京东预存款数字滚动 **/
		numFun(startNum,maxNum) {
			var that = this
			let numText = startNum;
			let golb; // 为了清除requestAnimationFrame
			function numSlideFun(){ // 数字动画
				numText +=6000; // 速度的计算可以为小数 。数字越大，滚动越快
				if(numText >= maxNum){
					numText = maxNum;
					cancelAnimationFrame(golb);
				}else {
					golb = requestAnimationFrame(numSlideFun);
				}
				that.jdmoneys.money=numText;
			}
			numSlideFun(); // 调用数字动画
		},

		/** 获取店铺信息 **/
	    getshopinfos(id) {
			this.shopinfoDialog=true;
			var resource = this.$resource(this.url);
			resource.query({act: 'getshopinfos',token: this.$cookies.get('token'),shopid:id}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.shopinfos=JSON.parse(Base64.decode(res.data.Data));
					this.shopmap(this.shopinfos.latitude,this.shopinfos.longitude);
				}
			}).catch((res) => {
				
			});
		},

		/** 地图展示 **/
    	shopmap(lat,log) {
			this.mapLoading=true;
			let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
			this.zoom=15;
			var geolocation = new BMap.Geolocation();
			geolocation.getCurrentPosition(function(r){
				_this.center = {lng:log,lat:lat};   // 设置center属性值
				_this.autoLocationPoint = {lng:log, lat:lat};   // 自定义覆盖物
				_this.initLocation = true;     
				_this.mapLoading=false;     
			},{enableHighAccuracy: true})  	
    	},

		setsenddays() {
			this.daysDialog=true;
			this.setgetgoodsdata();
		},

		/** 修改自动收货时间 **/
	    setgetgoodsdata() {
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index",);
			resource.query({act:'getsenddays',token: this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result=JSON.parse(Base64.decode(res.data.Data));
					this.days=result.senddays;
					this.showdays=result.senddays;
				}
			}).catch((res) => {
				
			});
		},

		/** 保存修改的收货时间 **/
		savedays() {
			var resource = this.$resource(this.GLOBAL.domain+"Setting/index",);
			resource.query({act:'savesenddays',token: this.$cookies.get('token'),days:this.days}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.setgetgoodsdata();
					this.showdays=this.days;
					this.daysDialog=false;
				}
			}).catch((res) => {
				
			});
		},


		/** 查看改单退货支付信息 **/
		checkeditpays(item) {
			this.editorderpayDialog=true;
			this.editpays.total_fee=item.total_fee;
			this.editpays.status=item.status;
			this.editpays.payment_trade_status=item.payment_trade_status;
			this.editpays.isused=item.isused;
			this.editpays.subject=item.subject;
			this.editpays.out_trade_no=item.out_trade_no;
			this.editpays.payment_trade_no=item.payment_trade_no;
			this.editpays.payment_notify_time=item.payment_notify_time;
		},

		//获取所有快递物流信息
		getallshippinglists() {
			this.shipDialog=true;
			this.shiploading=true;
			var resource = this.$resource(this.url);
			resource.query({act:'getshippingfrombirld',token: this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.shiploading=false;
				}else{
					this.shippinglists=JSON.parse(Base64.decode(res.data.Data));
					this.shiploading=false;
				}
			}).catch((res) => {
				this.shiploading=false;
			});
		},



		/** 设置第三方快递物流信息 **/
		settingshipping(item) {
			this.settingshippingDialog=true;
			this.shippingquery.orderid=item.orderid;
			this.shippingquery.parentagentid=item.parentagentid;

			this.shippingquery.shippingid='';
			this.shippingquery.shippingname='';
			this.shippingquery.shippingcode='';
			this.shippingquery.logisticscode='';
			this.shippingquery.status='';
			this.shippingquery.senderid='';
			this.shippingquery.sendname='';
			this.shippingquery.sendphone='';
			this.shippingquery.sendProvincename='';
			this.shippingquery.sendCityname='';
			this.shippingquery.sendArea='';
			this.shippingquery.sendAddress='';
			this.shippingquery.recieverid='';
			this.shippingquery.recievename='';
			this.shippingquery.recievephone='';
			this.shippingquery.recieveProvincename='';
			this.shippingquery.recieveCityname='';
			this.shippingquery.recieveArea='';
			this.shippingquery.recieveAddress='';
			this.shippingquery.note='宠物用品';
			this.shippingquery.localtime='';
			this.shippingquery.OriginCode='';
			this.shippingquery.SortingCode='';
			this.shippingquery.PackageCode='';
			this.shippingquery.goods=[];

			this.getshippingdetails(item);
		},

		/** 获取发货信息 **/
		getshippingdetails(item) {
			this.localprintshipping=item;
			this.settingshippingloading=true;
			var resource = this.$resource(this.url);
			resource.query({act:'getshippinginfos',token: this.$cookies.get('token'),orderid:item.orderid,parentagentid:item.parentagentid}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.settingshippingloading=false;
				}else{
					var result=JSON.parse(Base64.decode(res.data.Data));
					this.shippingquery.shippingid=result.shippingid;
					this.shippingquery.shippingname=result.shippingname;
					this.shippingquery.shippingcode=result.shippingcode;
					this.shippingquery.logisticscode=result.logisticscode;
					this.shippingquery.status=result.status;
					this.shippingquery.senderid=result.senderid;
					this.shippingquery.sendname=result.sendname;
					this.shippingquery.sendphone=result.sendphone;
					this.shippingquery.sendProvincename=result.sendProvincename;
					this.shippingquery.sendCityname=result.sendCityname;
					this.shippingquery.sendArea=result.sendArea;
					this.shippingquery.sendAddress=result.sendAddress;
					this.shippingquery.recieverid=result.recieverid;
					this.shippingquery.recievename=result.recievename;
					this.shippingquery.recievephone=result.recievephone;
					this.shippingquery.recieveProvincename=result.recieveProvincename;
					this.shippingquery.recieveCityname=result.recieveCityname;
					this.shippingquery.recieveArea=result.recieveArea;
					this.shippingquery.recieveAddress=result.recieveAddress;
					this.shippingquery.note=result.note;
					this.shippingquery.goods=result.goods;
					this.shippingquery.localtime=result.localtime;
					this.shippingquery.OriginCode=result.OriginCode;
					this.shippingquery.SortingCode=result.SortingCode;
					this.shippingquery.PackageCode=result.PackageCode;
					this.settingshippingloading=false;
				}
			}).catch((res) => {
				this.settingshippingloading=false;
			});
		},

		//选择快递信息
		selectships(item) {
			this.shippingquery.shippingid=item.id;
			this.shippingquery.shippingname=item.shippingname;
			this.shippingquery.shippingcode=item.shippingcode;
			this.shipDialog=false;
		},

		//获取寄件人信息列表
		getsenderlists() {
			this.senderDialog=true;
			this.senderquery.key='';
			this.senderquery.loading=false;
			this.senderquery.ischange=false;
			this.senderquery.p=1;
			this.senderquery.rollpage=10;
			this.senderlists=[];
			this.senderrows=0;
			this.getsenderlistsdata();
		},

		//获取寄件人数据
		getsenderlistsdata() {
			this.senderquery.loading=true;
			if(this.senderquery.ischange) {
				this.senderquery.p=1;
				this.senderquery.rollpage=10;
			}

			var resource = this.$resource(this.url);
			resource.save(this.senderquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.senderquery.loading=false;
				}else{
					this.senderlists=JSON.parse(Base64.decode(res.data.Data));
					this.senderrows=parseInt(res.data.count);
					this.senderquery.loading=false;
					if(this.senderquery.ischange) this.senderquery.ischange=false;
				}
			}).catch((res) => {
				this.senderquery.loading=false;
			});
		},

		senderpageSizeChange(val) {
        	this.senderquery.rollpage = val;
        	this.getsenderlistsdata();
		},
		senderpageCurrentChange(val) {
			this.senderquery.p = val;
			this.getsenderlistsdata();
		},

		/** 新增寄件人信息 **/
		addsender() {
			this.addsenderDialog=true;
			this.addsenderquery.act="addsender";
			this.addsenderquery.id='';
			this.addsenderquery.name='';
			this.addsenderquery.phone='';
			this.addsenderquery.provinceid='';
			this.addsenderquery.cityid='';
			this.addsenderquery.areaid='';
			this.addsenderquery.address='';

			this.cityquery.parentid='';
			this.citylists=[];
			this.areaquery.parentid='';
			this.arealists=[];
			//获取京东省份信息
			this.getjdprovince();
		},

		/** 保存寄件人信息 **/
		saveaddsender() {
			var resource = this.$resource(this.url);
			resource.save(this.addsenderquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.addsenderDialog=false;
					this.getsenderlistsdata();
				}
			}).catch((res) => {
				
			});
		},


		/** 获取待编辑的寄件人信息 **/
		editsender(item) {
			this.addsenderDialog=true;
			this.addsenderquery.act="editsender";
			this.addsenderquery.id=item.id;
			this.addsenderquery.name=item.name;
			this.addsenderquery.phone=item.phone;
			this.addsenderquery.provinceid=item.provinceid;

			this.addsenderquery.cityid=item.cityid==0 ? item.areaid : item.cityid;
			this.addsenderquery.areaid=item.cityid==0 ? '' : item.areaid;
			this.addsenderquery.address=item.address;

			this.getjdprovince();
			this.cityquery.parentid=this.addsenderquery.provinceid;
			this.getjdcity();
			this.areaquery.parentid=this.addsenderquery.cityid;
			this.getjdarea();
		},

		/** 删除寄件人信息 **/
		delsender(item) {
			this.$confirm('您是否需要删除该寄件人信息？', { type: 'warning' }).then(() => {
				var resource = this.$resource(this.url);
				resource.query({act:'delsender',token:this.$cookies.get('token'),id:item.id}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.getsenderlistsdata();
					}
				}).catch((res) => {
					
				});
			}).catch(() => {
				
			});
		},

		/** 选择当前寄件人 **/
		getsender(item) {
			this.shippingquery.senderid=item.id;
			this.shippingquery.sendname=item.name;
			this.shippingquery.sendphone=item.phone;
			this.shippingquery.sendProvincename=item.province;
			this.shippingquery.sendCityname=item.city;
			this.shippingquery.sendArea=item.area;
			this.shippingquery.sendAddress=item.address;
			this.senderDialog=false;
		},




		//获取收件人信息列表
		getrecieverlists() {
			this.recieverDialog=true;
			this.recieverquery.key='';
			this.recieverquery.loading=false;
			this.recieverquery.ischange=false;
			this.recieverquery.p=1;
			this.recieverquery.rollpage=10;
			this.recieverlists=[];
			this.recieverrows=0;
			this.getrecieverlistsdata();
		},

		//获取收件人数据
		getrecieverlistsdata() {
			this.recieverquery.loading=true;
			if(this.recieverquery.ischange) {
				this.recieverquery.p=1;
				this.recieverquery.rollpage=10;
			}

			var resource = this.$resource(this.url);
			resource.save(this.recieverquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.recieverquery.loading=false;
				}else{
					this.recieverlists=JSON.parse(Base64.decode(res.data.Data));
					this.recieverrows=parseInt(res.data.count);
					this.recieverquery.loading=false;
					if(this.recieverquery.ischange) this.recieverquery.ischange=false;
				}
			}).catch((res) => {
				this.recieverquery.loading=false;
			});
		},

		recieverpageSizeChange(val) {
        	this.recieverquery.rollpage = val;
        	this.getrecieverlistsdata();
		},
		recieverpageCurrentChange(val) {
			this.recieverquery.p = val;
			this.getrecieverlistsdata();
		},

		/** 新增收件人信息 **/
		addreciever() {
			this.addrecieverDialog=true;
			this.addrecieverquery.act="addreciever";
			this.addrecieverquery.id='';
			this.addrecieverquery.name='';
			this.addrecieverquery.phone='';
			this.addrecieverquery.provinceid='';
			this.addrecieverquery.cityid='';
			this.addrecieverquery.areaid='';
			this.addrecieverquery.address='';

			this.cityquery.parentid='';
			this.citylists=[];
			this.areaquery.parentid='';
			this.arealists=[];
			//获取京东省份信息
			this.getjdprovince();
		},

		/** 保存收件人信息 **/
		saveaddreciever() {
			var resource = this.$resource(this.url);
			resource.save(this.addrecieverquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.addrecieverDialog=false;
					this.getrecieverlistsdata();
				}
			}).catch((res) => {
				
			});
		},


		/** 获取待编辑的收件人信息 **/
		editreciever(item) {
			this.addrecieverDialog=true;
			this.addrecieverquery.act="editreciever";
			this.addrecieverquery.id=item.id;
			this.addrecieverquery.name=item.name;
			this.addrecieverquery.phone=item.phone;
			this.addrecieverquery.provinceid=item.provinceid;

			this.addrecieverquery.cityid=item.cityid==0 ? item.areaid : item.cityid;
			this.addrecieverquery.areaid=item.cityid==0 ? '' : item.areaid;
			this.addrecieverquery.address=item.address;

			this.getjdprovince();
			this.cityquery.parentid=this.addrecieverquery.provinceid;
			this.getjdcity();
			this.areaquery.parentid=this.addrecieverquery.cityid;
			this.getjdarea();
		},

		/** 删除收件人信息 **/
		delreciever(item) {
			this.$confirm('您是否需要删除该收件人信息？', { type: 'warning' }).then(() => {
				var resource = this.$resource(this.url);
				resource.query({act:'delreciever',token:this.$cookies.get('token'),id:item.id}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.getrecieverlistsdata();
					}
				}).catch((res) => {
					
				});
			}).catch(() => {
				
			});
		},

		/** 选择当前收件人 **/
		getreciever(item) {
			this.shippingquery.recieverid=item.id;
			this.shippingquery.recievename=item.name;
			this.shippingquery.recievephone=item.phone
			this.shippingquery.recieveProvincename=item.province;
			this.shippingquery.recieveCityname=item.city;
			this.shippingquery.recieveArea=item.area;
			this.shippingquery.recieveAddress=item.address;
			this.recieverDialog=false;
		},




		/** 搜索京东省份信息 **/
		getjdprovince() {
			this.provincelists=[];
			var resource = this.$resource(this.url);
			resource.query(this.provincequery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.provincelists=JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				
			});
		},

		/** 搜索京东城市信息 **/
		getjdcity() {
			this.citylists=[];
			var resource = this.$resource(this.url);
			resource.query(this.cityquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.citylists=JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				
			});
		},

		/** 搜索京东区域 / 县信息 **/
		getjdarea() {
			this.arealists=[];
			var resource = this.$resource(this.url);
			resource.query(this.areaquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.arealists=JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				
			});
		},

		/** 切换省份 **/
		changeprovince(val) {
			this.addsenderquery.cityid='';
			this.addsenderquery.areaid='';
			this.addrecieverquery.cityid='';
			this.addrecieverquery.areaid='';

			if(val > 0) {
				this.cityquery.parentid=val;
				this.getjdcity();
				this.areaquery.parentid='';
				this.arealists=[];
			}else {
				this.cityquery.parentid='';
				this.citylists=[];
				this.areaquery.parentid='';
				this.arealists=[];
			}
		},

		/** 切换城市 **/
		changecity(val) {
			this.addsenderquery.areaid='';
			this.addrecieverquery.areaid='';
			if(val > 0) {
				this.areaquery.parentid=val;
				this.getjdarea();
			}else {
				this.areaquery.parentid='';
				this.arealists=[];
			}
		},


		//保存已设置的第三方商品快递信息
		saveshippinginfos() {
			var resource = this.$resource(this.url);
			resource.save(this.shippingquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					//this.settingshippingDialog=false;
					this.getpacks(this.shippingquery.orderid);
					//刷新打印面单信息
					this.getshippingdetails(this.localprintshipping);
					//发起打印
					this.pringshipping();
				}
			}).catch((res) => {
				
			});
		},


		//打印快递电子面单
		pringshipping() {
			let _this=this;
			this.shippingprintDialog=true;
			//条形码
			var JsBarcode = require('jsbarcode');
			//二维码
			var qrcode='';
			var content=this.shippingquery.logisticscode;

			setTimeout(function() {
				JsBarcode("#shippingbarcode", "shippingbarcode", {
					format: "CODE128",//选择要使用的条形码类型
					width:3,//设置条之间的宽度
					height:150,//高度
					displayValue:true,//是否在条形码下方显示文字
					text:''+content+'',//覆盖显示的文本
					fontOptions:"",//使文字加粗体或变斜体
					font:"fantasy",//设置文本的字体
					textAlign:"center",//设置文本的水平对齐方式
					textPosition:"bottom",//设置文本的垂直位置
					textMargin:5,//设置条形码和文本之间的间距
					fontSize:35,//设置文本的大小
					background:"#fff",//设置条形码的背景
					lineColor:"#333333",//设置条和文本的颜色。
					margin:5//设置条形码周围的空白边距
				});
				_this.$refs.ercodeinfos.innerHTML='';
				qrcode = new QRCode(_this.$refs.ercodeinfos, {
					text: ''+content+'', // 需要转换为二维码的内容
					width: 80,
					height: 80,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
        		});
			},500);
		},


		





		/** 打印当前页面 **/
	    printlocalpage() {
	    	//设置打印信息
	    	var div_print=document.getElementById('shippingprinttemp');
		    var newStr=div_print.innerHTML;
		    var oldStr=document.body.innerHTML;
		    document.body.innerHTML=newStr;
		    window.print();
		    document.body.innerHTML=oldStr;	    
		    location.reload();
	    },





		//同步金蝶数据
		synkingdee(id) {
			this.$confirm('警告：该操作将会将订单的商品信息以销售订单形式同步提交至金蝶，操作前请确认该订单是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
        	    var resource = this.$resource(this.url);
				resource.query({act:'syndatatokingdee',token:this.$cookies.get('token'),id:id}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.$message.success('订单数据提交到金蝶成功');      
					}
				}).catch((res) => {
					
				});

            }).catch(() => {
                
            });
		},

		//同步订单中的京东商品信息到金蝶
		jdsynkingdee(id) {
			this.$confirm('警告：该操作将会将订单中的京东商品信息以采购单形式同步提交至金蝶，操作前请确认该订单是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
        	    var resource = this.$resource(this.url);
				resource.query({act:'jdsyndatatokingdee',token:this.$cookies.get('token'),id:id}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.$message.success('订单数据提交到金蝶成功');      
					}
				}).catch((res) => {
					
				});

            }).catch(() => {
                
            });
		},


		//获取第三方商品发货快递信息
		getallshippinglogistics() {
			var resource = this.$resource(this.url);
			resource.query({act:'getallshippinglists',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.otherlogistics=JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
					
			});
		},


		//设置快递信息
		settingoldshipping(item) {
			this.getlogisticsDialog=true;
			this.setlogisticsquery.orderid=item.orderid;
			this.setlogisticsquery.parentagentid=item.parentagentid;
			var resource = this.$resource(this.url);
			resource.query({act:'getmallordershippings',orderid:item.orderid,parentagentid:item.parentagentid,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var data=JSON.parse(Base64.decode(res.data.Data));
					this.setlogisticsquery.shippingid=data.shippingid;
					this.setlogisticsquery.logistics=data.code;
				}
			}).catch((res) => {
					
			});
		},

		//第三方非宠赞系统设置快递单号
		noczwritelogistics(item) {
			//var data={orderid:item.id,parentagentid:item.agentid,};
			//this.settingoldshipping(data);

			this.showshippinginfosDialog=true;
			this.shippingorders=item;
			this.shippingorderid=item.id;
		},


		//更新快递信息
		submitshippings() {
			var resource = this.$resource(this.url);
			resource.query(this.setlogisticsquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getlogisticsDialog=false;
					if(datacenter=='cz') this.getpacks(this.setlogisticsquery.orderid); //以宠赞为数据中心的添加完成刷新包裹数据
					if(datacenter!='cz') this.searchorder(); //第三方非宠赞为数据中心的添加完成刷新订单列表
				}
			}).catch((res) => {
					
			});
		},


		//切换选择包裹物流单号信息
		checkpacklogistics(index,ii) {
			var logistics=this.packlists[index].shipping;
			logistics.forEach(function(e,i) {
				ii==i ? e.isactive=1 : e.isactive=0;
			});
		},


    },
   
}
</script>


<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.packstyle {float:left;margin-top:10px;background:#fff;border-radius:5px;padding:1rem 2% 1rem 2%;width:96%}
.packstyle li {padding:0 5% 1rem 0;float:left;width:100%;list-style-type:none}
.packstyle .icon {width:1.2rem;height:1.2rem;border-radius:50%;position:absolute;margin-left:-.65rem;margin-top:0}
.packstyle .icon img {width:100%;background:#fff}
.packstyle .time {float:left;margin-left:3%;margin-top:-.1rem;color:#303133;font-size:.7rem;line-height:1.5rem}
.packstyle .content {float:left;width:90%;margin-left:3%;color:#909399;font-size:.7rem;line-height:1.5rem}
.showtr {}
.noshowtr {background:#ddd}
.goodedits .el-input__inner {height:25px;line-height:25px;}
.goodedits .el-input__prefix, .goodedits .el-input__suffix {top:7px}

.cz-mall-order-addressinfo {display:inline-block;position:relative;width:100%;padding:10px 0 10px 1%;background:#fff;border-bottom:1px solid #ebeef5;font-size:12px;font-weight:500}
.cz-mall-order-reciever-name {margin-right:2%}
.cz-mall-order-reciever-phone {margin-right:2%}
.cz-mall-order-paytype {margin-right:2%;font-size:12px;}
.cz-mall-order-goods-infos {display:flex;align-items: center;justify-content: center;float:left;width:60px;height:60px;background:rgba(221,221,221,.4);border:1px solid #dddddd;border-radius:5px;overflow:hidden}
.cz-mall-order-goods-jd-icon {background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-style:normal;display:flex;justify-content:center;align-items:center;width:25px;height:25px;margin-top:-60px;margin-left:60px;font-size:12px}
.cz-mall-order-goods-name {float:left;width:100%;font-size:12px;line-height:21px;}
.cz-mall-order-goods-song {font-style:normal;font-size:12px;line-height:12px;color:#FFF;background:#F56C6C;border-radius:6px;padding:3px;position:absolute;top:0;right:0}
.cz-mall-order-goods-spec {float:left;width:100%;color:rgb(144, 147, 153);font-size:12px;line-height:1.3rem;}
.cz-mall-order-goods-brand {float:left;width:100%;color:rgb(144, 147, 153);font-size:12px;line-height:1.3rem}
.cz-mall-order-goods-active-detail {float:left;margin-left:2%;border:1px solid #f56c6c;color:#f56c6c;padding:2px 10px;font-size:12px;line-height:12px;margin-top:5px;background:#fef0f0;border-radius:15px}
.cz-mall-order-goods-active-news {float:left;margin-left:2%;border:1px solid #f56c6c;color:#f56c6c;padding:2px 10px;font-size:.7rem;margin-top:5px;background:#fef0f0;border-radius:15px}
.cz-mall-order-goods-active-change {float:left;margin-left:2%;border:1px solid #f56c6c;color:#f56c6c;padding:2px 10px;font-size:.7rem;margin-top:5px;background:#fef0f0;border-radius:15px}
.cz-mall-order-number {float:left;width:100%}
.cz-mall-order-sort {display:inline-block;font-size:.7rem;line-height:15px;font-style:normal;color:#fff;background:rgb(230, 162, 60);padding:.1rem .5rem;border-radius:15px;}
.cz-mall-order-yh {display:inline-block;text-decoration:none;font-size:.7rem;line-height:15px;font-style:normal;color:#fff;background:#409EFF;padding:.1rem .5rem;border-radius:15px;}
.cz-mall-order-edit {display:inline-block;text-decoration:none;font-size:.7rem;line-height:15px;font-style:normal;color:#fff;background:#F56C6C;padding:.1rem .5rem;border-radius:15px;}
.cz-mall-order-refund {display:inline-block;text-decoration:none;font-size:.7rem;line-height:15px;font-style:normal;color:#fff;background:#F56C6C;padding:.1rem .5rem;border-radius:15px;}
.cz-mall-order-pd {text-decoration:none;font-size:.7rem;font-style:normal;color:#fff;background:#67C23A;padding:.1rem .5rem;border-radius:15px;}
.cz-mall-order-pt {float:left;line-height:18px;text-decoration:none;font-size:.7rem;font-style:normal;color:#606266;padding:.1rem 0;border-radius:15px;}
.cz-mall-order-shop {float:left;width:100%;font-size:.7rem;color:rgb(144, 147, 153);cursor:pointer}
.cz-mall-order-seller {float:left;width:100%;font-size:.7rem;color:rgb(144, 147, 153)}
.cz-mall-order-inputtime {float:left;font-size:.8rem;line-height:1.2rem}
.cz-mall-order-status-pay {float:left;width:100%;font-size:12px;line-height:21px;text-align:center;}
.cz-mall-order-status-send {float:left;width:100%;font-size:13px;line-height:21px;text-align:center;}


/** 新增商品 **/
.showaddgoods {display:block;position:fixed;width:100%;height:100%;background:rgb(0,0,0,.6);top:0;left:0;z-index:10000}
.cover {position:absolute;width:100%;height:100%;background:rgb(0,0,0,.6);top:0;left:0;}
.addtempgoodsinside {position:absolute;width:100%;height:100%;background:#fff;border-radius:0 5px 5px 0;transition:all .3s;overflow:hidden}
.closeshowaddgoods {display:none;}
.selectgoods {float:left;width:57%;height:100%;overflow:hidden;font-size:.8rem;padding:.5rem 0 .5rem 1%;}
.salegoods {float:left;width:41%;height:50%;font-size:.8rem;padding:.5rem 0 .5rem 1%;overflow:hidden;font-size:.8rem;}
.giftgoods {float:left;width:41%;height:50%;font-size:.8rem;padding:.5rem 0 .5rem 1%;overflow:hidden;font-size:.8rem;}
.selectgoods .title {float:left;margin-top:0;}
.salegoods .title {float:left;margin-top:0;}
.giftgoods .title {float:left;margin-top:0;}
.showspec {text-decoration:none;border:1px dashed #fff;color:rgb(144, 147, 153);padding:.5rem;float:left;width:90%;font-size:.7rem;line-height:1.2rem}
.specon:hover {border:1px dashed rgb(221,221,221);background:#fff}

.selectgoods .temgoodslists {float:left;width:100%;height:90%;margin-top:.5rem;overflow-y:scroll;}
.salegoods .temgoodslists,.giftgoods .temgoodslists {float:left;width:100%;height:85%;margin-top:0;overflow-y:scroll;}
.selectgoods .temgoodslists::-webkit-scrollbar,.salegoods .temgoodslists::-webkit-scrollbar,.giftgoods .temgoodslists::-webkit-scrollbar {width:5px;height:5px;}
.selectgoods .temgoodslists::-webkit-scrollbar-thumb,.salegoods .temgoodslists::-webkit-scrollbar-thumb,.giftgoods .temgoodslists::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.selectgoods .temgoodslists::-webkit-scrollbar-track,.salegoods .temgoodslists::-webkit-scrollbar-track,.giftgoods .temgoodslists::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

/** 数量选择器 **/
.salegoods .el-input-number--small .el-input-number__decrease, .salegoods .el-input-number--small .el-input-number__increase,
.giftgoods .el-input-number--small .el-input-number__decrease, .giftgoods .el-input-number--small .el-input-number__increase {width:20px;}
.salegoods .el-input-number--small,.giftgoods .el-input-number--small {line-height:23px;width:75px;}
.salegoods .el-input--small .el-input__inner,.giftgoods .el-input--small .el-input__inner {height:25px;line-height:25px;padding-left:25px;padding-right:25px}
.ordertempgoods .el-input__inner {height:25px;line-height:25px;padding:0;text-align:center}
.ordertempgoods .el-input {width:60%}
.temelinputinner .el-input__inner {background-color:rgb(225,225,225,0);border:none;transition:all .3s;color:#666666;font-size:13px;font-weight:500}
.temelinputinner .el-input__inner:focus {background-color:rgb(255,255,255,1);border:1px solid #dcdfe6}
.showsetprice .el-input__inner {width:80%;height:25px;line-height:25px;text-align:right;padding:0 7px}
.tr {padding:0 7px}
.logs {float:left;width:100%;border-radius:5px;background:rgb(221,221,221,.2);border:1px solid rgb(221,221,221,.8);margin-bottom:2rem;padding:.5rem 0}
.logs .baseinfo {float:left;width:98%;margin-left:1%;padding:.5rem 0;font-size:.8rem;border-bottom:1px solid rgb(221,221,221,.6)}
.logs .edittype {float:left;color:#fff;background:#E6A23C;padding:.1rem .5rem;border-radius:15px;line-height:1.5rem;font-size:.7rem;margin-right:2%}
.logs .refundtype {float:left;color:#fff;background:#F56C6C;padding:.1rem .5rem;border-radius:15px;line-height:1.5rem;font-size:.7rem;margin-right:2%}
.logs .editman {float:left;}
.logs .edittime {float:left;margin-left:2%}
.logs .verifyman {float:left;margin-left:2%}
.logs .verifytime {float:left;margin-left:2%}
.logs .logtime {float:right}

.logs .old {float:left;width:98%;padding:1rem 1%;}
.logs .new {float:left;width:98%;padding:1rem 1%;}
.logs .title,.logs .title {float:left;width:100%;color:#606266;font-size:.8rem;line-height:1.2rem;padding:.5rem 0;}


/** 寄件人、发货人信息 **/
.sendandreciever {float:left;width:96%;padding:0 2%;}
.sendandreciever .shippingcodeinfos {float:left;width:100%;padding:10px 0;border-bottom:1px solid #999999}
.sendandreciever .shippingcodeinfos .shippingde {float:left;font-size:13px;margin-right:8%}
.sendandreciever .shippingcodeinfos .red {color:#F56C6C}
.sendandreciever .shippingcodeinfos .green {color:#67C23A}
.sendandrecieverdetails {float:left;width:100%;border-bottom:1px solid #999999}
.senderinfos {float:left;width:46%;padding:10px 3% 10px 0;border-right:1px solid #999999}
.senderinfos .sendtitle {float:left;width:100%;font-size:13px;font-weight:bold;padding:5px 0}
.senderinfos .sendcontent {float:left;width:100%;font-size:13px;padding:5px 0;line-height:23px}
.recieverinfos {float:left;width:45%;padding:10px 0 10px 4%}
.recieverinfos .recivertitle {float:left;width:100%;font-size:13px;font-weight:bold;padding:5px 0}
.recieverinfos .recivercontent {float:left;width:100%;font-size:13px;padding:5px 0;line-height:23px}
.sendgoods {float:left;width:96%;margin-top:10px;margin-bottom:30px;padding:5px 2%;border-radius:5px;border:1px solid #dddddd;background:#dddddd}
.sendgoods .sendgoodstitle {float:left;width:100%;padding:5px 0;font-size:13px;font-weight:bold}
.sendgoods .sendgoodslists {float:left;width:100%;padding:10px 0;}

.sendgoods .sendgoodslists .sendgis {float:left;width:100%}
.sendgis img {float:left;width:50px;border:1px solid #999999;border-radius:5px;margin-right:5px}
.sendgoods .sendgoodslists .sendgoodsname {float:left;width:40%;font-size:13px;line-height:13px}
.sendgoodsname i {font-style:normal;font-size:12px;background:red;color:#fff;padding:1px 3px 2px 3px;border-radius:5px;margin-left:5px}
.sendgoods .sendgoodslists .sendgoodsnum {float:left;width:30%;text-align:center;font-size:13px;line-height:13px}
.sendgoods .sendgoodslists .sendgoodspec {float:left;width:60%;color:#666666;font-size:12px;line-height:13px;margin-top:10px}

/** 打印电子面单模板 **/
.shippingprinttemp {width:320px;height:563px;padding:10px;margin:0 auto;overflow:hidden;border:1px solid #dddddd}
.printtime {width:100%;color:#333;padding-bottom:5px;border-bottom:1px solid #333333;font-size:13px;float:left}
.codeout {width:100%;float:left;}
.sourse {float:left;width:100%;padding:10px 0;border-top:1px solid #333333}
.sourse .sourse-left {float:left;font-size:23px;font-weight:bold;line-height:23px}
.sourse .sourse-right {float:left;font-size:16px;margin-left:5px;line-height:16px}
.shippingsender {float:left;width:100%;padding:15px 0;border-top:1px solid #333333;border-bottom:1px solid #333333}
.shippingsender .senderlogo {float:left;color:#fff;background:#333333;-webkit-print-color-adjust: exact;padding:5px;font-size:23px;line-height:23px}
.shippingsender .senderright {float:left;width:220px;margin-left:10px;}
.shippingsender .senderright .sendername {float:left;font-size:15px;line-height:15px}
.shippingsender .senderright .senderphone {float:left;margin-left:30px;font-size:15px;line-height:15px}
.shippingsender .senderright .senderaddress {float:left;width:100%;font-size:13px;line-height:18px;margin-top:5px}
.shippingreciever {float:left;width:100%;border-bottom:1px solid #333333}
.shippingreciever .recieverleft {float:left;width:33%;height:90px;border-right:1px solid #333333}
.shippingreciever .recieverleft .recieverlogo {float:left;color:#fff;background:#333333;-webkit-print-color-adjust: exact;padding:5px;font-size:23px;line-height:23px;margin-top:5px}
.shippingreciever .recieverleft .recievername {float:left;width:100%;font-size:14px;line-height:14px;text-align:left;margin-top:5px}
.shippingreciever .recieverleft .recieverphone {float:left;width:100%;font-size:14px;line-height:14px;text-align:left;margin-top:5px}
.shippingreciever .recievercenter {float:left;width:33%;height:90px;border-right:1px solid #333333}
.shippingreciever .recievercenter .ercode {float:left;width:70px;height:70px;margin:5px 0 0 12px;}
.shippingreciever .recieverright {float:left;width:32%;height:90px;}
.recieverright .recieverrighttop {float:left;width:100%;border-bottom:1px solid #333333}
.recieverright .recieverrighttop span {float:left;width:100%;text-align:center;padding:3px 0;font-size:14px;line-height:14px}
.recieverright .recieverrightbottom {float:left;width:100%;}
.recieverright .recieverrightbottom span {float:left;width:100%;text-align:center;padding:5px 0;font-size:15px;line-height:15px;font-weight:bold}
@page {size: auto;margin: 0mm;}
.mall-order-info-goods-thumb {float:left;border-radius:5px;max-width:100%;max-height:100%}

.cz-mall-order-haveshippings {display:inline-block;width:20px;height:20px;margin-top:5px;cursor:pointer;}
.cz-mall-order-haveshippings img {max-width:20px;max-height:20px;}

.cz-mall-order-verifys-infos {display:flex;justify-content:left;align-items:center;margin-top:10px;width:calc(100% - 2px - 40px);padding:10px 20px;border-radius:6px;border:1px solid #fde2e2;background:#fef0f0;}
.cz-mall-order-verifys-infos i {width:15px;height:15px;background:url(../../assets/gantanhao.png) no-repeat;background-size:15px 15px;background-position:center center;margin-right:10px;}
.cz-mall-order-verifys-infos span {color:#f56c6c;font-size:12px;line-height:12px;}

.buhuo {
	padding: 0px 7px;
    background-color: #e60c0c;
    color: #FFF;
    border-radius: 26px;
    margin-left: 10px;
}
.buhuo-greey {
	background-color: #67c23a !important;
}
.q-label {
	margin-left: 20px;
	color: red;
}
.q-num {
	position: relative;
    top: 1px;
    font-style: normal;
}
.pcqd {
	width: 30px;
    height: 18px;
    margin-left: 7px;
    background: #fede00;
    border-radius: 9px;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
    color: #bb5c24;
}
</style>



// WEBPACK FOOTER //
// src/components/mall/Order.vue